<template>
  <div class="main-content">
    <!-- Header -->
    <div class="row mb-2">
      <div class="col-md-12">
        <div class="d-flex align-items-center">
          <feather-icon icon="BookIcon" size="22" class="mr-1 text-primary" />
          <div>
            <h4 class="mb-0">
              {{ discipline.name || $t('nodeDisciplineConfig.header.disciplineFallback') }}
              <small class="text-muted font-weight-normal">
                — {{ $t('nodeDisciplineConfig.header.configFor') }}
                <feather-icon icon="GitBranchIcon" size="14" />
                {{ node.name || $t('nodeDisciplineConfig.header.nodeFallback') }}
              </small>
            </h4>
            <small
              v-if="
                discipline.description &&
                discipline.description !== discipline.name
              "
              class="text-muted"
              >{{ discipline.description }}</small
            >
          </div>
          <div class="ml-auto">
            <b-button size="sm" variant="outline-secondary" @click="goBack">
              <feather-icon icon="ArrowLeftIcon" size="14" class="mr-50" />
              {{ $t('common.back') }}
            </b-button>
          </div>
        </div>
        <hr />
      </div>
    </div>

    <!-- Abas de configuração da disciplina -->
    <b-tabs content-class="mt-2" nav-class="dc-tabs-nav">
      <!-- ─── POSIÇÕES  ─────────────────────────────────────────── -->
      <b-tab :title="$t('nodeDisciplineConfig.tabs.positions')" active>
        <div class="row">
          <!-- Formulário de cadastro -->
          <div class="col-md-4">
            <div class="card">
              <div class="card-header">
                <span class="card-title mb-0">
                  {{ editingPosition.id ? $t('nodeDisciplineConfig.positions.formTitleEdit') : $t('nodeDisciplineConfig.positions.formTitleNew') }}
                </span>
              </div>
              <div class="card-body">
                <div class="form-group">
                  <label><span class="required">*</span> {{ $t('nodeDisciplineConfig.fields.code') }}</label>
                  <input
                    v-model="editingPosition.code"
                    type="text"
                    class="form-control"
                    :placeholder="$t('nodeDisciplineConfig.positions.codePlaceholder')"
                    maxlength="20"
                  />
                </div>
                <div class="form-group">
                  <label><span class="required">*</span> {{ $t('nodeDisciplineConfig.fields.name') }}</label>
                  <input
                    v-model="editingPosition.name"
                    type="text"
                    class="form-control"
                    :placeholder="$t('nodeDisciplineConfig.positions.namePlaceholder')"
                    maxlength="120"
                  />
                </div>
                <div class="form-group">
                  <label>{{ $t('nodeDisciplineConfig.fields.description') }}</label>
                  <textarea
                    v-model="editingPosition.description"
                    class="form-control"
                    rows="2"
                    :placeholder="$t('nodeDisciplineConfig.fields.descriptionPlaceholder')"
                  />
                </div>
                <div class="form-row">
                  <div class="form-group col-md-5">
                    <label>{{ $t('nodeDisciplineConfig.fields.order') }}</label>
                    <input
                      v-model="editingPosition.order"
                      type="number"
                      class="form-control"
                      min="0"
                    />
                  </div>
                  <div class="form-group col-md-7">
                    <label>{{ $t('nodeDisciplineConfig.fields.status') }}</label>
                    <select
                      v-model="editingPosition.status"
                      class="form-control"
                    >
                      <option :value="1">{{ $t('common.active') }}</option>
                      <option :value="0">{{ $t('common.inactive') }}</option>
                    </select>
                  </div>
                  <div class="form-group col-md-12">
                    <label>{{ $t('nodeDisciplineConfig.positions.scopeLabel') }}</label>
                    <select
                      v-model="editingPosition.scope"
                      class="form-control"
                    >
                      <option value="ocorrencia">
                        {{ $t('nodeDisciplineConfig.positions.scopeOccurrenceOption') }}
                      </option>
                      <option value="veiculo">
                        {{ $t('nodeDisciplineConfig.positions.scopeVehicleOption') }}
                      </option>
                    </select>
                    <small class="text-muted">
                      {{ $t('nodeDisciplineConfig.positions.scopeHint') }}
                    </small>
                  </div>
                </div>

                <div class="form-group">
                  <b-form-checkbox v-model="editingPosition.free_access" switch>
                    {{ $t('nodeDisciplineConfig.positions.freeAccessLabel') }}
                    <small class="text-muted d-block">
                      {{ $t('nodeDisciplineConfig.positions.freeAccessHint') }}
                    </small>
                  </b-form-checkbox>
                </div>
                <div class="form-group">
                  <b-form-checkbox
                    v-model="editingPosition.display_kanban"
                    switch
                  >
                    {{ $t('nodeDisciplineConfig.positions.displayKanbanLabel') }}
                  </b-form-checkbox>
                </div>
                <div class="form-group">
                  <b-form-checkbox
                    v-model="editingPosition.allows_dispatch"
                    switch
                  >
                    {{ $t('nodeDisciplineConfig.positions.allowsDispatchLabel') }}
                    <small class="text-muted d-block">
                      {{ $t('nodeDisciplineConfig.positions.allowsDispatchHint') }}
                    </small>
                  </b-form-checkbox>
                </div>
                <div class="form-group">
                  <b-form-checkbox
                    v-model="editingPosition.is_default_position"
                    switch
                  >
                    {{ $t('nodeDisciplineConfig.positions.isDefaultLabel') }}
                    <small class="text-muted d-block">
                      {{ $t('nodeDisciplineConfig.positions.isDefaultHint') }}
                    </small>
                  </b-form-checkbox>
                </div>
                <div class="form-group">
                  <b-form-checkbox
                    v-model="editingPosition.releases_occurrence"
                    switch
                  >
                    {{ $t('nodeDisciplineConfig.positions.releasesOccurrenceLabel') }}
                    <small class="text-muted d-block">
                      {{ $t('nodeDisciplineConfig.positions.releasesOccurrenceHint') }}
                    </small>
                  </b-form-checkbox>
                </div>
                <div class="form-group">
                  <b-form-checkbox
                    v-model="editingPosition.marks_arrival"
                    switch
                  >
                    {{ $t('nodeDisciplineConfig.positions.marksArrivalLabel') }}
                    <small class="text-muted d-block">
                      {{ $t('nodeDisciplineConfig.positions.marksArrivalHint') }}
                    </small>
                  </b-form-checkbox>
                </div>
                <div class="form-group">
                  <b-form-checkbox
                    v-model="editingPosition.has_patient"
                    switch
                  >
                    {{ $t('nodeDisciplineConfig.positions.hasPatientLabel') }}
                    <small class="text-muted d-block">
                      {{ $t('nodeDisciplineConfig.positions.hasPatientHint') }}
                    </small>
                  </b-form-checkbox>
                </div>
                <div class="form-group">
                  <b-form-checkbox
                    v-model="editingPosition.allows_redirect"
                    switch
                  >
                    {{ $t('nodeDisciplineConfig.positions.allowsRedirectLabel') }}
                    <small class="text-muted d-block">
                      {{ $t('nodeDisciplineConfig.positions.allowsRedirectHint') }}
                    </small>
                  </b-form-checkbox>
                </div>
                <div class="form-group">
                  <b-form-checkbox
                    v-model="editingPosition.marks_base_arrival"
                    switch
                  >
                    {{ $t('nodeDisciplineConfig.positions.marksBaseArrivalLabel') }}
                    <small class="text-muted d-block">
                      {{ $t('nodeDisciplineConfig.positions.marksBaseArrivalHint') }}
                    </small>
                  </b-form-checkbox>
                </div>
                <div class="form-group">
                  <b-form-checkbox
                    v-model="editingPosition.allows_unboarding"
                    switch
                  >
                    {{ $t('nodeDisciplineConfig.positions.allowsUnboardingLabel') }}
                    <small class="text-muted d-block">
                      {{ $t('nodeDisciplineConfig.positions.allowsUnboardingHint') }}
                    </small>
                  </b-form-checkbox>
                </div>
                <div class="form-group">
                  <b-form-checkbox
                    v-model="editingPosition.show_in_occurrence"
                    switch
                  >
                    {{ $t('nodeDisciplineConfig.positions.showInOccurrenceLabel') }}
                    <small class="text-muted d-block">
                      {{ $t('nodeDisciplineConfig.positions.showInOccurrenceHint') }}
                    </small>
                  </b-form-checkbox>
                </div>
                <div class="form-group">
                  <b-form-checkbox
                    v-model="editingPosition.display_panel"
                    switch
                  >
                    {{ $t('nodeDisciplineConfig.positions.displayPanelLabel') }}
                    <small class="text-muted d-block">
                      {{ $t('nodeDisciplineConfig.positions.displayPanelHint') }}
                    </small>
                  </b-form-checkbox>
                  <div
                    v-if="editingPosition.display_panel"
                    class="panel-color-picker mt-1"
                  >
                    <label
                      class="panel-color-swatch"
                      :style="{ backgroundColor: editingPosition.panel_color }"
                    >
                      <input
                        v-model="editingPosition.panel_color"
                        type="color"
                      />
                    </label>
                    <div>
                      <span class="d-block font-weight-bold" style="font-size: 0.8rem">
                        {{ $t('nodeDisciplineConfig.positions.panelColorLabel') }}
                      </span>
                      <small class="text-muted">{{ editingPosition.panel_color }}</small>
                    </div>
                  </div>
                </div>

                <div class="d-flex">
                  <b-button
                    variant="primary"
                    class="mr-1"
                    v-if="$hasAbility('node.admin')"
                    @click="savePosition"
                  >
                    <feather-icon icon="SaveIcon" size="14" class="mr-50" />
                    {{ editingPosition.id ? $t('nodeDisciplineConfig.actions.update') : $t('common.add') }}
                  </b-button>
                  <b-button
                    v-if="editingPosition.id"
                    variant="outline-secondary"
                    @click="cancelEdit"
                  >
                    {{ $t('common.cancel') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>

          <!-- Lista de posições -->
          <div class="col-md-8">
            <div class="card">
              <div
                class="card-header d-flex align-items-center justify-content-between"
              >
                <span class="card-title mb-0">{{ $t('nodeDisciplineConfig.positions.listTitle') }}</span>
                <small class="text-muted"
                  >{{ $t('nodeDisciplineConfig.positions.count', { count: positions.length }) }}</small
                >
              </div>
              <div class="card-body p-0">
                <div v-if="loadingPositions" class="text-center py-4">
                  <b-spinner variant="primary" />
                </div>
                <div
                  v-else-if="!positions.length"
                  class="text-center text-muted py-4"
                >
                  {{ $t('nodeDisciplineConfig.positions.emptyState') }}
                </div>
                <table v-else class="table table-hover mb-0">
                  <thead>
                    <tr>
                      <th style="width: 36px" />
                      <th style="width: 60px">{{ $t('nodeDisciplineConfig.fields.orderHeader') }}</th>
                      <th style="width: 80px">{{ $t('nodeDisciplineConfig.fields.codeHeader') }}</th>
                      <th>{{ $t('nodeDisciplineConfig.tableHeaders.name') }}</th>
                      <th style="width: 150px">{{ $t('nodeDisciplineConfig.tableHeaders.node') }}</th>
                      <th style="width: 110px">{{ $t('nodeDisciplineConfig.positions.table.scope') }}</th>
                      <th>{{ $t('nodeDisciplineConfig.positions.table.predecessors') }}</th>
                      <th style="width: 90px">{{ $t('nodeDisciplineConfig.positions.table.free') }}</th>
                      <th style="width: 80px">{{ $t('nodeDisciplineConfig.positions.table.dispatch') }}</th>
                      <th style="width: 70px">{{ $t('nodeDisciplineConfig.positions.table.default') }}</th>
                      <th style="width: 80px">{{ $t('nodeDisciplineConfig.positions.table.releasesOccurrence') }}</th>
                      <th style="width: 80px">{{ $t('nodeDisciplineConfig.positions.table.marksArrival') }}</th>
                      <th style="width: 80px">{{ $t('nodeDisciplineConfig.positions.table.hasPatient') }}</th>
                      <th style="width: 80px">{{ $t('nodeDisciplineConfig.positions.table.allowsRedirect') }}</th>
                      <th style="width: 80px">{{ $t('nodeDisciplineConfig.positions.table.marksBaseArrival') }}</th>
                      <th style="width: 80px">{{ $t('nodeDisciplineConfig.positions.table.allowsUnboarding') }}</th>
                      <th style="width: 80px">{{ $t('nodeDisciplineConfig.positions.table.showInOccurrence') }}</th>
                      <th style="width: 80px">{{ $t('nodeDisciplineConfig.positions.table.displayPanel') }}</th>
                      <th style="width: 80px">{{ $t('common.status') }}</th>
                      <th style="width: 100px">{{ $t('common.actions') }}</th>
                    </tr>
                  </thead>
                  <draggable
                    v-model="orderedPositions"
                    tag="tbody"
                    handle=".drag-handle"
                    ghost-class="drag-ghost"
                    :disabled="!$hasAbility('node.admin')"
                    @end="onDragEnd"
                  >
                    <tr
                      v-for="pos in orderedPositions"
                      :key="pos.id"
                      :class="{ 'table-active': editingPosition.id === pos.id }"
                    >
                      <td
                        class="align-middle text-center drag-handle"
                        style="cursor: grab"
                      >
                        <feather-icon
                          icon="MenuIcon"
                          size="14"
                          class="text-muted"
                        />
                      </td>
                      <td class="align-middle text-center">
                        <span class="text-muted">{{ pos.order }}</span>
                      </td>
                      <td class="align-middle">
                        <b-badge variant="primary">
                          {{ pos.code }}
                        </b-badge>
                      </td>
                      <td class="align-middle">
                        <span class="font-weight-bold">{{ pos.name }}</span>
                        <br />
                        <small class="text-muted">{{ pos.description }}</small>
                      </td>
                      <td class="align-middle">
                        <span
                          v-if="pos.node"
                          class="small"
                          :class="daPropriaNo(pos) ? '' : 'text-muted'"
                          :title="textoDaOrigem(pos)"
                        >
                          {{ pos.node.name }}
                          <feather-icon
                            v-if="origemDaPosicao(pos) === 'inherited'"
                            icon="CornerRightDownIcon"
                            size="12"
                          />
                          <feather-icon
                            v-else-if="origemDaPosicao(pos) === 'descendant'"
                            icon="CornerRightUpIcon"
                            size="12"
                          />
                        </span>
                        <span v-else class="text-muted small">&mdash;</span>
                      </td>
                      <td class="align-middle">
                        <b-badge
                          :variant="
                            pos.scope === 'veiculo'
                              ? 'light-warning'
                              : 'light-info'
                          "
                        >
                          {{
                            pos.scope === "veiculo" ? $t('nodeDisciplineConfig.positions.scopeVehicleBadge') : $t('nodeDisciplineConfig.positions.scopeOccurrenceBadge')
                          }}
                        </b-badge>
                      </td>
                      <td class="align-middle">
                        <span v-if="pos.free_access" class="text-success small">
                          <feather-icon
                            icon="UnlockIcon"
                            size="12"
                            class="mr-25"
                          />
                          {{ $t('nodeDisciplineConfig.positions.freeAccessLabel') }}
                        </span>
                        <template
                          v-else-if="
                            pos.predecessors && pos.predecessors.length
                          "
                        >
                          <b-badge
                            v-for="pred in pos.predecessors"
                            :key="pred.id"
                            variant="light-warning"
                            class="mr-25 mb-25"
                          >
                            {{ pred.code }}
                          </b-badge>
                        </template>
                        <span v-else class="text-muted small">—</span>
                        <!-- Botão configurar predecessores -->
                        <b-button
                          v-if="!pos.free_access && $hasAbility('node.admin')"
                          size="sm"
                          variant="flat-secondary"
                          class="p-0 ml-1"
                          :title="$t('nodeDisciplineConfig.positions.configurePredecessorsTitle')"
                          @click="openPredecessors(pos)"
                        >
                          <feather-icon icon="GitMergeIcon" size="13" />
                        </b-button>
                      </td>
                      <td class="align-middle text-center">
                        <b-form-checkbox
                          :checked="pos.free_access"
                          switch
                          size="sm"
                          :disabled="!$hasAbility('node.admin')"
                          @change="toggleFreeAccess(pos)"
                        />
                      </td>
                      <td class="align-middle text-center">
                        <b-form-checkbox
                          :checked="pos.allows_dispatch"
                          switch
                          size="sm"
                          :disabled="!$hasAbility('node.admin')"
                          @change="toggleAllowsDispatch(pos)"
                        />
                      </td>
                      <td class="align-middle text-center">
                        <feather-icon
                          v-if="pos.is_default_position"
                          icon="StarIcon"
                          size="15"
                          class="text-warning"
                          :title="$t('nodeDisciplineConfig.positions.isDefaultLabel')"
                        />
                        <span v-else class="text-muted">—</span>
                      </td>
                      <td class="align-middle text-center">
                        <b-form-checkbox
                          :checked="pos.releases_occurrence"
                          switch
                          size="sm"
                          :disabled="!$hasAbility('node.admin')"
                          @change="toggleReleasesOccurrence(pos)"
                        />
                      </td>
                      <td class="align-middle text-center">
                        <b-form-checkbox
                          :checked="pos.marks_arrival"
                          switch
                          size="sm"
                          :disabled="!$hasAbility('node.admin')"
                          @change="toggleMarksArrival(pos)"
                        />
                      </td>
                      <td class="align-middle text-center">
                        <b-form-checkbox
                          :checked="pos.has_patient"
                          switch
                          size="sm"
                          :disabled="!$hasAbility('node.admin')"
                          @change="toggleHasPatient(pos)"
                        />
                      </td>
                      <td class="align-middle text-center">
                        <b-form-checkbox
                          :checked="pos.allows_redirect"
                          switch
                          size="sm"
                          :disabled="!$hasAbility('node.admin')"
                          @change="toggleAllowsRedirect(pos)"
                        />
                      </td>
                      <td class="align-middle text-center">
                        <b-form-checkbox
                          :checked="pos.marks_base_arrival"
                          switch
                          size="sm"
                          :disabled="!$hasAbility('node.admin')"
                          @change="toggleMarksBaseArrival(pos)"
                        />
                      </td>
                      <td class="align-middle text-center">
                        <b-form-checkbox
                          :checked="pos.allows_unboarding"
                          switch
                          size="sm"
                          :disabled="!$hasAbility('node.admin')"
                          @change="toggleAllowsUnboarding(pos)"
                        />
                      </td>
                      <td class="align-middle text-center">
                        <b-form-checkbox
                          :checked="pos.show_in_occurrence"
                          switch
                          size="sm"
                          :disabled="!$hasAbility('node.admin')"
                          @change="toggleShowInOccurrence(pos)"
                        />
                      </td>
                      <td class="align-middle">
                        <div class="d-flex align-items-center justify-content-center" style="gap: 8px">
                          <b-form-checkbox
                            :checked="pos.display_panel"
                            switch
                            size="sm"
                            :disabled="!$hasAbility('node.admin')"
                            @change="toggleDisplayPanel(pos)"
                          />
                          <span
                            v-if="pos.display_panel && pos.panel_color"
                            class="panel-color-chip"
                            :style="{ backgroundColor: pos.panel_color }"
                            :title="pos.panel_color"
                          />
                        </div>
                      </td>
                      <td class="align-middle">
                        <b-badge
                          :variant="pos.status ? 'success' : 'secondary'"
                        >
                          {{ pos.status ? $t('common.active') : $t('common.inactive') }}
                        </b-badge>
                      </td>
                      <td class="align-middle">
                        <b-button
                          size="sm"
                          variant="outline-primary"
                          class="mr-50"
                          :disabled="!daPropriaNo(pos)"
                          :title="
                            daPropriaNo(pos) ? $t('common.edit') : textoDaOrigem(pos)
                          "
                          @click="editPosition(pos)"
                        >
                          <feather-icon icon="EditIcon" size="13" />
                        </b-button>
                        <b-button
                          v-if="$hasAbility('node.admin')"
                          size="sm"
                          variant="outline-danger"
                          :disabled="!daPropriaNo(pos)"
                          :title="
                            daPropriaNo(pos) ? $t('common.delete') : textoDaOrigem(pos)
                          "
                          @click="deletePosition(pos)"
                        >
                          <feather-icon icon="TrashIcon" size="13" />
                        </b-button>
                      </td>
                    </tr>
                  </draggable>
                </table>
              </div>
            </div>
          </div>
        </div>
      </b-tab>

      <!-- ─── TIPOS E MOTIVOS ──────────────────────────────────────────── -->
      <b-tab :title="$t('nodeDisciplineConfig.tabs.typesAndReasons')">
        <!-- == TIPOS == -->
        <h6 class="mb-1 text-primary">
          <feather-icon icon="TagIcon" size="15" class="mr-50" />
          {{ $t('nodeDisciplineConfig.types.sectionTitle') }}
        </h6>
        <div class="row">
          <!-- Formulário de tipo -->
          <div class="col-md-4">
            <div class="card">
              <div class="card-header">
                <span class="card-title mb-0">
                  {{ editingType.id ? $t('nodeDisciplineConfig.types.formTitleEdit') : $t('nodeDisciplineConfig.types.formTitleNew') }}
                </span>
              </div>
              <div class="card-body">
                <div class="form-group">
                  <label><span class="required">*</span> {{ $t('nodeDisciplineConfig.fields.name') }}</label>
                  <input
                    v-model="editingType.name"
                    type="text"
                    class="form-control"
                    :placeholder="$t('nodeDisciplineConfig.types.namePlaceholder')"
                    maxlength="180"
                  />
                </div>
                <div class="form-group">
                  <label>{{ $t('nodeDisciplineConfig.fields.description') }}</label>
                  <textarea
                    v-model="editingType.description"
                    class="form-control"
                    rows="2"
                    :placeholder="$t('nodeDisciplineConfig.fields.descriptionPlaceholder')"
                  />
                </div>
                <div class="form-group">
                  <label>{{ $t('nodeDisciplineConfig.fields.status') }}</label>
                  <select v-model="editingType.status" class="form-control">
                    <option :value="1">{{ $t('common.active') }}</option>
                    <option :value="0">{{ $t('common.inactive') }}</option>
                  </select>
                </div>
                <div class="form-group mb-1">
                  <label style="font-size: 0.8rem"
                    >{{ $t('nodeDisciplineConfig.types.teamTypesLabel') }}</label
                  >
                  <div
                    v-for="(tt, ttIdx) in editingType.team_types"
                    :key="ttIdx"
                    class="d-flex align-items-center mb-1"
                    style="gap: 6px"
                  >
                    <v-select
                      v-model="tt.team_type_id"
                      :options="teamTypes"
                      :reduce="(t) => t.id"
                      label="name"
                      :placeholder="$t('common.select')"
                      class="vselect"
                      style="flex: 1"
                    />
                    <b-button
                      size="sm"
                      variant="outline-danger"
                      style="padding: 2px 7px; flex-shrink: 0"
                      @click="editingType.team_types.splice(ttIdx, 1)"
                    >
                      <feather-icon icon="XIcon" size="12" />
                    </b-button>
                  </div>
                  <b-button
                    size="sm"
                    variant="outline-primary"
                    @click="editingType.team_types.push({ team_type_id: null })"
                  >
                    {{ $t('nodeDisciplineConfig.types.addTeamTypeButton') }}
                  </b-button>
                  <small class="text-muted d-block mt-1"
                    >{{ $t('nodeDisciplineConfig.types.teamTypesHint') }}</small
                  >
                </div>
                <div v-if="editingType.id" class="form-group">
                  <label>{{ $t('nodeDisciplineConfig.types.pinLabel') }}</label>
                  <div class="d-flex align-items-center" style="gap: 12px">
                    <div>
                      <img
                        v-if="editingType.pin_icon"
                        :src="editingType.pin_icon"
                        style="
                          width: 48px;
                          height: 48px;
                          object-fit: contain;
                          border: 1px solid #e0ddf5;
                          border-radius: 8px;
                        "
                      />
                      <pin-preview
                        v-else-if="editingType.pin_color"
                        :pin-style="{ color: editingType.pin_color, icon_class: editingType.pin_icon_class, icon_color: editingType.pin_icon_color, size: editingType.pin_size }"
                        :size="48"
                      />
                      <div v-else class="pin-empty-preview">{{ $t('nodeDisciplineConfig.pin.emptyLine1') }}<br />{{ $t('nodeDisciplineConfig.pin.emptyLine2') }}</div>
                    </div>
                    <div>
                      <label
                        v-if="$hasAbility('node.admin')"
                        class="btn btn-sm btn-outline-primary mb-1"
                        style="cursor: pointer"
                      >
                        <feather-icon
                          icon="UploadIcon"
                          size="13"
                          class="mr-25"
                        />
                        {{ $t('nodeDisciplineConfig.pin.upload') }}
                        <input
                          type="file"
                          accept="image/*"
                          style="display: none"
                          @change="uploadTypePin"
                        />
                      </label>
                      <br />
                      <a
                        v-if="(editingType.pin_icon || editingType.pin_color) && $hasAbility('node.admin')"
                        href="#"
                        class="text-danger"
                        style="font-size: 0.78rem"
                        @click.prevent="removeTypePin"
                      >
                        {{ $t('nodeDisciplineConfig.pin.remove') }}
                      </a>
                    </div>
                  </div>
                  <small class="text-muted"
                    >{{ $t('nodeDisciplineConfig.types.pinHint') }}</small
                  >
                  <div v-if="$hasAbility('node.admin')" class="mt-3">
                    <small class="text-muted d-block mb-50">{{ $t('pinStyle.title') }}</small>
                    <pin-style-editor
                      :endpoint="`dispatch_types/${editingType.id}/pin-style`"
                      :color="editingType.pin_color"
                      :icon-class="editingType.pin_icon_class"
                      :icon-color="editingType.pin_icon_color"
                      :size="editingType.pin_size"
                      @saved="onTypePinStyleSaved"
                    />
                  </div>
                </div>
                <div class="d-flex">
                  <b-button
                    variant="primary"
                    class="mr-1"
                    v-if="$hasAbility('node.admin')"
                    @click="saveType"
                  >
                    <feather-icon icon="SaveIcon" size="14" class="mr-50" />
                    {{ editingType.id ? $t('nodeDisciplineConfig.actions.update') : $t('common.add') }}
                  </b-button>
                  <b-button
                    v-if="editingType.id"
                    variant="outline-secondary"
                    @click="cancelEditType"
                  >
                    {{ $t('common.cancel') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>

          <!-- Lista de tipos -->
          <div class="col-md-8">
            <div class="card">
              <div
                class="card-header d-flex align-items-center justify-content-between"
              >
                <span class="card-title mb-0">{{ $t('nodeDisciplineConfig.types.listTitle') }}</span>
                <small class="text-muted"
                  >{{ $t('nodeDisciplineConfig.types.count', { count: dispatchTypes.length }) }}</small
                >
              </div>
              <div class="card-body p-0">
                <div v-if="loadingTypes" class="text-center py-4">
                  <b-spinner variant="primary" />
                </div>
                <div
                  v-else-if="!dispatchTypes.length"
                  class="text-center text-muted py-4"
                >
                  {{ $t('nodeDisciplineConfig.types.emptyState') }}
                </div>
                <table v-else class="table table-hover mb-0">
                  <thead>
                    <tr>
                      <th>{{ $t('nodeDisciplineConfig.tableHeaders.name') }}</th>
                      <th style="width: 150px">{{ $t('nodeDisciplineConfig.tableHeaders.node') }}</th>
                      <th style="width: 100px">{{ $t('common.status') }}</th>
                      <th style="width: 100px">{{ $t('common.actions') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="t in dispatchTypes"
                      :key="t.id"
                      :class="{ 'table-active': editingType.id === t.id }"
                    >
                      <td class="align-middle">
                        <span class="font-weight-bold">{{ t.name }}</span>
                        <small
                          v-if="t.description"
                          class="text-muted d-block"
                          >{{ t.description }}</small
                        >
                      </td>
                      <td class="align-middle">
                        <span
                          v-if="t.node"
                          class="small"
                          :class="ehDoProprioNo(t) ? '' : 'text-muted'"
                          :title="textoDaOrigemRegistro(t)"
                        >
                          {{ t.node.name }}
                          <feather-icon
                            v-if="origemDoRegistro(t) === 'inherited'"
                            icon="CornerRightDownIcon"
                            size="12"
                          />
                          <feather-icon
                            v-else-if="origemDoRegistro(t) === 'descendant'"
                            icon="CornerRightUpIcon"
                            size="12"
                          />
                        </span>
                        <span v-else class="text-muted small">&mdash;</span>
                      </td>
                      <td class="align-middle">
                        <b-badge :variant="t.status ? 'success' : 'secondary'">
                          {{ t.status ? $t('common.active') : $t('common.inactive') }}
                        </b-badge>
                      </td>
                      <td class="align-middle">
                        <b-button
                          size="sm"
                          variant="outline-primary"
                          class="mr-50"
                          :disabled="!ehDoProprioNo(t)"
                          :title="
                            ehDoProprioNo(t)
                              ? $t('common.edit')
                              : textoDaOrigemRegistro(t)
                          "
                          @click="editType(t)"
                        >
                          <feather-icon icon="EditIcon" size="13" />
                        </b-button>
                        <b-button
                          size="sm"
                          variant="outline-danger"
                          :disabled="!ehDoProprioNo(t)"
                          :title="
                            ehDoProprioNo(t)
                              ? $t('common.delete')
                              : textoDaOrigemRegistro(t)
                          "
                          v-if="$hasAbility('node.admin')"
                          @click="deleteType(t)"
                        >
                          <feather-icon icon="TrashIcon" size="13" />
                        </b-button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <hr class="my-2" />

        <!-- == MOTIVOS == -->
        <h6 class="mb-1 text-primary">
          <feather-icon icon="AlignLeftIcon" size="15" class="mr-50" />
          {{ $t('nodeDisciplineConfig.reasons.sectionTitle') }}
        </h6>

        <!-- Seletor de tipo para filtrar motivos -->
        <div class="row mb-1">
          <div class="col-md-4">
            <div class="form-group mb-0">
              <label>{{ $t('nodeDisciplineConfig.reasons.filterByTypeLabel') }}</label>
              <v-select
                v-model="selectedTypeIdForReasons"
                :options="dispatchTypes"
                :reduce="(t) => t.id"
                label="name"
                :placeholder="$t('nodeDisciplineConfig.reasons.selectTypePlaceholder')"
                class="vselect"
                @input="onReasonTypeChange"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <!-- Formulário de motivo -->
          <div class="col-md-4">
            <div class="card">
              <div class="card-header">
                <span class="card-title mb-0">
                  {{ editingReason.id ? $t('nodeDisciplineConfig.reasons.formTitleEdit') : $t('nodeDisciplineConfig.reasons.formTitleNew') }}
                </span>
              </div>
              <div class="card-body">
                <div class="form-group">
                  <label>{{ $t('nodeDisciplineConfig.tableHeaders.type') }}</label>
                  <v-select
                    v-model="editingReason.dispatch_type_id"
                    :options="dispatchTypes"
                    :reduce="(t) => t.id"
                    label="name"
                    :placeholder="$t('nodeDisciplineConfig.reasons.selectTypeOptionPlaceholder')"
                    class="vselect"
                  />
                </div>
                <div class="form-group">
                  <label><span class="required">*</span> {{ $t('nodeDisciplineConfig.fields.name') }}</label>
                  <input
                    v-model="editingReason.name"
                    type="text"
                    class="form-control"
                    :placeholder="$t('nodeDisciplineConfig.reasons.namePlaceholder')"
                    maxlength="180"
                  />
                </div>
                <div class="form-group">
                  <label>{{ $t('nodeDisciplineConfig.fields.description') }}</label>
                  <textarea
                    v-model="editingReason.description"
                    class="form-control"
                    rows="2"
                    :placeholder="$t('nodeDisciplineConfig.fields.descriptionPlaceholder')"
                  />
                </div>
                <div class="form-group">
                  <label>{{ $t('nodeDisciplineConfig.fields.status') }}</label>
                  <select v-model="editingReason.status" class="form-control">
                    <option :value="1">{{ $t('common.active') }}</option>
                    <option :value="0">{{ $t('common.inactive') }}</option>
                  </select>
                </div>
                <div class="form-group">
                  <label><span class="required">*</span> {{ $t('nodeDisciplineConfig.reasons.classificationLabel') }}</label>
                  <v-select
                    v-model="editingReason.classification_id"
                    :options="classifications"
                    :reduce="(c) => c.id"
                    label="color_label"
                    :placeholder="$t('nodeDisciplineConfig.reasons.selectClassificationPlaceholder')"
                    class="vselect"
                  >
                    <template #option="c">
                      <span
                        class="d-inline-block rounded-circle mr-1"
                        style="
                          width: 12px;
                          height: 12px;
                          vertical-align: middle;
                        "
                        :style="{ background: c.hex_color }"
                      />
                      {{ c.color_label }}
                    </template>
                    <template #selected-option="c">
                      <span
                        class="d-inline-block rounded-circle mr-1"
                        style="
                          width: 12px;
                          height: 12px;
                          vertical-align: middle;
                        "
                        :style="{ background: c.hex_color }"
                      />
                      {{ c.color_label }}
                    </template>
                  </v-select>
                  <small class="text-muted"
                    >{{ $t('nodeDisciplineConfig.reasons.classificationHint') }}</small
                  >
                </div>
                <div class="form-group">
                  <label>{{ $t('nodeDisciplineConfig.reasons.interrogatoryLabel') }}</label>
                  <v-select
                    v-model="editingReason.interrogatory_id"
                    :options="interrogatories"
                    :reduce="(i) => i.id"
                    label="name"
                    :placeholder="$t('nodeDisciplineConfig.reasons.interrogatoryPlaceholder')"
                    class="vselect"
                    :clearable="true"
                  />
                  <small class="text-muted"
                    >{{ $t('nodeDisciplineConfig.reasons.interrogatoryHint') }}</small
                  >
                </div>
                <div v-if="editingReason.interrogatory_id" class="form-group">
                  <div class="custom-control custom-switch">
                    <input
                      id="interr-reason-required-switch"
                      v-model="editingReason.interrogatory_required"
                      type="checkbox"
                      class="custom-control-input"
                    />
                    <label
                      class="custom-control-label"
                      for="interr-reason-required-switch"
                    >
                      {{ $t('nodeDisciplineConfig.reasons.requiredFillLabel') }}
                    </label>
                  </div>
                  <small class="text-muted"
                    >{{ $t('nodeDisciplineConfig.reasons.requiredFillHint') }}</small
                  >
                </div>
                <div class="form-group mb-1">
                  <label style="font-size: 0.8rem"
                    >{{ $t('nodeDisciplineConfig.reasons.teamTypesLabel') }}</label
                  >
                  <div
                    v-for="(tt, ttIdx) in editingReason.team_types"
                    :key="ttIdx"
                    class="d-flex align-items-center mb-1"
                    style="gap: 6px"
                  >
                    <v-select
                      v-model="tt.team_type_id"
                      :options="teamTypes"
                      :reduce="(t) => t.id"
                      label="name"
                      :placeholder="$t('common.select')"
                      class="vselect"
                      style="flex: 1"
                    />
                    <b-button
                      size="sm"
                      variant="outline-danger"
                      style="padding: 2px 7px; flex-shrink: 0"
                      @click="editingReason.team_types.splice(ttIdx, 1)"
                    >
                      <feather-icon icon="XIcon" size="12" />
                    </b-button>
                  </div>
                  <b-button
                    size="sm"
                    variant="outline-primary"
                    @click="editingReason.team_types.push({ team_type_id: null })"
                  >
                    {{ $t('nodeDisciplineConfig.types.addTeamTypeButton') }}
                  </b-button>
                  <small class="text-muted d-block mt-1"
                    >{{ $t('nodeDisciplineConfig.reasons.teamTypesHint') }}</small
                  >
                </div>
                <div class="d-flex">
                  <b-button
                    variant="primary"
                    class="mr-1"
                    :disabled="!editingReason.dispatch_type_id"
                    v-if="$hasAbility('node.admin')"
                    @click="saveReason"
                  >
                    <feather-icon icon="SaveIcon" size="14" class="mr-50" />
                    {{ editingReason.id ? $t('nodeDisciplineConfig.actions.update') : $t('common.add') }}
                  </b-button>
                  <b-button
                    v-if="editingReason.id"
                    variant="outline-secondary"
                    @click="cancelEditReason"
                  >
                    {{ $t('common.cancel') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>

          <!-- Lista de motivos -->
          <div class="col-md-8">
            <div class="card">
              <div
                class="card-header d-flex align-items-center justify-content-between"
              >
                <span class="card-title mb-0">{{ $t('nodeDisciplineConfig.reasons.listTitle') }}</span>
                <small class="text-muted"
                  >{{ $t('nodeDisciplineConfig.reasons.count', { count: dispatchReasons.length }) }}</small
                >
              </div>
              <div class="card-body p-0">
                <div v-if="loadingReasons" class="text-center py-4">
                  <b-spinner variant="primary" />
                </div>
                <div
                  v-else-if="!filteredReasons.length"
                  class="text-center text-muted py-4"
                >
                  {{
                    selectedTypeIdForReasons ? $t('nodeDisciplineConfig.reasons.emptyStateForType') : $t('nodeDisciplineConfig.reasons.emptyState')
                  }}
                </div>
                <table v-else class="table table-hover mb-0">
                  <thead>
                    <tr>
                      <th>{{ $t('nodeDisciplineConfig.tableHeaders.name') }}</th>
                      <th>{{ $t('nodeDisciplineConfig.tableHeaders.type') }}</th>
                      <th>{{ $t('nodeDisciplineConfig.reasons.classificationLabel') }}</th>
                      <th style="width: 150px">{{ $t('nodeDisciplineConfig.tableHeaders.node') }}</th>
                      <th style="width: 100px">{{ $t('common.status') }}</th>
                      <th style="width: 100px">{{ $t('common.actions') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="r in filteredReasons"
                      :key="r.id"
                      :class="{ 'table-active': editingReason.id === r.id }"
                    >
                      <td class="align-middle">
                        <span class="font-weight-bold">{{ r.name }}</span>
                        <small
                          v-if="r.description"
                          class="text-muted d-block"
                          >{{ r.description }}</small
                        >
                      </td>
                      <td class="align-middle">
                        <small class="text-muted">{{
                          typeNameById(r.dispatch_type_id)
                        }}</small>
                      </td>
                      <td class="align-middle">
                        <span v-if="r.classification" class="small">
                          <span
                            class="d-inline-block rounded-circle mr-25"
                            style="
                              width: 10px;
                              height: 10px;
                              vertical-align: middle;
                            "
                            :style="{ background: r.classification.hex_color }"
                          />
                          {{ r.classification.color_label }}
                        </span>
                        <span v-else class="text-danger small">
                          <feather-icon
                            icon="AlertTriangleIcon"
                            size="11"
                            class="mr-25"
                          />
                          {{ $t('nodeDisciplineConfig.reasons.noClassification') }}
                        </span>
                      </td>
                      <td class="align-middle">
                        <span
                          v-if="r.node"
                          class="small"
                          :class="ehDoProprioNo(r) ? '' : 'text-muted'"
                          :title="textoDaOrigemRegistro(r)"
                        >
                          {{ r.node.name }}
                          <feather-icon
                            v-if="origemDoRegistro(r) === 'inherited'"
                            icon="CornerRightDownIcon"
                            size="12"
                          />
                          <feather-icon
                            v-else-if="origemDoRegistro(r) === 'descendant'"
                            icon="CornerRightUpIcon"
                            size="12"
                          />
                        </span>
                        <span v-else class="text-muted small">&mdash;</span>
                      </td>
                      <td class="align-middle">
                        <b-badge :variant="r.status ? 'success' : 'secondary'">
                          {{ r.status ? $t('common.active') : $t('common.inactive') }}
                        </b-badge>
                      </td>
                      <td class="align-middle">
                        <b-button
                          size="sm"
                          variant="outline-primary"
                          class="mr-50"
                          :disabled="!ehDoProprioNo(r)"
                          :title="
                            ehDoProprioNo(r)
                              ? $t('common.edit')
                              : textoDaOrigemRegistro(r)
                          "
                          @click="editReason(r)"
                        >
                          <feather-icon icon="EditIcon" size="13" />
                        </b-button>
                        <b-button
                          size="sm"
                          variant="outline-danger"
                          :disabled="!ehDoProprioNo(r)"
                          :title="
                            ehDoProprioNo(r)
                              ? $t('common.delete')
                              : textoDaOrigemRegistro(r)
                          "
                          v-if="$hasAbility('node.admin')"
                          @click="deleteReason(r)"
                        >
                          <feather-icon icon="TrashIcon" size="13" />
                        </b-button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </b-tab>

      <!-- ─── LINHAS DE CUIDADO ─────────────────────────────────────────── -->
      <b-tab :title="$t('nodeDisciplineConfig.tabs.careLines')">
        <div class="row">
          <div class="col-md-4">
            <div class="card">
              <div class="card-header">
                <span class="card-title mb-0">
                  {{
                    editingCareLine.id
                      ? $t('nodeDisciplineConfig.careLines.formTitleEdit')
                      : $t('nodeDisciplineConfig.careLines.formTitleNew')
                  }}
                </span>
              </div>
              <div class="card-body">
                <div class="form-group">
                  <label><span class="required">*</span> {{ $t('nodeDisciplineConfig.fields.name') }}</label>
                  <input
                    v-model="editingCareLine.name"
                    type="text"
                    class="form-control"
                    :placeholder="$t('nodeDisciplineConfig.careLines.namePlaceholder')"
                    maxlength="180"
                  />
                </div>
                <div class="form-group">
                  <label>{{ $t('nodeDisciplineConfig.fields.description') }}</label>
                  <textarea
                    v-model="editingCareLine.description"
                    class="form-control"
                    rows="2"
                    :placeholder="$t('nodeDisciplineConfig.fields.descriptionPlaceholder')"
                  />
                </div>
                <div class="form-group">
                  <label>{{ $t('nodeDisciplineConfig.fields.status') }}</label>
                  <select v-model="editingCareLine.status" class="form-control">
                    <option :value="1">{{ $t('common.active') }}</option>
                    <option :value="0">{{ $t('common.inactive') }}</option>
                  </select>
                </div>
                <div class="d-flex">
                  <b-button
                    variant="primary"
                    class="mr-1"
                    v-if="$hasAbility('node.admin')"
                    @click="saveCareLine"
                  >
                    <feather-icon icon="SaveIcon" size="14" class="mr-50" />
                    {{ editingCareLine.id ? $t('nodeDisciplineConfig.actions.update') : $t('common.add') }}
                  </b-button>
                  <b-button
                    v-if="editingCareLine.id"
                    variant="outline-secondary"
                    @click="cancelEditCareLine"
                  >
                    {{ $t('common.cancel') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-8">
            <div class="card">
              <div
                class="card-header d-flex align-items-center justify-content-between"
              >
                <span class="card-title mb-0"
                  >{{ $t('nodeDisciplineConfig.careLines.listTitle') }}</span
                >
                <small class="text-muted"
                  >{{ $t('nodeDisciplineConfig.careLines.count', { count: careLines.length }) }}</small
                >
              </div>
              <div class="card-body p-0">
                <div v-if="loadingCareLines" class="text-center py-4">
                  <b-spinner variant="primary" />
                </div>
                <div
                  v-else-if="!careLines.length"
                  class="text-center text-muted py-4"
                >
                  {{ $t('nodeDisciplineConfig.careLines.emptyState') }}
                </div>
                <table v-else class="table table-hover mb-0">
                  <thead>
                    <tr>
                      <th>{{ $t('nodeDisciplineConfig.tableHeaders.name') }}</th>
                      <th style="width: 150px">{{ $t('nodeDisciplineConfig.tableHeaders.node') }}</th>
                      <th style="width: 100px">{{ $t('common.status') }}</th>
                      <th style="width: 100px">{{ $t('common.actions') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="cl in careLines"
                      :key="cl.id"
                      :class="{ 'table-active': editingCareLine.id === cl.id }"
                    >
                      <td class="align-middle">
                        <span class="font-weight-bold">{{ cl.name }}</span>
                        <small
                          v-if="cl.description"
                          class="text-muted d-block"
                          >{{ cl.description }}</small
                        >
                      </td>
                      <td class="align-middle">
                        <span
                          v-if="cl.node"
                          class="small"
                          :class="ehDoProprioNo(cl) ? '' : 'text-muted'"
                          :title="textoDaOrigemRegistro(cl)"
                        >
                          {{ cl.node.name }}
                          <feather-icon
                            v-if="origemDoRegistro(cl) === 'inherited'"
                            icon="CornerRightDownIcon"
                            size="12"
                          />
                          <feather-icon
                            v-else-if="origemDoRegistro(cl) === 'descendant'"
                            icon="CornerRightUpIcon"
                            size="12"
                          />
                        </span>
                        <span v-else class="text-muted small">&mdash;</span>
                      </td>
                      <td class="align-middle">
                        <b-badge :variant="cl.status ? 'success' : 'secondary'">
                          {{ cl.status ? $t('common.active') : $t('common.inactive') }}
                        </b-badge>
                      </td>
                      <td class="align-middle">
                        <b-button
                          size="sm"
                          variant="outline-primary"
                          class="mr-50"
                          :disabled="!ehDoProprioNo(cl)"
                          :title="
                            ehDoProprioNo(cl)
                              ? $t('common.edit')
                              : textoDaOrigemRegistro(cl)
                          "
                          @click="editCareLine(cl)"
                        >
                          <feather-icon icon="EditIcon" size="13" />
                        </b-button>
                        <b-button
                          size="sm"
                          variant="outline-danger"
                          :disabled="!ehDoProprioNo(cl)"
                          :title="
                            ehDoProprioNo(cl)
                              ? $t('common.delete')
                              : textoDaOrigemRegistro(cl)
                          "
                          v-if="$hasAbility('node.admin')"
                          @click="deleteCareLine(cl)"
                        >
                          <feather-icon icon="TrashIcon" size="13" />
                        </b-button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </b-tab>

      <!-- ─── INTERROGATÓRIOS ───────────────────────────────────────────── -->
      <b-tab :title="$t('nodeDisciplineConfig.tabs.interrogatories')">
        <div class="p-2">
          <!-- Seção: Interrogatórios -->
          <h6 class="dc-section-title mb-1">{{ $t('nodeDisciplineConfig.tabs.interrogatories') }}</h6>
          <div class="row mb-3">
            <!-- Formulário -->
            <div class="col-md-4">
              <div class="card">
                <div class="card-header">
                  <span class="card-title mb-0"
                    >{{
                      editingInterrogatory.id ? $t('common.edit') : $t('nodeDisciplineConfig.interrogatories.newPrefix')
                    }}
                    {{ $t('nodeDisciplineConfig.interrogatories.singular') }}</span
                  >
                </div>
                <div class="card-body">
                  <div class="form-group">
                    <label><span class="required">*</span> {{ $t('nodeDisciplineConfig.fields.name') }}</label>
                    <input
                      v-model="editingInterrogatory.name"
                      type="text"
                      class="form-control"
                      :placeholder="$t('nodeDisciplineConfig.interrogatories.namePlaceholder')"
                      maxlength="180"
                    />
                  </div>
                  <div class="form-group">
                    <label>{{ $t('nodeDisciplineConfig.fields.description') }}</label>
                    <textarea
                      v-model="editingInterrogatory.description"
                      class="form-control"
                      rows="2"
                      :placeholder="$t('nodeDisciplineConfig.fields.descriptionPlaceholder')"
                    />
                  </div>
                  <div class="form-group">
                    <label>{{ $t('nodeDisciplineConfig.fields.status') }}</label>
                    <select
                      v-model="editingInterrogatory.status"
                      class="form-control"
                    >
                      <option :value="1">{{ $t('common.active') }}</option>
                      <option :value="0">{{ $t('common.inactive') }}</option>
                    </select>
                  </div>
                  <div class="form-group">
                    <b-form-checkbox
                      v-model="editingInterrogatory.show_on_multiple_involveds"
                      @change="onShowOnMultipleInvolvedsChange"
                    >
                      {{ $t('nodeDisciplineConfig.interrogatories.showOnMultipleInvolveds') }}
                    </b-form-checkbox>
                  </div>
                  <div
                    v-if="editingInterrogatory.show_on_multiple_involveds"
                    class="form-group"
                  >
                    <label
                      ><span class="required">*</span>
                      {{ $t('nodeDisciplineConfig.interrogatories.dispatchTypeLabel') }}</label
                    >
                    <v-select
                      v-model="editingInterrogatory.dispatch_type_id"
                      :options="dispatchTypes"
                      :reduce="(t) => t.id"
                      label="name"
                      :placeholder="$t('nodeDisciplineConfig.reasons.selectTypeOptionPlaceholder')"
                      class="vselect"
                    />
                  </div>
                  <div class="d-flex">
                    <b-button
                      variant="primary"
                      class="mr-1"
                      v-if="$hasAbility('node.admin')"
                      @click="saveInterrogatory"
                    >
                      <feather-icon icon="SaveIcon" size="14" class="mr-50" />
                      {{ editingInterrogatory.id ? $t('nodeDisciplineConfig.actions.update') : $t('common.add') }}
                    </b-button>
                    <b-button
                      v-if="editingInterrogatory.id"
                      variant="outline-secondary"
                      @click="cancelEditInterrogatory"
                      >{{ $t('common.cancel') }}</b-button
                    >
                  </div>
                </div>
              </div>
            </div>

            <!-- Tabela de interrogatórios -->
            <div class="col-md-8">
              <div class="card">
                <div
                  class="card-header d-flex align-items-center justify-content-between"
                >
                  <span class="card-title mb-0"
                    >{{ $t('nodeDisciplineConfig.interrogatories.listTitle') }}</span
                  >
                  <small class="text-muted"
                    >{{ $t('nodeDisciplineConfig.interrogatories.count', { count: interrogatories.length }) }}</small
                  >
                </div>
                <div class="card-body p-0">
                  <div v-if="loadingInterrogatories" class="text-center py-4">
                    <b-spinner variant="primary" />
                  </div>
                  <div
                    v-else-if="!interrogatories.length"
                    class="text-center text-muted py-4"
                  >
                    {{ $t('nodeDisciplineConfig.interrogatories.emptyState') }}
                  </div>
                  <table v-else class="table table-hover mb-0">
                    <thead>
                      <tr>
                        <th>{{ $t('nodeDisciplineConfig.tableHeaders.name') }}</th>
                        <th style="width: 80px">{{ $t('common.status') }}</th>
                        <th style="width: 120px">{{ $t('common.actions') }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="item in interrogatories"
                        :key="item.id"
                        :class="{
                          'table-active': selectedInterrogatoryId === item.id,
                        }"
                        style="cursor: pointer"
                        @click="selectInterrogatory(item)"
                      >
                        <td class="align-middle">
                          <span class="font-weight-bold">{{ item.name }}</span>
                          <small
                            v-if="item.description"
                            class="text-muted d-block"
                            >{{ item.description }}</small
                          >
                        </td>
                        <td class="align-middle">
                          <b-badge
                            :variant="item.status ? 'success' : 'secondary'"
                            >{{ item.status ? $t('common.active') : $t('common.inactive') }}</b-badge
                          >
                        </td>
                        <td class="align-middle">
                          <b-button
                            size="sm"
                            variant="outline-primary"
                            class="mr-50"
                            :title="$t('common.edit')"
                            @click.stop="editInterrogatory(item)"
                          >
                            <feather-icon icon="EditIcon" size="13" />
                          </b-button>
                          <b-button
                            size="sm"
                            variant="outline-danger"
                            :title="$t('common.delete')"
                            @click.stop="deleteInterrogatory(item)"
                          >
                            <feather-icon icon="TrashIcon" size="13" />
                          </b-button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <!-- Seção: Perguntas (aparece ao selecionar um interrogatório) -->
          <template v-if="selectedInterrogatoryId">
            <h6 class="dc-section-title mb-1">
              {{ $t('nodeDisciplineConfig.questions.sectionTitle') }}
            </h6>
            <div class="row">
              <!-- Formulário pergunta -->
              <div :class="questionMode === 'edit' ? 'col-md-5' : 'col-md-4'">
                <div class="card">
                  <div class="card-header">
                    <span class="card-title mb-0">
                      {{
                        questionMode === "edit"
                          ? $t('nodeDisciplineConfig.questions.formTitleEdit')
                          : $t('nodeDisciplineConfig.questions.formTitleNew')
                      }}
                    </span>
                  </div>
                  <div class="card-body">
                    <!-- Campos sempre visíveis -->
                    <div class="form-group">
                      <label><span class="required">*</span> {{ $t('nodeDisciplineConfig.questions.questionLabel') }}</label>
                      <textarea
                        v-model="editingQuestion.question"
                        class="form-control"
                        rows="3"
                        maxlength="500"
                        :placeholder="$t('nodeDisciplineConfig.questions.questionPlaceholder')"
                      />
                    </div>
                    <div class="form-row">
                      <div class="form-group col-7">
                        <label>{{ $t('nodeDisciplineConfig.questions.answerTypeLabel') }}</label>
                        <select
                          v-model.number="editingQuestion.question_type"
                          class="form-control"
                        >
                          <option :value="2">{{ $t('nodeDisciplineConfig.questions.answerTypeFreeText') }}</option>
                          <option :value="3">{{ $t('nodeDisciplineConfig.questions.answerTypeNumber') }}</option>
                          <option :value="4">{{ $t('nodeDisciplineConfig.questions.answerTypeAlternatives') }}</option>
                        </select>
                      </div>
                      <div
                        class="form-group col-5 d-flex flex-column justify-content-end pb-1"
                      >
                        <b-form-checkbox
                          v-model="editingQuestion.required"
                          switch
                        >
                          {{ $t('nodeDisciplineConfig.questions.requiredLabel') }}
                        </b-form-checkbox>
                      </div>
                    </div>

                    <!-- type=4: alternativas (disponível em ADD e EDIT) -->
                    <template v-if="editingQuestion.question_type === 4">
                      <div class="form-group">
                        <label>{{ $t('nodeDisciplineConfig.questions.alternativesLabel') }}</label>
                        <div
                          v-for="(alt, idx) in editingAlternatives"
                          :key="idx"
                          class="card border mb-2 p-2"
                          style="background: #f9f9f9"
                        >
                          <div class="form-row mb-1">
                            <div class="form-group col-6 mb-0">
                              <label style="font-size: 0.8rem">{{ $t('nodeDisciplineConfig.questions.labelLabel') }}</label>
                              <input
                                v-model="alt.label"
                                type="text"
                                class="form-control form-control-sm"
                                :placeholder="$t('nodeDisciplineConfig.questions.labelPlaceholder')"
                              />
                            </div>
                            <div class="form-group col-6 mb-0">
                              <label style="font-size: 0.8rem"
                                >{{ $t('nodeDisciplineConfig.questions.nextQuestionLabel') }}</label
                              >
                              <select
                                v-model="alt.next_question_id"
                                class="form-control form-control-sm"
                              >
                                <option :value="null">{{ $t('nodeDisciplineConfig.questions.endOption') }}</option>
                                <option
                                  v-for="q in questions.filter(
                                    (q) => q.id !== editingQuestion.id
                                  )"
                                  :key="q.id"
                                  :value="q.id"
                                >
                                  {{ q.question.substring(0, 25) }}...
                                </option>
                              </select>
                            </div>
                          </div>
                          <div class="form-group mb-1">
                            <label style="font-size: 0.8rem"
                              >{{ $t('nodeDisciplineConfig.questions.alternativeClassificationLabel') }}</label
                            >
                            <v-select
                              v-model="alt.classification_id"
                              :options="classifications"
                              :reduce="(c) => c.id"
                              label="color_label"
                              :placeholder="$t('nodeDisciplineConfig.questions.noneOption')"
                              :clearable="true"
                              class="vselect"
                            >
                              <template #option="opt">
                                <span
                                  class="d-inline-block rounded-circle mr-1"
                                  style="
                                    width: 12px;
                                    height: 12px;
                                    vertical-align: middle;
                                  "
                                  :style="{ background: opt.hex_color }"
                                />
                                {{ opt.color_label }}
                              </template>
                            </v-select>
                          </div>
                          <div class="form-group mb-1">
                            <label style="font-size: 0.8rem"
                              >{{ $t('nodeDisciplineConfig.questions.alternativeTeamTypesLabel') }}</label
                            >
                            <div
                              v-for="(tt, ttIdx) in alt.team_types"
                              :key="ttIdx"
                              class="d-flex align-items-center mb-1"
                              style="gap: 6px"
                            >
                              <v-select
                                v-model="tt.team_type_id"
                                :options="alternativeTeamTypeOptions(tt)"
                                :reduce="(t) => t.id"
                                label="name"
                                :placeholder="$t('common.select')"
                                class="vselect"
                                style="flex: 1"
                              />
                              <b-button
                                size="sm"
                                variant="outline-danger"
                                style="padding: 2px 7px; flex-shrink: 0"
                                @click="alt.team_types.splice(ttIdx, 1)"
                              >
                                <feather-icon icon="XIcon" size="12" />
                              </b-button>
                            </div>
                            <small
                              v-if="!disciplineTeamTypes.length"
                              class="text-muted d-block mb-1"
                              >{{ $t('nodeDisciplineConfig.questions.noDisciplineTeamTypes') }}</small
                            >
                            <b-button
                              size="sm"
                              variant="outline-primary"
                              @click="
                                alt.team_types.push({ team_type_id: null })
                              "
                            >
                              <feather-icon
                                icon="PlusIcon"
                                size="13"
                                class="mr-25"
                              />
                              {{ $t('nodeDisciplineConfig.questions.addTypeButton') }}
                            </b-button>
                          </div>
                          <div class="text-right">
                            <b-button
                              size="sm"
                              variant="outline-danger"
                              v-if="$hasAbility('node.admin')"
                              @click="removeAlternative(idx)"
                            >
                              <feather-icon icon="TrashIcon" size="12" />
                              {{ $t('nodeDisciplineConfig.questions.removeAlternativeButton') }}
                            </b-button>
                          </div>
                        </div>
                        <b-button
                          size="sm"
                          variant="outline-primary"
                          class="mt-1"
                          @click="addAlternative"
                        >
                          <feather-icon
                            icon="PlusIcon"
                            size="13"
                            class="mr-25"
                          />
                          {{ $t('nodeDisciplineConfig.questions.addAlternativeButton') }}
                        </b-button>
                      </div>
                    </template>

                    <!-- Campos extras apenas no modo EDITAR -->
                    <template v-if="questionMode === 'edit'">
                      <!-- type=2 or 3: próxima pergunta -->
                      <template
                        v-if="
                          editingQuestion.question_type === 2 ||
                          editingQuestion.question_type === 3
                        "
                      >
                        <div class="form-group">
                          <label>{{ $t('nodeDisciplineConfig.questions.nextQuestionLabel') }}</label>
                          <select
                            v-model="editingQuestion.next_question_id"
                            class="form-control form-control-sm"
                          >
                            <option :value="null">{{ $t('nodeDisciplineConfig.questions.endOption') }}</option>
                            <option
                              v-for="q in questions.filter(
                                (q) => q.id !== editingQuestion.id
                              )"
                              :key="q.id"
                              :value="q.id"
                            >
                              {{ q.question.substring(0, 50)
                              }}{{ q.question.length > 50 ? "..." : "" }}
                            </option>
                          </select>
                        </div>
                      </template>

                      <div class="form-group">
                        <label>{{ $t('nodeDisciplineConfig.fields.status') }}</label>
                        <select
                          v-model="editingQuestion.status"
                          class="form-control form-control-sm"
                        >
                          <option :value="1">{{ $t('nodeDisciplineConfig.questions.activeFeminine') }}</option>
                          <option :value="0">{{ $t('nodeDisciplineConfig.questions.inactiveFeminine') }}</option>
                        </select>
                      </div>
                    </template>
                    <!-- Fim do modo EDITAR -->

                    <div class="d-flex mt-1">
                      <b-button
                        variant="primary"
                        class="mr-1"
                        v-if="$hasAbility('node.admin')"
                        @click="saveQuestion"
                      >
                        <feather-icon icon="SaveIcon" size="14" class="mr-50" />
                        {{
                          questionMode === "edit" ? $t('nodeDisciplineConfig.actions.update') : $t('common.add')
                        }}
                      </b-button>
                      <b-button
                        v-if="questionMode === 'edit'"
                        variant="outline-secondary"
                        @click="cancelEditQuestion"
                      >
                        {{ $t('common.cancel') }}
                      </b-button>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Tabela de perguntas com drag-and-drop -->
              <div :class="questionMode === 'edit' ? 'col-md-7' : 'col-md-8'">
                <div class="card">
                  <div
                    class="card-header d-flex align-items-center justify-content-between"
                  >
                    <span class="card-title mb-0">{{ $t('nodeDisciplineConfig.questions.listTitle') }}</span>
                    <small class="text-muted"
                      >{{ $t('nodeDisciplineConfig.questions.count', { count: questions.length }) }}</small
                    >
                  </div>
                  <div class="card-body p-0">
                    <div v-if="loadingQuestions" class="text-center py-4">
                      <b-spinner variant="primary" />
                    </div>
                    <div
                      v-else-if="!questions.length"
                      class="text-center text-muted py-4"
                    >
                      {{ $t('nodeDisciplineConfig.questions.emptyState') }}
                    </div>
                    <table
                      v-else
                      class="table table-hover mb-0"
                      style="font-size: 0.85rem"
                    >
                      <thead>
                        <tr>
                          <th style="width: 28px" />
                          <th style="width: 36px">#</th>
                          <th>{{ $t('nodeDisciplineConfig.questions.questionLabel') }}</th>
                          <th style="width: 90px">{{ $t('nodeDisciplineConfig.tableHeaders.type') }}</th>
                          <th style="width: 60px">{{ $t('nodeDisciplineConfig.questions.requiredAbbrev') }}</th>
                          <th style="width: 80px">{{ $t('common.actions') }}</th>
                        </tr>
                      </thead>
                      <draggable
                        v-model="orderedQuestions"
                        tag="tbody"
                        handle=".drag-handle"
                        ghost-class="drag-ghost"
                        :disabled="!$hasAbility('node.admin')"
                        @end="onQuestionDragEnd"
                      >
                        <tr
                          v-for="q in orderedQuestions"
                          :key="q.id"
                          :class="{
                            'table-active': editingQuestion.id === q.id,
                          }"
                        >
                          <td
                            class="align-middle text-center drag-handle"
                            style="cursor: grab"
                          >
                            <feather-icon
                              icon="MenuIcon"
                              size="14"
                              class="text-muted"
                            />
                          </td>
                          <td
                            class="align-middle text-center text-muted"
                            style="font-size: 0.8rem"
                          >
                            {{ q.order }}
                          </td>
                          <td class="align-middle">
                            <span
                              >{{ q.question.substring(0, 60)
                              }}{{ q.question.length > 60 ? "..." : "" }}</span
                            >
                            <div
                              v-if="
                                q.question_type === 2 || q.question_type === 3
                              "
                              class="mt-1"
                              style="font-size: 0.78rem; color: #888"
                            >
                              → {{ questionNameById(q.next_question_id) }}
                            </div>
                            <div
                              v-else-if="
                                q.question_type === 4 &&
                                q.alternatives &&
                                q.alternatives.length
                              "
                              class="mt-1"
                              style="font-size: 0.78rem; color: #888"
                            >
                              <span
                                v-for="(alt, i) in q.alternatives"
                                :key="i"
                                class="mr-1"
                              >
                                "{{ alt.label }}" →
                                {{ questionNameById(alt.next_question_id)
                                }}<span v-if="i < q.alternatives.length - 1"
                                  >;</span
                                >
                              </span>
                            </div>
                          </td>
                          <td class="align-middle text-center">
                            <b-badge
                              :variant="
                                ['', 'secondary', 'info', 'warning', 'success'][
                                  q.question_type || 2
                                ]
                              "
                              style="font-size: 0.72rem"
                            >
                              {{
                                ["", "", $t('nodeDisciplineConfig.questions.typeFreeText'), $t('nodeDisciplineConfig.questions.typeNumber'), $t('nodeDisciplineConfig.questions.typeAlternatives')][
                                  q.question_type || 2
                                ]
                              }}
                            </b-badge>
                          </td>
                          <td class="align-middle text-center">
                            <b-badge
                              :variant="q.required ? 'danger' : 'secondary'"
                            >
                              {{ q.required ? $t('nodeDisciplineConfig.questions.yes') : $t('nodeDisciplineConfig.questions.no') }}
                            </b-badge>
                          </td>
                          <td class="align-middle">
                            <b-button
                              size="sm"
                              variant="outline-primary"
                              class="mr-50"
                              :title="$t('common.edit')"
                              @click="editQuestion(q)"
                            >
                              <feather-icon icon="EditIcon" size="13" />
                            </b-button>
                            <b-button
                              size="sm"
                              variant="outline-danger"
                              :title="$t('common.delete')"
                              v-if="$hasAbility('node.admin')"
                              @click="deleteQuestion(q)"
                            >
                              <feather-icon icon="TrashIcon" size="13" />
                            </b-button>
                          </td>
                        </tr>
                      </draggable>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </b-tab>

      <!-- ─── DESFECHOS ─────────────────────────────────────────────────── -->
      <b-tab :title="$t('nodeDisciplineConfig.tabs.outcomes')">
        <div class="row">
          <!-- Formulário -->
          <div class="col-md-4">
            <div class="card">
              <div class="card-header">
                <span class="card-title mb-0">
                  {{ editingOutcome.id ? $t('nodeDisciplineConfig.outcomes.formTitleEdit') : $t('nodeDisciplineConfig.outcomes.formTitleNew') }}
                </span>
              </div>
              <div class="card-body">
                <div class="form-group">
                  <label><span class="required">*</span> {{ $t('nodeDisciplineConfig.fields.name') }}</label>
                  <input
                    v-model="editingOutcome.name"
                    type="text"
                    class="form-control"
                    :placeholder="$t('nodeDisciplineConfig.outcomes.namePlaceholder')"
                    maxlength="180"
                  />
                </div>
                <div class="form-group">
                  <label>{{ $t('nodeDisciplineConfig.fields.description') }}</label>
                  <textarea
                    v-model="editingOutcome.description"
                    class="form-control"
                    rows="2"
                    :placeholder="$t('nodeDisciplineConfig.fields.descriptionPlaceholder')"
                  />
                </div>
                <div class="form-group">
                  <label>{{ $t('nodeDisciplineConfig.outcomes.contextsLabel') }}</label>
                  <v-select
                    v-model="editingOutcome.types"
                    :options="outcomeTypes"
                    :reduce="(ot) => ot.id"
                    label="name_outcome"
                    multiple
                    :placeholder="$t('nodeDisciplineConfig.outcomes.contextsPlaceholder')"
                    class="vselect"
                  />
                  <small class="text-muted">
                    {{ $t('nodeDisciplineConfig.outcomes.contextsHint') }}
                  </small>
                </div>
                <div class="form-group">
                  <div class="custom-control custom-switch">
                    <input
                      id="outcome-prank-call"
                      v-model="editingOutcome.is_prank_call"
                      type="checkbox"
                      class="custom-control-input"
                    />
                    <label
                      class="custom-control-label"
                      for="outcome-prank-call"
                    >
                      {{ $t('nodeDisciplineConfig.outcomes.reportNumberLabel') }}
                    </label>
                  </div>
                  <small class="text-muted">
                    {{ $t('nodeDisciplineConfig.outcomes.reportNumberHint') }}
                  </small>
                </div>
                <div class="d-flex">
                  <b-button
                    variant="primary"
                    class="mr-1"
                    v-if="$hasAbility('node.admin')"
                    @click="saveOutcome"
                  >
                    <feather-icon icon="SaveIcon" size="14" class="mr-50" />
                    {{ editingOutcome.id ? $t('nodeDisciplineConfig.actions.update') : $t('common.add') }}
                  </b-button>
                  <b-button
                    v-if="editingOutcome.id"
                    variant="outline-secondary"
                    @click="cancelEditOutcome"
                  >
                    {{ $t('common.cancel') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>

          <!-- Lista -->
          <div class="col-md-8">
            <div class="card">
              <div
                class="card-header d-flex align-items-center justify-content-between"
              >
                <span class="card-title mb-0">{{ $t('nodeDisciplineConfig.outcomes.listTitle') }}</span>
                <small class="text-muted"
                  >{{ $t('nodeDisciplineConfig.outcomes.count', { count: outcomes.length }) }}</small
                >
              </div>
              <div class="card-body p-0">
                <div v-if="loadingOutcomes" class="text-center py-4">
                  <b-spinner variant="primary" />
                </div>
                <div
                  v-else-if="!outcomes.length"
                  class="text-center text-muted py-4"
                >
                  {{ $t('nodeDisciplineConfig.outcomes.emptyState') }}
                </div>
                <div v-else class="table-responsive">
                  <table class="table table-sm table-hover mb-0">
                    <thead class="thead-light">
                      <tr>
                        <th>{{ $t('nodeDisciplineConfig.tableHeaders.name') }}</th>
                        <th>{{ $t('nodeDisciplineConfig.outcomes.contextsHeader') }}</th>
                        <th style="width: 90px" />
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="oc in outcomes"
                        :key="oc.id"
                        :class="{
                          'table-active': editingOutcome.id === oc.id,
                        }"
                      >
                        <td>
                          {{ oc.name }}
                          <span
                            v-if="oc.is_prank_call"
                            class="badge badge-light-danger ml-50"
                            :title="$t('nodeDisciplineConfig.outcomes.reportsNumberTitle')"
                            >{{ $t('nodeDisciplineConfig.outcomes.reportsNumberBadge') }}</span
                          >
                        </td>
                        <td>
                          <span
                            v-for="t in oc.types"
                            :key="t.id"
                            class="badge badge-secondary mr-1"
                            >{{ t.name_outcome }}</span
                          >
                          <span
                            v-if="!oc.types || !oc.types.length"
                            class="text-muted"
                            >—</span
                          >
                        </td>
                        <td class="text-right">
                          <b-button
                            size="sm"
                            variant="outline-primary"
                            class="mr-1"
                            @click="editOutcome(oc)"
                          >
                            <feather-icon icon="EditIcon" size="12" />
                          </b-button>
                          <b-button
                            size="sm"
                            variant="outline-danger"
                            v-if="$hasAbility('node.admin')"
                            @click="deleteOutcome(oc)"
                          >
                            <feather-icon icon="TrashIcon" size="12" />
                          </b-button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-tab>

      <!-- ─── CLASSIFICAÇÕES ────────────────────────────────────────────── -->
      <b-tab :title="$t('nodeDisciplineConfig.tabs.classifications')">
        <div class="row">
          <!-- Formulário -->
          <div class="col-md-4">
            <div class="card">
              <div class="card-header">
                <span class="card-title mb-0">
                  {{
                    editingClassification.id
                      ? $t('nodeDisciplineConfig.classifications.formTitleEdit')
                      : $t('nodeDisciplineConfig.classifications.formTitleNew')
                  }}
                </span>
              </div>
              <div class="card-body">
                <div class="form-row">
                  <div class="form-group col-md-5">
                    <label><span class="required">*</span> {{ $t('nodeDisciplineConfig.classifications.colorHexLabel') }}</label>
                    <div class="d-flex align-items-center" style="gap: 6px">
                      <input
                        v-model="editingClassification.hex_color"
                        type="color"
                        class="form-control p-0"
                        style="
                          width: 42px;
                          height: 38px;
                          cursor: pointer;
                          flex-shrink: 0;
                        "
                      />
                      <input
                        v-model="editingClassification.hex_color"
                        type="text"
                        class="form-control"
                        placeholder="#FF0000"
                        maxlength="7"
                        style="font-family: monospace"
                      />
                    </div>
                  </div>
                  <div class="form-group col-md-7">
                    <label><span class="required">*</span> {{ $t('nodeDisciplineConfig.classifications.labelLabel') }}</label>
                    <input
                      v-model="editingClassification.color_label"
                      type="text"
                      class="form-control"
                      :placeholder="$t('nodeDisciplineConfig.classifications.labelPlaceholder')"
                      maxlength="50"
                    />
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label><span class="required">*</span> {{ $t('nodeDisciplineConfig.classifications.weightLabel') }}</label>
                    <input
                      v-model.number="editingClassification.weight"
                      type="number"
                      class="form-control"
                      min="0"
                      :placeholder="$t('nodeDisciplineConfig.classifications.weightPlaceholder')"
                    />
                    <small class="text-muted">{{ $t('nodeDisciplineConfig.classifications.weightHint') }}</small>
                  </div>
                  <div class="form-group col-md-6">
                    <label>{{ $t('nodeDisciplineConfig.fields.status') }}</label>
                    <select
                      v-model="editingClassification.status"
                      class="form-control"
                    >
                      <option :value="1">{{ $t('common.active') }}</option>
                      <option :value="0">{{ $t('common.inactive') }}</option>
                    </select>
                  </div>
                </div>

                <div class="d-flex">
                  <b-button
                    variant="primary"
                    class="mr-1"
                    v-if="$hasAbility('node.admin')"
                    @click="saveClassification"
                  >
                    <feather-icon icon="SaveIcon" size="14" class="mr-50" />
                    {{ editingClassification.id ? $t('nodeDisciplineConfig.actions.update') : $t('common.add') }}
                  </b-button>
                  <b-button
                    v-if="editingClassification.id"
                    variant="outline-secondary"
                    @click="cancelEditClassification"
                  >
                    {{ $t('common.cancel') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>

          <!-- Lista -->
          <div class="col-md-8">
            <div class="card">
              <div
                class="card-header d-flex align-items-center justify-content-between"
              >
                <span class="card-title mb-0">{{ $t('nodeDisciplineConfig.classifications.listTitle') }}</span>
                <small class="text-muted"
                  >{{ $t('nodeDisciplineConfig.classifications.count', { count: classifications.length }) }}</small
                >
              </div>
              <div class="card-body p-0">
                <div v-if="loadingClassifications" class="text-center py-4">
                  <b-spinner variant="primary" />
                </div>
                <div
                  v-else-if="!classifications.length"
                  class="text-center text-muted py-4"
                >
                  {{ $t('nodeDisciplineConfig.classifications.emptyState') }}
                </div>
                <table v-else class="table table-hover mb-0">
                  <thead>
                    <tr>
                      <th>{{ $t('nodeDisciplineConfig.classifications.labelHeader') }}</th>
                      <th style="width: 90px">{{ $t('nodeDisciplineConfig.classifications.colorHeader') }}</th>
                      <th style="width: 70px">{{ $t('nodeDisciplineConfig.classifications.weightHeader') }}</th>
                      <th style="width: 80px">{{ $t('common.status') }}</th>
                      <th style="width: 100px">{{ $t('common.actions') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="c in classifications"
                      :key="c.id"
                      :class="{
                        'table-active': editingClassification.id === c.id,
                      }"
                    >
                      <td class="align-middle">
                        <div class="d-flex align-items-center" style="gap: 8px">
                          <div
                            :style="{ backgroundColor: c.hex_color }"
                            style="
                              width: 14px;
                              height: 14px;
                              border-radius: 3px;
                              border: 1px solid rgba(0, 0, 0, 0.15);
                              flex-shrink: 0;
                            "
                          />
                          <span class="font-weight-bold">{{
                            c.color_label
                          }}</span>
                          <code class="text-muted" style="font-size: 0.75rem">{{
                            c.hex_color
                          }}</code>
                        </div>
                      </td>
                      <td class="align-middle">
                        <div
                          :style="{ backgroundColor: c.hex_color }"
                          style="
                            width: 100%;
                            height: 24px;
                            border-radius: 4px;
                            border: 1px solid rgba(0, 0, 0, 0.1);
                          "
                        />
                      </td>
                      <td class="align-middle text-center">
                        <b-badge variant="light-secondary">
                          {{ c.weight }}
                        </b-badge>
                      </td>
                      <td class="align-middle">
                        <b-badge :variant="c.status ? 'success' : 'secondary'">
                          {{ c.status ? $t('common.active') : $t('common.inactive') }}
                        </b-badge>
                      </td>
                      <td class="align-middle">
                        <b-button
                          size="sm"
                          variant="outline-primary"
                          class="mr-50"
                          :title="$t('common.edit')"
                          @click="editClassification(c)"
                        >
                          <feather-icon icon="EditIcon" size="13" />
                        </b-button>
                        <b-button
                          size="sm"
                          variant="outline-danger"
                          :title="$t('common.delete')"
                          v-if="$hasAbility('node.admin')"
                          @click="deleteClassification(c)"
                        >
                          <feather-icon icon="TrashIcon" size="13" />
                        </b-button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </b-tab>

      <!-- ─── INTERCORRÊNCIAS ───────────────────────────────────────────── -->
      <b-tab :title="$t('nodeDisciplineConfig.tabs.intercurrences')">
        <div class="row">
          <!-- Formulário -->
          <div class="col-md-4">
            <div class="card">
              <div class="card-header">
                <span class="card-title mb-0">
                  {{
                    editingIntercurrence.id
                      ? $t('nodeDisciplineConfig.intercurrences.formTitleEdit')
                      : $t('nodeDisciplineConfig.intercurrences.formTitleNew')
                  }}
                </span>
              </div>
              <div class="card-body">
                <div class="form-group">
                  <label><span class="required">*</span> {{ $t('nodeDisciplineConfig.fields.name') }}</label>
                  <input
                    v-model="editingIntercurrence.name"
                    type="text"
                    class="form-control"
                    :placeholder="$t('nodeDisciplineConfig.intercurrences.namePlaceholder')"
                    maxlength="150"
                  />
                </div>
                <div class="form-group">
                  <label>{{ $t('nodeDisciplineConfig.fields.description') }}</label>
                  <textarea
                    v-model="editingIntercurrence.description"
                    class="form-control"
                    rows="2"
                    :placeholder="$t('nodeDisciplineConfig.fields.descriptionPlaceholder')"
                  />
                </div>
                <div class="form-group">
                  <label>{{ $t('nodeDisciplineConfig.fields.status') }}</label>
                  <select
                    v-model="editingIntercurrence.is_active"
                    class="form-control"
                  >
                    <option :value="true">{{ $t('common.active') }}</option>
                    <option :value="false">{{ $t('common.inactive') }}</option>
                  </select>
                </div>
                <div class="d-flex">
                  <b-button
                    variant="primary"
                    class="mr-1"
                    v-if="$hasAbility('node.admin')"
                    @click="saveIntercurrence"
                  >
                    <feather-icon icon="SaveIcon" size="14" class="mr-50" />
                    {{ editingIntercurrence.id ? $t('nodeDisciplineConfig.actions.update') : $t('common.add') }}
                  </b-button>
                  <b-button
                    v-if="editingIntercurrence.id"
                    variant="outline-secondary"
                    @click="cancelEditIntercurrence"
                  >
                    {{ $t('common.cancel') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>

          <!-- Lista -->
          <div class="col-md-8">
            <div class="card">
              <div
                class="card-header d-flex align-items-center justify-content-between"
              >
                <span class="card-title mb-0">{{ $t('nodeDisciplineConfig.intercurrences.listTitle') }}</span>
                <small class="text-muted"
                  >{{ $t('nodeDisciplineConfig.intercurrences.count', { count: intercurrences.length }) }}</small
                >
              </div>
              <div class="card-body p-0">
                <div v-if="loadingIntercurrences" class="text-center py-4">
                  <b-spinner variant="primary" />
                </div>
                <div
                  v-else-if="!intercurrences.length"
                  class="text-center text-muted py-4"
                >
                  {{ $t('nodeDisciplineConfig.intercurrences.emptyState') }}
                </div>
                <table v-else class="table table-hover mb-0">
                  <thead>
                    <tr>
                      <th>{{ $t('nodeDisciplineConfig.tableHeaders.name') }}</th>
                      <th style="width: 90px">{{ $t('common.status') }}</th>
                      <th style="width: 100px">{{ $t('common.actions') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="item in intercurrences"
                      :key="item.id"
                      :class="{
                        'table-active': editingIntercurrence.id === item.id,
                      }"
                    >
                      <td class="align-middle">
                        <span class="font-weight-bold">{{ item.name }}</span>
                        <small
                          v-if="item.description"
                          class="text-muted d-block"
                          >{{ item.description }}</small
                        >
                      </td>
                      <td class="align-middle">
                        <b-badge
                          :variant="item.is_active ? 'success' : 'secondary'"
                        >
                          {{ item.is_active ? $t('common.active') : $t('common.inactive') }}
                        </b-badge>
                      </td>
                      <td class="align-middle">
                        <b-button
                          size="sm"
                          variant="outline-primary"
                          class="mr-50"
                          :title="$t('common.edit')"
                          @click="editIntercurrence(item)"
                        >
                          <feather-icon icon="EditIcon" size="13" />
                        </b-button>
                        <b-button
                          size="sm"
                          variant="outline-danger"
                          :title="$t('common.delete')"
                          v-if="$hasAbility('node.admin')"
                          @click="deleteIntercurrence(item)"
                        >
                          <feather-icon icon="TrashIcon" size="13" />
                        </b-button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </b-tab>

      <!-- ─── AVALIAÇÃO INICIAL ──────────────────────────────────────── -->
      <b-tab :title="$t('nodeDisciplineConfig.tabs.initialAssessment')">
        <div class="row">
          <!-- Formulário de pergunta -->
          <div class="col-md-5">
            <div class="card">
              <div class="card-header">
                <span class="card-title mb-0">
                  {{
                    editingAssessmentQuestion.id
                      ? $t('nodeDisciplineConfig.questions.formTitleEdit')
                      : $t('nodeDisciplineConfig.questions.formTitleNew')
                  }}
                </span>
              </div>
              <div class="card-body">
                <div class="form-group">
                  <label
                    ><span class="required">*</span> {{ $t('nodeDisciplineConfig.assessmentQuestions.labelQuestionLabel') }}</label
                  >
                  <input
                    v-model="editingAssessmentQuestion.label"
                    type="text"
                    class="form-control"
                    :placeholder="$t('nodeDisciplineConfig.assessmentQuestions.labelPlaceholder')"
                    maxlength="200"
                  />
                </div>
                <div class="form-group">
                  <label><span class="required">*</span> {{ $t('nodeDisciplineConfig.tableHeaders.type') }}</label>
                  <select
                    v-model="editingAssessmentQuestion.type"
                    class="form-control"
                  >
                    <option value="single_select">{{ $t('nodeDisciplineConfig.assessmentQuestions.typeSingleSelect') }}</option>
                    <option value="multiple_select">{{ $t('nodeDisciplineConfig.assessmentQuestions.typeMultipleSelect') }}</option>
                    <option value="text">{{ $t('nodeDisciplineConfig.assessmentQuestions.typeFreeText') }}</option>
                  </select>
                </div>
                <div class="form-group">
                  <label>{{ $t('nodeDisciplineConfig.fields.order') }}</label>
                  <input
                    v-model.number="editingAssessmentQuestion.order"
                    type="number"
                    class="form-control"
                    min="0"
                    placeholder="0"
                    style="width: 100px"
                  />
                </div>
                <div class="form-group">
                  <label>{{ $t('nodeDisciplineConfig.fields.status') }}</label>
                  <select
                    v-model="editingAssessmentQuestion.is_active"
                    class="form-control"
                  >
                    <option :value="true">{{ $t('common.active') }}</option>
                    <option :value="false">{{ $t('common.inactive') }}</option>
                  </select>
                </div>

                <!-- Opções de resposta (para tipos de seleção) -->
                <div
                  v-if="
                    editingAssessmentQuestion.type === 'single_select' ||
                    editingAssessmentQuestion.type === 'multiple_select'
                  "
                  class="form-group"
                >
                  <label>{{ $t('nodeDisciplineConfig.assessmentQuestions.optionsLabel') }}</label>
                  <div class="d-flex mb-1" style="gap: 6px">
                    <input
                      v-model="inlineOptionInput"
                      type="text"
                      class="form-control form-control-sm"
                      :placeholder="$t('nodeDisciplineConfig.assessmentQuestions.optionPlaceholder')"
                      maxlength="150"
                      @keyup.enter="addInlineOption"
                    />
                    <b-button
                      size="sm"
                      variant="outline-primary"
                      :disabled="!inlineOptionInput.trim()"
                      @click="addInlineOption"
                    >
                      <feather-icon icon="PlusIcon" size="13" />
                    </b-button>
                  </div>
                  <div
                    v-if="!editingAssessmentQuestionOptions.length"
                    class="text-muted"
                    style="font-size: 12px"
                  >
                    {{ $t('nodeDisciplineConfig.assessmentQuestions.noOptionsAdded') }}
                  </div>
                  <div v-else class="d-flex flex-wrap" style="gap: 4px">
                    <span
                      v-for="(opt, idx) in editingAssessmentQuestionOptions"
                      :key="idx"
                      class="badge badge-light-primary d-inline-flex align-items-center"
                      style="font-size: 12px; gap: 4px; padding: 4px 8px"
                    >
                      {{ opt.label }}
                      <button
                        class="btn btn-link p-0 text-danger"
                        style="font-size: 11px; line-height: 1"
                        :title="$t('nodeDisciplineConfig.assessmentQuestions.removeOptionTitle')"
                        v-if="$hasAbility('node.admin')"
                        @click="removeInlineOption(opt, idx)"
                      >
                        <feather-icon icon="XIcon" size="11" />
                      </button>
                    </span>
                  </div>
                </div>

                <div class="d-flex">
                  <b-button
                    variant="primary"
                    class="mr-1"
                    v-if="$hasAbility('node.admin')"
                    @click="saveAssessmentQuestion"
                  >
                    <feather-icon icon="SaveIcon" size="14" class="mr-50" />
                    {{
                      editingAssessmentQuestion.id ? $t('nodeDisciplineConfig.actions.update') : $t('common.add')
                    }}
                  </b-button>
                  <b-button
                    v-if="editingAssessmentQuestion.id"
                    variant="outline-secondary"
                    @click="cancelEditAssessmentQuestion"
                  >
                    {{ $t('common.cancel') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>

          <!-- Lista de perguntas -->
          <div class="col-md-7">
            <div class="card">
              <div
                class="card-header d-flex align-items-center justify-content-between"
              >
                <span class="card-title mb-0">{{ $t('nodeDisciplineConfig.questions.listTitle') }}</span>
                <small class="text-muted"
                  >{{ $t('nodeDisciplineConfig.questions.count', { count: assessmentQuestions.length }) }}</small
                >
              </div>
              <div class="card-body p-0">
                <div v-if="loadingAssessmentQuestions" class="text-center py-4">
                  <b-spinner variant="primary" />
                </div>
                <div
                  v-else-if="!assessmentQuestions.length"
                  class="text-center text-muted py-4"
                >
                  {{ $t('nodeDisciplineConfig.assessmentQuestions.emptyState') }}
                </div>
                <table v-else class="table table-hover mb-0">
                  <thead>
                    <tr>
                      <th style="width: 36px" />
                      <th style="width: 60px">{{ $t('nodeDisciplineConfig.fields.orderHeader') }}</th>
                      <th>{{ $t('nodeDisciplineConfig.classifications.labelHeader') }}</th>
                      <th style="width: 120px">{{ $t('nodeDisciplineConfig.tableHeaders.type') }}</th>
                      <th style="width: 80px">{{ $t('common.status') }}</th>
                      <th style="width: 90px">{{ $t('common.actions') }}</th>
                    </tr>
                  </thead>
                  <draggable
                    v-model="orderedAssessmentQuestions"
                    tag="tbody"
                    handle=".drag-handle"
                    ghost-class="drag-ghost"
                    :disabled="!$hasAbility('node.admin')"
                    @end="onAssessmentQuestionDragEnd"
                  >
                    <tr
                      v-for="q in orderedAssessmentQuestions"
                      :key="q.id"
                      :class="{
                        'table-active': editingAssessmentQuestion.id === q.id,
                      }"
                    >
                      <td
                        class="align-middle text-center drag-handle"
                        style="cursor: grab"
                      >
                        <feather-icon
                          icon="MenuIcon"
                          size="14"
                          class="text-muted"
                        />
                      </td>
                      <td class="align-middle text-center">
                        <span class="text-muted">{{ q.order }}</span>
                      </td>
                      <td class="align-middle">
                        <span class="font-weight-bold">{{ q.label }}</span>
                        <div
                          v-if="
                            q.type !== 'text' && q.options && q.options.length
                          "
                          class="d-flex flex-wrap mt-25"
                          style="gap: 3px"
                        >
                          <span
                            v-for="opt in q.options"
                            :key="opt.id"
                            class="badge badge-light-secondary"
                            style="font-size: 10px"
                            >{{ opt.label }}</span
                          >
                        </div>
                        <div v-else-if="q.type !== 'text'">
                          <small class="text-muted"
                            >{{ $t('nodeDisciplineConfig.assessmentQuestions.noOptionsHint') }}</small
                          >
                        </div>
                      </td>
                      <td class="align-middle">
                        <b-badge
                          :variant="typeVariant(q.type)"
                          style="font-size: 11px"
                        >
                          {{ typeLabel(q.type) }}
                        </b-badge>
                      </td>
                      <td class="align-middle">
                        <b-badge
                          :variant="q.is_active ? 'success' : 'secondary'"
                        >
                          {{ q.is_active ? $t('common.active') : $t('common.inactive') }}
                        </b-badge>
                      </td>
                      <td class="align-middle">
                        <b-button
                          size="sm"
                          variant="outline-primary"
                          class="mr-50"
                          :title="$t('common.edit')"
                          @click="beginEditAssessmentQuestion(q)"
                        >
                          <feather-icon icon="EditIcon" size="13" />
                        </b-button>
                        <b-button
                          size="sm"
                          variant="outline-danger"
                          :title="$t('common.delete')"
                          v-if="$hasAbility('node.admin')"
                          @click="deleteAssessmentQuestion(q)"
                        >
                          <feather-icon icon="TrashIcon" size="13" />
                        </b-button>
                      </td>
                    </tr>
                  </draggable>
                </table>
              </div>
            </div>
          </div>
        </div>
      </b-tab>

      <!-- ─── PROBLEMAS ──────────────────────────────────────────────── -->
      <b-tab :title="$t('nodeDisciplineConfig.tabs.problems')">
        <div class="row">
          <!-- Formulário de problema -->
          <div class="col-md-5">
            <div class="card">
              <div class="card-header">
                <span class="card-title mb-0">
                  {{ editingProblem.id ? $t('nodeDisciplineConfig.problems.formTitleEdit') : $t('nodeDisciplineConfig.problems.formTitleNew') }}
                </span>
              </div>
              <div class="card-body">
                <div class="form-group">
                  <label
                    ><span class="required">*</span> {{ $t('nodeDisciplineConfig.problems.problemQuestionLabel') }}</label
                  >
                  <input
                    v-model="editingProblem.label"
                    type="text"
                    class="form-control"
                    :placeholder="$t('nodeDisciplineConfig.problems.problemPlaceholder')"
                    maxlength="200"
                  />
                  <small class="text-muted"
                    >{{ $t('nodeDisciplineConfig.problems.answerHint') }}</small
                  >
                </div>
                <div class="form-group">
                  <label>{{ $t('nodeDisciplineConfig.fields.order') }}</label>
                  <input
                    v-model.number="editingProblem.order"
                    type="number"
                    class="form-control"
                    min="0"
                    placeholder="0"
                    style="width: 100px"
                  />
                </div>
                <div class="form-group">
                  <label>{{ $t('nodeDisciplineConfig.fields.status') }}</label>
                  <select
                    v-model="editingProblem.is_active"
                    class="form-control"
                  >
                    <option :value="true">{{ $t('common.active') }}</option>
                    <option :value="false">{{ $t('common.inactive') }}</option>
                  </select>
                </div>
                <div class="d-flex">
                  <b-button
                    variant="primary"
                    class="mr-1"
                    v-if="$hasAbility('node.admin')"
                    @click="saveProblem"
                  >
                    <feather-icon icon="SaveIcon" size="14" class="mr-50" />
                    {{ editingProblem.id ? $t('nodeDisciplineConfig.actions.update') : $t('common.add') }}
                  </b-button>
                  <b-button
                    v-if="editingProblem.id"
                    variant="outline-secondary"
                    @click="cancelEditProblem"
                  >
                    {{ $t('common.cancel') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>

          <!-- Lista de problemas -->
          <div class="col-md-7">
            <div class="card">
              <div
                class="card-header d-flex align-items-center justify-content-between"
              >
                <span class="card-title mb-0">{{ $t('nodeDisciplineConfig.problems.listTitle') }}</span>
                <small class="text-muted"
                  >{{ $t('nodeDisciplineConfig.problems.count', { count: problems.length }) }}</small
                >
              </div>
              <div class="card-body p-0">
                <div v-if="loadingProblems" class="text-center py-4">
                  <b-spinner variant="primary" />
                </div>
                <div
                  v-else-if="!problems.length"
                  class="text-center text-muted py-4"
                >
                  {{ $t('nodeDisciplineConfig.problems.emptyState') }}
                </div>
                <table v-else class="table table-hover mb-0">
                  <thead>
                    <tr>
                      <th style="width: 36px" />
                      <th style="width: 60px">{{ $t('nodeDisciplineConfig.fields.orderHeader') }}</th>
                      <th>{{ $t('nodeDisciplineConfig.problems.problemHeader') }}</th>
                      <th style="width: 80px">{{ $t('common.status') }}</th>
                      <th style="width: 90px">{{ $t('common.actions') }}</th>
                    </tr>
                  </thead>
                  <draggable
                    v-model="orderedProblems"
                    tag="tbody"
                    handle=".drag-handle"
                    ghost-class="drag-ghost"
                    :disabled="!$hasAbility('node.admin')"
                    @end="onProblemDragEnd"
                  >
                    <tr
                      v-for="p in orderedProblems"
                      :key="p.id"
                      :class="{ 'table-active': editingProblem.id === p.id }"
                    >
                      <td
                        class="align-middle text-center drag-handle"
                        style="cursor: grab"
                      >
                        <feather-icon
                          icon="MenuIcon"
                          size="14"
                          class="text-muted"
                        />
                      </td>
                      <td class="align-middle text-center">
                        <span class="text-muted">{{ p.order }}</span>
                      </td>
                      <td class="align-middle">
                        <span class="font-weight-bold">{{ p.label }}</span>
                      </td>
                      <td class="align-middle">
                        <b-badge
                          :variant="p.is_active ? 'success' : 'secondary'"
                        >
                          {{ p.is_active ? $t('common.active') : $t('common.inactive') }}
                        </b-badge>
                      </td>
                      <td class="align-middle">
                        <b-button
                          size="sm"
                          variant="outline-primary"
                          class="mr-50"
                          :title="$t('common.edit')"
                          @click="beginEditProblem(p)"
                        >
                          <feather-icon icon="EditIcon" size="13" />
                        </b-button>
                        <b-button
                          size="sm"
                          variant="outline-danger"
                          :title="$t('common.delete')"
                          v-if="$hasAbility('node.admin')"
                          @click="deleteProblem(p)"
                        >
                          <feather-icon icon="TrashIcon" size="13" />
                        </b-button>
                      </td>
                    </tr>
                  </draggable>
                </table>
              </div>
            </div>
          </div>
        </div>
      </b-tab>

      <!-- ─── FLUXO DE OCORRÊNCIA ──────────────────────────────────────── -->
      <b-tab :title="$t('nodeDisciplineConfig.tabs.occurrenceFlow')">
        <div class="row mt-1">
          <div class="col-md-8">
            <div class="card">
              <div class="card-header">
                <span class="card-title mb-0">{{ $t('nodeDisciplineConfig.flow.pipelineTitle') }}</span>
              </div>
              <div class="card-body pb-2">
                <p class="text-muted small mb-2">
                  {{ $t('nodeDisciplineConfig.flow.pipelineHint') }}
                </p>

                <!-- Etapa fixa: SOLICITA -->
                <div class="flow-step-fixed">
                  <feather-icon
                    icon="PhoneIcon"
                    size="14"
                    class="mr-50 text-primary"
                  />
                  <strong>SOLICITA</strong>
                  <span class="text-muted ml-1 small"
                    >{{ $t('nodeDisciplineConfig.flow.requestStepHint') }}</span
                  >
                </div>
                <div class="flow-step-arrow">↓</div>

                <!-- Etapas intermediárias -->
                <div
                  v-if="flowSteps.length === 0"
                  class="text-center text-muted small py-2"
                  style="border: 1px dashed #ddd; border-radius: 6px"
                >
                  {{ $t('nodeDisciplineConfig.flow.emptyState') }}
                </div>

                <div v-for="step in flowSteps" :key="step.id">
                  <div
                    class="flow-step-row"
                    :class="{ 'flow-step-inactive': !step.status }"
                  >
                    <span
                      class="badge mr-1"
                      :class="
                        step.status
                          ? 'badge-light-success'
                          : 'badge-light-secondary'
                      "
                      >{{ step.status ? $t('common.active') : $t('common.inactive') }}</span
                    >

                    <div class="flex-grow-1">
                      <strong>{{ step.step_label }}</strong>
                      <code
                        class="ml-1 text-muted"
                        style="font-size: 0.75rem"
                        >{{ step.step_key }}</code
                      >
                      <div
                        v-if="
                          step.skip_conditions && step.skip_conditions.length
                        "
                        class="small text-muted mt-25"
                      >
                        {{ $t('nodeDisciplineConfig.flow.skippedBy', { summary: skipSummary(step) }) }}
                      </div>
                    </div>

                    <div class="d-flex align-items-center">
                      <b-button
                        size="sm"
                        :variant="
                          step.status ? 'outline-warning' : 'outline-success'
                        "
                        class="mr-50"
                        v-if="$hasAbility('node.admin')"
                        @click="toggleFlowStep(step)"
                      >
                        {{ step.status ? $t('nodeDisciplineConfig.flow.deactivate') : $t('nodeDisciplineConfig.flow.activate') }}
                      </b-button>
                      <b-button
                        v-if="$hasAbility('node.admin')"
                        size="sm"
                        variant="flat-primary"
                        @click="openSkipModal(step)"
                      >
                        <feather-icon
                          icon="SkipForwardIcon"
                          size="12"
                          class="mr-25"
                        />
                        {{ $t('nodeDisciplineConfig.flow.skipsButton') }}
                      </b-button>
                    </div>
                  </div>
                  <div class="flow-step-arrow">↓</div>
                </div>

                <!-- Etapa fixa: DESPACHA -->
                <div class="flow-step-fixed flow-step-fixed--end">
                  <feather-icon
                    icon="RadioIcon"
                    size="14"
                    class="mr-50 text-success"
                  />
                  <strong>DESPACHA</strong>
                  <span class="text-muted ml-1 small"
                    >{{ $t('nodeDisciplineConfig.flow.dispatchStepHint') }}</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-tab>
      <!-- ===== Decisões Técnicas ===== -->
      <b-tab :title="$t('nodeDisciplineConfig.tabs.technicalDecisions')">
        <div class="row">
          <div class="col-md-4">
            <div class="card">
              <div class="card-header">
                <span class="card-title mb-0">
                  {{
                    editingTechnicalDecision.id
                      ? $t('nodeDisciplineConfig.technicalDecisions.formTitleEdit')
                      : $t('nodeDisciplineConfig.technicalDecisions.formTitleNew')
                  }}
                </span>
              </div>
              <div v-if="!editingTechnicalDecision.is_fixed" class="card-body">
                <div class="form-group">
                  <label><span class="required">*</span> {{ $t('nodeDisciplineConfig.fields.name') }}</label>
                  <input
                    v-model="editingTechnicalDecision.name"
                    type="text"
                    class="form-control"
                    :placeholder="$t('nodeDisciplineConfig.technicalDecisions.namePlaceholder')"
                    maxlength="180"
                  />
                </div>
                <div class="form-group">
                  <label>{{ $t('nodeDisciplineConfig.fields.status') }}</label>
                  <select
                    v-model="editingTechnicalDecision.status"
                    class="form-control"
                  >
                    <option :value="1">{{ $t('common.active') }}</option>
                    <option :value="0">{{ $t('common.inactive') }}</option>
                  </select>
                </div>
                <div class="d-flex">
                  <b-button
                    variant="primary"
                    class="mr-1"
                    v-if="$hasAbility('node.admin')"
                    @click="saveTechnicalDecision"
                  >
                    <feather-icon icon="SaveIcon" size="14" class="mr-50" />
                    {{
                      editingTechnicalDecision.id ? $t('nodeDisciplineConfig.actions.update') : $t('common.add')
                    }}
                  </b-button>
                  <b-button
                    v-if="editingTechnicalDecision.id"
                    variant="outline-secondary"
                    @click="cancelEditTechnicalDecision"
                  >
                    {{ $t('common.cancel') }}
                  </b-button>
                </div>
              </div>
              <div v-else class="card-body text-muted small">
                {{ $t('nodeDisciplineConfig.technicalDecisions.systemHint') }}
              </div>
            </div>
          </div>

          <div class="col-md-8">
            <div class="card">
              <div
                class="card-header d-flex align-items-center justify-content-between"
              >
                <span class="card-title mb-0">{{ $t('nodeDisciplineConfig.technicalDecisions.listTitle') }}</span>
                <small class="text-muted"
                  >{{ $t('nodeDisciplineConfig.technicalDecisions.count', { count: technicalDecisions.length }) }}</small
                >
              </div>
              <div class="card-body p-0">
                <div v-if="loadingTechnicalDecisions" class="text-center py-4">
                  <b-spinner variant="primary" />
                </div>
                <div
                  v-else-if="!technicalDecisions.length"
                  class="text-center text-muted py-4"
                >
                  {{ $t('nodeDisciplineConfig.technicalDecisions.emptyState') }}
                </div>
                <table v-else class="table table-hover mb-0">
                  <thead>
                    <tr>
                      <th>{{ $t('nodeDisciplineConfig.tableHeaders.name') }}</th>
                      <th style="width: 90px">{{ $t('nodeDisciplineConfig.tableHeaders.type') }}</th>
                      <th style="width: 90px">{{ $t('common.status') }}</th>
                      <th style="width: 150px">{{ $t('common.actions') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="item in technicalDecisions"
                      :key="item.id"
                      :class="{
                        'table-active': editingTechnicalDecision.id === item.id,
                      }"
                    >
                      <td class="align-middle">
                        <span class="font-weight-bold">{{ item.name }}</span>
                      </td>
                      <td class="align-middle">
                        <b-badge
                          :variant="item.is_fixed ? 'secondary' : 'info'"
                        >
                          {{ item.is_fixed ? $t('nodeDisciplineConfig.technicalDecisions.systemBadge') : $t('nodeDisciplineConfig.technicalDecisions.customBadge') }}
                        </b-badge>
                      </td>
                      <td class="align-middle">
                        <b-badge
                          :variant="item.status ? 'success' : 'secondary'"
                        >
                          {{ item.status ? $t('common.active') : $t('common.inactive') }}
                        </b-badge>
                      </td>
                      <td class="align-middle" style="white-space: nowrap">
                        <b-button
                          size="sm"
                          :variant="
                            item.status ? 'outline-warning' : 'outline-success'
                          "
                          class="mr-50"
                          :title="item.status ? $t('nodeDisciplineConfig.technicalDecisions.deactivateTitle') : $t('nodeDisciplineConfig.flow.activate')"
                          v-if="$hasAbility('node.admin')"
                          @click="toggleTechnicalDecisionStatus(item)"
                        >
                          <feather-icon
                            :icon="item.status ? 'EyeOffIcon' : 'EyeIcon'"
                            size="13"
                          />
                        </b-button>
                        <template v-if="!item.is_fixed">
                          <b-button
                            size="sm"
                            variant="outline-primary"
                            class="mr-50"
                            :title="$t('common.edit')"
                            @click="editTechnicalDecision(item)"
                          >
                            <feather-icon icon="EditIcon" size="13" />
                          </b-button>
                          <b-button
                            size="sm"
                            variant="outline-danger"
                            :title="$t('common.delete')"
                            v-if="$hasAbility('node.admin')"
                            @click="deleteTechnicalDecision(item)"
                          >
                            <feather-icon icon="TrashIcon" size="13" />
                          </b-button>
                        </template>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </b-tab>


      <!-- ─── FORMULÁRIOS ──────────────────────────────────────────────── -->
      <b-tab :title="$t('nodeDisciplineConfig.tabs.forms')">
        <div class="row">
          <!-- Formulário de cadastro (Seção A: definições) -->
          <div class="col-md-4">
            <div class="card">
              <div class="card-header">
                <span class="card-title mb-0">
                  {{
                    editingFormDefinition.id
                      ? $t('nodeDisciplineConfig.forms.formTitleEdit')
                      : $t('nodeDisciplineConfig.forms.formTitleNew')
                  }}
                </span>
              </div>
              <div class="card-body">
                <div class="form-group">
                  <label><span class="required">*</span> {{ $t('nodeDisciplineConfig.fields.name') }}</label>
                  <input
                    v-model="editingFormDefinition.name"
                    type="text"
                    class="form-control"
                    :placeholder="$t('nodeDisciplineConfig.forms.namePlaceholder')"
                    maxlength="180"
                  />
                </div>
                <div class="form-group">
                  <label>{{ $t('nodeDisciplineConfig.fields.description') }}</label>
                  <textarea
                    v-model="editingFormDefinition.description"
                    class="form-control"
                    rows="2"
                    :placeholder="$t('nodeDisciplineConfig.fields.descriptionPlaceholder')"
                  />
                </div>
                <div class="form-group">
                  <label>{{ $t('nodeDisciplineConfig.fields.status') }}</label>
                  <select
                    v-model="editingFormDefinition.status"
                    class="form-control"
                  >
                    <option :value="true">{{ $t('nodeDisciplineConfig.forms.publishedOption') }}</option>
                    <option :value="false">{{ $t('nodeDisciplineConfig.forms.draftOption') }}</option>
                  </select>
                </div>
                <div class="d-flex">
                  <b-button
                    variant="primary"
                    class="mr-1"
                    v-if="$hasAbility('forms.admin')"
                    @click="saveFormDefinition"
                  >
                    <feather-icon icon="SaveIcon" size="14" class="mr-50" />
                    {{ editingFormDefinition.id ? $t('nodeDisciplineConfig.actions.update') : $t('common.add') }}
                  </b-button>
                  <b-button
                    v-if="editingFormDefinition.id"
                    variant="outline-secondary"
                    @click="cancelEditFormDefinition"
                  >
                    {{ $t('common.cancel') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>

          <!-- Lista de formulários -->
          <div class="col-md-8">
            <div class="card">
              <div
                class="card-header d-flex align-items-center justify-content-between"
              >
                <span class="card-title mb-0">{{ $t('nodeDisciplineConfig.forms.listTitle') }}</span>
                <small class="text-muted"
                  >{{ $t('nodeDisciplineConfig.forms.count', { count: formDefinitions.length }) }}</small
                >
              </div>
              <div class="card-body p-0">
                <div v-if="loadingFormDefinitions" class="text-center py-4">
                  <b-spinner variant="primary" />
                </div>
                <div
                  v-else-if="!formDefinitions.length"
                  class="text-center text-muted py-4"
                >
                  {{ $t('nodeDisciplineConfig.forms.emptyState') }}
                </div>
                <table v-else class="table table-hover mb-0">
                  <thead>
                    <tr>
                      <th style="width: 40px" />
                      <th>{{ $t('nodeDisciplineConfig.tableHeaders.name') }}</th>
                      <th>{{ $t('nodeDisciplineConfig.tableHeaders.description') }}</th>
                      <th style="width: 80px">{{ $t('common.status') }}</th>
                      <th style="width: 190px">{{ $t('common.actions') }}</th>
                    </tr>
                  </thead>
                  <draggable
                    v-model="orderedFormDefinitions"
                    tag="tbody"
                    handle=".drag-handle"
                    ghost-class="drag-ghost"
                    :disabled="!$hasAbility('forms.admin')"
                    @end="onFormDefinitionDragEnd"
                  >
                    <tr
                      v-for="item in orderedFormDefinitions"
                      :key="item.id"
                      :class="{
                        'table-active':
                          (selectedFormDefinition &&
                            selectedFormDefinition.id === item.id) ||
                          editingFormDefinition.id === item.id,
                      }"
                    >
                      <td
                        class="align-middle text-center drag-handle"
                        style="cursor: grab"
                      >
                        <feather-icon
                          icon="MenuIcon"
                          size="14"
                          class="text-muted"
                        />
                      </td>
                      <td class="align-middle">
                        <span class="font-weight-bold">{{ item.name }}</span>
                      </td>
                      <td class="align-middle">
                        <small class="text-muted">{{
                          (item.description || "").substring(0, 60)
                        }}</small>
                      </td>
                      <td class="align-middle">
                        <b-badge
                          :variant="item.status ? 'success' : 'secondary'"
                        >
                          {{ item.status ? $t('nodeDisciplineConfig.forms.publishedOption') : $t('nodeDisciplineConfig.forms.draftOption') }}
                        </b-badge>
                      </td>
                      <td class="align-middle" style="white-space: nowrap">
                        <b-button
                          v-if="$hasAbility('forms.admin')"
                          size="sm"
                          variant="primary"
                          class="mr-50"
                          :title="$t('nodeDisciplineConfig.forms.buildFieldsTitle')"
                          @click="goToFormBuilder(item)"
                        >
                          <feather-icon
                            icon="LayersIcon"
                            size="13"
                            class="mr-25"
                          />
                          {{ $t('nodeDisciplineConfig.forms.buildFieldsButton') }}
                        </b-button>
                        <b-button
                          size="sm"
                          variant="outline-secondary"
                          class="mr-50"
                          :title="$t('nodeDisciplineConfig.forms.assignmentsTitle')"
                          @click="selectFormDefinition(item)"
                        >
                          <feather-icon icon="UsersIcon" size="13" />
                        </b-button>
                        <b-button
                          size="sm"
                          variant="outline-primary"
                          class="mr-50"
                          :title="$t('nodeDisciplineConfig.forms.editBasicInfoTitle')"
                          @click="editFormDefinition(item)"
                        >
                          <feather-icon icon="EditIcon" size="13" />
                        </b-button>
                        <b-button
                          size="sm"
                          variant="outline-danger"
                          :title="$t('common.delete')"
                          v-if="$hasAbility('forms.admin')"
                          @click="deleteFormDefinition(item)"
                        >
                          <feather-icon icon="TrashIcon" size="13" />
                        </b-button>
                      </td>
                    </tr>
                  </draggable>
                </table>
              </div>
            </div>
          </div>
        </div>

        <!-- Seção C: associações — aparece ao clicar no botão de associações de um formulário -->
        <template v-if="selectedFormDefinition">
          <hr />

          <h6 class="dc-section-title mb-1">
            {{ $t('nodeDisciplineConfig.forms.assignmentsTitle') }}
          </h6>
          <div class="card">
            <div class="card-body">
              <div class="form-row align-items-end">
                <div class="form-group col-md-3">
                  <label>{{ $t('nodeDisciplineConfig.forms.disciplineLabel') }}</label>
                  <v-select
                    v-model="editingFormAssignment.discipline_id"
                    :options="allDisciplines"
                    :reduce="(d) => d.id"
                    label="name"
                    :placeholder="$t('nodeDisciplineConfig.forms.allOption')"
                    class="vselect"
                  />
                </div>
                <div class="form-group col-md-3">
                  <label>{{ $t('nodeDisciplineConfig.forms.involvedRoleLabel') }}</label>
                  <v-select
                    v-model="editingFormAssignment.involved_role_id"
                    :options="involvedRolesAll"
                    :reduce="(r) => r.id"
                    label="label"
                    :placeholder="$t('nodeDisciplineConfig.forms.allOption')"
                    class="vselect"
                  />
                </div>
                <div class="form-group col-md-2">
                  <label>{{ $t('nodeDisciplineConfig.forms.userRoleLabel') }}</label>
                  <v-select
                    v-model="editingFormAssignment.user_role_id"
                    :options="userRolesAll"
                    :reduce="(r) => r.id"
                    label="name"
                    :placeholder="$t('nodeDisciplineConfig.forms.allOption')"
                    class="vselect"
                  />
                </div>
                <div class="form-group col-md-2">
                  <label>{{ $t('nodeDisciplineConfig.forms.contextLabel') }}</label>
                  <select
                    v-model="editingFormAssignment.context"
                    class="form-control"
                  >
                    <option value="all">{{ $t('nodeDisciplineConfig.forms.allOption') }}</option>
                    <option value="web">Web</option>
                    <option value="app">App</option>
                  </select>
                </div>
                <div class="form-group col-md-1">
                  <b-form-checkbox
                    v-model="editingFormAssignment.status"
                    :value="1"
                    :unchecked-value="0"
                    switch
                  >
                    {{ $t('common.active') }}
                  </b-form-checkbox>
                </div>
                <div class="form-group col-md-1">
                  <b-button
                    variant="primary"
                    size="sm"
                    :title="$t('nodeDisciplineConfig.forms.addAssignmentTitle')"
                    v-if="$hasAbility('forms.admin')"
                    @click="saveFormAssignment"
                  >
                    <feather-icon icon="PlusIcon" size="14" />
                  </b-button>
                </div>
              </div>

              <div v-if="loadingFormAssignments" class="text-center py-3">
                <b-spinner variant="primary" />
              </div>
              <div
                v-else-if="!formAssignments.length"
                class="text-muted small mt-2"
              >
                {{ $t('nodeDisciplineConfig.forms.assignmentsEmptyState') }}
              </div>
              <table v-else class="table table-sm table-hover mb-0 mt-2">
                <thead>
                  <tr>
                    <th>{{ $t('nodeDisciplineConfig.forms.disciplineLabel') }}</th>
                    <th>{{ $t('nodeDisciplineConfig.forms.involvedRoleLabel') }}</th>
                    <th>{{ $t('nodeDisciplineConfig.forms.userRoleLabel') }}</th>
                    <th style="width: 80px">{{ $t('nodeDisciplineConfig.forms.contextLabel') }}</th>
                    <th style="width: 80px">{{ $t('common.status') }}</th>
                    <th style="width: 60px">{{ $t('common.actions') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="a in formAssignments" :key="a.id">
                    <td>{{ disciplineNameById(a.discipline_id) }}</td>
                    <td>{{ involvedRoleLabelById(a.involved_role_id) }}</td>
                    <td>{{ userRoleNameById(a.user_role_id) }}</td>
                    <td>{{ contextLabel(a.context) }}</td>
                    <td>
                      <b-badge :variant="a.status ? 'success' : 'secondary'">
                        {{ a.status ? $t('common.active') : $t('common.inactive') }}
                      </b-badge>
                    </td>
                    <td>
                      <b-button
                        size="sm"
                        variant="outline-danger"
                        :title="$t('common.delete')"
                        v-if="$hasAbility('forms.admin')"
                        @click="deleteFormAssignment(a)"
                      >
                        <feather-icon icon="TrashIcon" size="13" />
                      </b-button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </template>
      </b-tab>

      <b-tab :title="$t('nodeDisciplineConfig.tabs.businessRules')">
        <business-rules-tab
          :discipline-id="Number($route.params.disciplineId)"
        />
      </b-tab>

      <!-- ─── OUTRAS CONFIGURAÇÕES (última aba) ─────────────────── -->
      <b-tab :title="$t('nodeDisciplineConfig.tabs.otherSettings')">
        <div class="p-2">
          <div class="dc-other-grid">
          <div>
          <h6 class="dc-section-title mb-2">{{ $t('nodeDisciplineConfig.otherSettings.pinTitle') }}</h6>
          <div class="card">
            <div class="card-body">
              <p class="text-muted small mb-2">
                {{ $t('nodeDisciplineConfig.otherSettings.pinHint') }}
              </p>
              <div class="d-flex align-items-center" style="gap: 16px">
                <div>
                  <img
                    v-if="discipline.pin_icon"
                    :src="discipline.pin_icon"
                    style="
                      width: 64px;
                      height: 64px;
                      object-fit: contain;
                      border: 1px solid #ddd;
                      border-radius: 8px;
                    "
                  />
                  <pin-preview
                    v-else-if="discipline.pin_color"
                    :pin-style="{ color: discipline.pin_color, icon_class: discipline.pin_icon_class, icon_color: discipline.pin_icon_color, size: discipline.pin_size }"
                    :size="64"
                  />
                  <div
                    v-else
                    class="pin-empty-preview"
                    style="width: 64px; height: 64px; font-size: 11px"
                  >
                    {{ $t('nodeDisciplineConfig.pin.emptyLine1') }}<br />{{ $t('nodeDisciplineConfig.pin.emptyLine2') }}
                  </div>
                </div>
                <div>
                  <label
                    class="btn btn-sm btn-outline-primary mb-1"
                    style="cursor: pointer"
                  >
                    <feather-icon icon="UploadIcon" size="13" class="mr-25" />
                    {{ $t('nodeDisciplineConfig.otherSettings.uploadPinButton') }}
                    <input
                      type="file"
                      accept="image/*"
                      style="display: none"
                      @change="uploadDisciplinePin"
                    />
                  </label>
                  <br />
                  <a
                    v-if="discipline.pin_icon || discipline.pin_color"
                    href="#"
                    class="text-danger"
                    style="font-size: 0.78rem"
                    @click.prevent="removeDisciplinePin"
                    >{{ $t('nodeDisciplineConfig.pin.remove') }}</a
                  >
                </div>
              </div>
              <div v-if="$hasAbility('node.admin') && discipline.id" class="mt-3">
                <small class="text-muted d-block mb-50">{{ $t('pinStyle.title') }}</small>
                <pin-style-editor
                  :endpoint="`discipline/${discipline.id}/pin-style`"
                  :color="discipline.pin_color"
                  :icon-class="discipline.pin_icon_class"
                  :icon-color="discipline.pin_icon_color"
                  :size="discipline.pin_size"
                  @saved="onDisciplinePinStyleSaved"
                />
              </div>
            </div>
          </div>
          </div>
            <div>
              <h6 class="dc-section-title mb-2">{{ $t('nodeDisciplineConfig.otherSettings.entityTypesTitle') }}</h6>
              <div class="card">
                <div class="card-body">
                  <p class="text-muted small mb-2">
                    {{ $t('nodeDisciplineConfig.otherSettings.entityTypesHint') }}
                  </p>
                  <div v-if="loadingEntityTypes" class="text-muted small">
                    <b-spinner small /> {{ $t('nodeDisciplineConfig.otherSettings.loading') }}
                  </div>
                  <div v-else class="dc-card-fill">
                    <div
                      v-for="t in disciplineEntityTypes"
                      :key="t.id"
                      class="d-flex align-items-center justify-content-between mb-2"
                    >
                      <div class="custom-control custom-switch">
                        <input
                          :id="`det-${t.id}`"
                          v-model="t.enabled"
                          type="checkbox"
                          class="custom-control-input"
                        />
                        <label
                          class="custom-control-label"
                          :for="`det-${t.id}`"
                        >
                          {{ t.label }}
                        </label>
                      </div>
                      <button
                        v-if="$hasAbility('node.admin')"
                        type="button"
                        class="btn btn-sm btn-outline-secondary"
                        :title="$t('nodeDisciplineConfig.otherSettings.configureRolesTitle')"
                        @click="openRoleModal(t)"
                      >
                        <feather-icon icon="SettingsIcon" size="14" />
                      </button>
                    </div>

                    <button
                      type="button"
                      class="btn btn-sm btn-primary dc-card-action"
                      :disabled="savingEntityTypes"
                      v-if="$hasAbility('node.admin')"
                      @click="saveDisciplineEntityTypes"
                    >
                      <b-spinner v-if="savingEntityTypes" small class="mr-25" />
                      {{ $t('nodeDisciplineConfig.otherSettings.saveEntityTypesButton') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- "Códigos de envio" não é uma natureza de envolvido (não vem de
                 disciplineEntityTypes) — é uma feature à parte. Fica num bloco
                 separado ao lado pra não passar a impressão de que é mais uma
                 natureza (Pessoa, Veículo, etc). -->
            <div>
              <h6 class="dc-section-title mb-2">{{ $t('nodeDisciplineConfig.otherSettings.dispatchCodesTitle') }}</h6>
              <div class="card">
                <div class="card-body">
                  <p class="text-muted small mb-2">
                    {{ $t('nodeDisciplineConfig.otherSettings.dispatchCodesHint') }}
                  </p>
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    <div class="custom-control custom-switch">
                      <input
                        id="det-dispatch-codes"
                        v-model="dispatchCodesEnabled"
                        type="checkbox"
                        class="custom-control-input"
                        :disabled="savingDispatchCodesEnabled"
                        @change="saveDispatchCodesEnabled"
                      />
                      <label
                        class="custom-control-label"
                        for="det-dispatch-codes"
                      >
                        {{ $t('nodeDisciplineConfig.otherSettings.activatedLabel') }}
                      </label>
                    </div>
                    <button
                      v-if="$hasAbility('node.admin')"
                      type="button"
                      class="btn btn-sm btn-outline-secondary"
                      :title="$t('nodeDisciplineConfig.otherSettings.registerDispatchCodesTitle')"
                      @click="showDispatchCodesModal = true"
                    >
                      <feather-icon icon="SettingsIcon" size="14" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <hr />

          <h6 class="dc-section-title mb-2">{{ $t('nodeDisciplineConfig.stepAlerts.title') }}</h6>
          <div class="card">
            <div class="card-body">
              <p class="text-muted small mb-2">
                {{ $t('nodeDisciplineConfig.stepAlerts.hint') }}
              </p>

              <div v-if="loadingStepAlerts" class="text-muted small">
                <b-spinner small /> {{ $t('nodeDisciplineConfig.otherSettings.loading') }}
              </div>

              <div v-else-if="stepAlertsError" class="text-danger small">
                {{ stepAlertsError }}
                <a href="#" class="ml-50" @click.prevent="loadStepAlerts"
                  >{{ $t('nodeDisciplineConfig.stepAlerts.retry') }}</a
                >
              </div>

              <div v-else-if="!stepAlerts.length" class="text-muted small">
                {{ $t('nodeDisciplineConfig.stepAlerts.emptyState') }}
              </div>

              <div v-else>
                <table class="table table-sm mb-1">
                  <thead>
                    <tr>
                      <th>{{ $t('nodeDisciplineConfig.stepAlerts.stepHeader') }}</th>
                      <th style="width: 150px">
                        {{ $t('nodeDisciplineConfig.stepAlerts.warningHeader') }}
                        <span class="text-muted font-weight-normal"
                          >{{ $t('nodeDisciplineConfig.stepAlerts.secondsSuffix') }}</span
                        >
                      </th>
                      <th style="width: 150px">
                        {{ $t('nodeDisciplineConfig.stepAlerts.dangerHeader') }}
                        <span class="text-muted font-weight-normal"
                          >{{ $t('nodeDisciplineConfig.stepAlerts.secondsSuffix') }}</span
                        >
                      </th>
                      <th style="width: 190px">{{ $t('nodeDisciplineConfig.stepAlerts.operatorViewHeader') }}</th>
                      <th style="width: 130px" />
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="step in stepAlerts" :key="step.step_key">
                      <td class="align-middle">
                        {{ step.step_label }}
                        <small v-if="step.is_default" class="text-muted"
                          >{{ $t('nodeDisciplineConfig.stepAlerts.defaultSuffix') }}</small
                        >
                      </td>
                      <td>
                        <input
                          v-model.number="step.warning_seconds"
                          type="number"
                          min="5"
                          max="86400"
                          class="form-control form-control-sm"
                        />
                        <small class="text-muted">{{
                          humanSeconds(step.warning_seconds)
                        }}</small>
                      </td>
                      <td>
                        <input
                          v-model.number="step.danger_seconds"
                          type="number"
                          min="5"
                          max="86400"
                          class="form-control form-control-sm"
                        />
                        <small class="text-muted">{{
                          humanSeconds(step.danger_seconds)
                        }}</small>
                      </td>
                      <td class="align-middle">
                        <span
                          class="badge elapsed-badge elapsed-badge--warning mr-50"
                        >
                          {{ clockSeconds(step.warning_seconds) }}
                        </span>
                        <span class="badge elapsed-badge elapsed-badge--danger">
                          {{ clockSeconds(step.danger_seconds) }}
                        </span>
                      </td>
                      <td class="align-middle">
                        <a
                          href="#"
                          style="font-size: 0.78rem"
                          @click.prevent="restoreDefaultStepAlert(step)"
                          >{{ $t('nodeDisciplineConfig.stepAlerts.restoreDefault') }}</a
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>

                <button
                  v-if="$hasAbility('node.admin')"
                  type="button"
                  class="btn btn-sm btn-primary mt-1"
                  :disabled="savingStepAlerts"
                  @click="saveStepAlerts"
                >
                  <b-spinner v-if="savingStepAlerts" small class="mr-25" />
                  {{ $t('nodeDisciplineConfig.stepAlerts.saveButton') }}
                </button>
              </div>
            </div>
          </div>

          <template v-if="$hasAbility('supervisao.configurar_pausas')">
            <hr />

            <h6 class="dc-section-title mb-1">{{ $t('nodeDisciplineConfig.otherSettings.pausesTitle') }}</h6>
            <p class="text-muted small mb-2">
              {{ $t('nodeDisciplineConfig.otherSettings.pausesHint') }}
            </p>
            <pause-type-list :node-id="Number($route.params.nodeId)" />
          </template>
        </div>
      </b-tab>
    </b-tabs>

    <!-- Modal: papéis de uma natureza (habilitar + configurar abas) -->
    <b-modal
      v-model="showRoleModal"
      :title="roleModalTitle"
      size="lg"
      centered
      hide-footer
    >
      <div v-if="loadingDisciplineRoles" class="text-muted small">
        <b-spinner small /> {{ $t('nodeDisciplineConfig.otherSettings.loading') }}
      </div>
      <template v-else>
        <p class="text-muted small">
          {{ $t('nodeDisciplineConfig.roleModal.hint') }}
        </p>
        <div v-if="!rolesForModal.length" class="text-muted small py-2">
          {{ $t('nodeDisciplineConfig.roleModal.emptyState') }}
        </div>
        <div v-for="r in rolesForModal" :key="r.id" class="card mb-2">
          <div class="card-body py-2">
            <div class="custom-control custom-switch">
              <input
                :id="`mrole-${r.id}`"
                v-model="r.enabled"
                type="checkbox"
                class="custom-control-input"
              />
              <label class="custom-control-label" :for="`mrole-${r.id}`">
                <strong>{{ r.label }}</strong>
              </label>
            </div>
            <div v-if="r.enabled" class="mt-2 pl-2">
              <small class="text-muted d-block mb-1">{{ $t('nodeDisciplineConfig.roleModal.iconLabel') }}</small>
              <div class="d-flex align-items-center mb-2" style="gap: 12px">
                <div>
                  <img
                    v-if="r.icon"
                    :src="r.icon"
                    style="
                      width: 40px;
                      height: 40px;
                      object-fit: contain;
                      border: 1px solid #e0ddf5;
                      border-radius: 8px;
                    "
                  />
                  <span
                    v-else-if="r.icon_class"
                    class="d-inline-flex align-items-center justify-content-center"
                    style="width: 40px; height: 40px; font-size: 20px; border: 1px solid #e0ddf5; border-radius: 8px"
                  >
                    <i :class="r.icon_class" aria-hidden="true" />
                  </span>
                  <div v-else class="pin-empty-preview" style="width: 40px; height: 40px; font-size: 9px">
                    {{ $t('nodeDisciplineConfig.pin.emptyLine1') }}
                  </div>
                </div>
                <div>
                  <label
                    v-if="$hasAbility('node.admin')"
                    class="btn btn-sm btn-outline-primary mb-0"
                    style="cursor: pointer"
                  >
                    <feather-icon icon="UploadIcon" size="13" class="mr-25" />
                    {{ $t('nodeDisciplineConfig.pin.upload') }}
                    <input
                      type="file"
                      accept="image/*"
                      style="display: none"
                      @change="uploadRoleIconOverride($event, r)"
                    />
                  </label>
                  <button
                    v-if="$hasAbility('node.admin')"
                    type="button"
                    class="btn btn-sm btn-outline-secondary mb-0 ml-1"
                    @click="r.showIconSearch = !r.showIconSearch"
                  >
                    <feather-icon icon="SearchIcon" size="13" class="mr-25" />
                    {{ $t('nodeDisciplineConfig.roleModal.searchIconButton') }}
                  </button>
                  <br />
                  <a
                    v-if="(r.icon || r.icon_class) && $hasAbility('node.admin')"
                    href="#"
                    class="text-danger"
                    style="font-size: 0.78rem"
                    @click.prevent="removeRoleIconOverride(r)"
                  >
                    {{ $t('nodeDisciplineConfig.pin.remove') }}
                  </a>
                </div>
              </div>

              <div v-if="r.showIconSearch" class="mt-2 p-2" style="background: #f8f7fa; border-radius: 6px">
                <fa-icon-picker :value="r.icon_class" @select="selectRoleIconClass(r, $event)" />
              </div>

              <small class="text-muted d-block mb-1 mt-2">{{ $t('nodeDisciplineConfig.roleModal.displayedTabsLabel') }}</small>
              <div
                v-for="p in allPanels"
                :key="p.key"
                class="custom-control custom-checkbox custom-control-inline"
              >
                <input
                  :id="`mdrp-${r.id}-${p.key}`"
                  v-model="r.panelKeys"
                  type="checkbox"
                  class="custom-control-input"
                  :value="p.key"
                />
                <label
                  class="custom-control-label"
                  :for="`mdrp-${r.id}-${p.key}`"
                >
                  {{ p.label }}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-end mt-2">
          <button
            type="button"
            class="btn btn-sm btn-outline-secondary mr-1"
            @click="showRoleModal = false"
          >
            {{ $t('nodeDisciplineConfig.roleModal.closeButton') }}
          </button>
          <button
            type="button"
            class="btn btn-sm btn-primary"
            :disabled="savingDisciplineRoles"
            v-if="$hasAbility('node.admin')"
            @click="saveDisciplineRoles"
          >
            <b-spinner v-if="savingDisciplineRoles" small class="mr-25" />
            {{ $t('nodeDisciplineConfig.roleModal.saveRolesButton') }}
          </button>
        </div>
      </template>
    </b-modal>

    <!-- Modal: cadastro de códigos de envio -->
    <b-modal
      v-model="showDispatchCodesModal"
      :title="$t('nodeDisciplineConfig.otherSettings.dispatchCodesTitle')"
      size="lg"
      centered
      hide-footer
      body-class="dc-modal-body"
    >
      <p class="text-muted small mb-3">
        {{ $t('nodeDisciplineConfig.dispatchCodes.modalHint') }}
      </p>
      <div class="dc-form-row">
        <div class="dc-form-row__field">
          <label class="dc-form-row__label"
            ><span class="required">*</span> {{ $t('nodeDisciplineConfig.fields.codeHeader') }}</label
          >
          <input
            v-model="editingDispatchCode.code"
            type="text"
            class="form-control"
            :placeholder="$t('nodeDisciplineConfig.dispatchCodes.codePlaceholder')"
            maxlength="180"
          />
        </div>
        <div class="dc-form-row__field dc-form-row__field--status">
          <label class="dc-form-row__label">{{ $t('common.status') }}</label>
          <select v-model="editingDispatchCode.status" class="form-control">
            <option :value="1">{{ $t('common.active') }}</option>
            <option :value="0">{{ $t('common.inactive') }}</option>
          </select>
        </div>
        <div class="dc-form-row__actions">
          <b-button
            variant="primary"
            v-if="$hasAbility('node.admin')"
            @click="saveDispatchCode"
          >
            <feather-icon
              :icon="editingDispatchCode.id ? 'SaveIcon' : 'PlusIcon'"
              size="14"
              class="mr-50"
            />
            {{ editingDispatchCode.id ? $t('nodeDisciplineConfig.actions.update') : $t('common.add') }}
          </b-button>
          <b-button
            v-if="editingDispatchCode.id"
            variant="outline-secondary"
            @click="cancelEditDispatchCode"
          >
            {{ $t('common.cancel') }}
          </b-button>
        </div>
      </div>

      <hr class="my-3" />

      <div v-if="loadingDispatchCodes" class="text-center py-4">
        <b-spinner variant="primary" />
      </div>
      <div
        v-else-if="!dispatchCodes.length"
        class="text-center text-muted py-4"
      >
        <feather-icon icon="InboxIcon" size="24" class="mb-2 d-block mx-auto" />
        {{ $t('nodeDisciplineConfig.dispatchCodes.emptyState') }}
      </div>
      <div v-else class="dc-code-list">
        <div
          v-for="c in dispatchCodes"
          :key="c.id"
          class="dc-code-item"
          :class="{ 'dc-code-item--editing': editingDispatchCode.id === c.id }"
        >
          <span
            class="dc-code-item__dot"
            :class="
              c.status === 1
                ? 'dc-code-item__dot--active'
                : 'dc-code-item__dot--inactive'
            "
          />
          <span class="dc-code-item__code">{{ c.code }}</span>
          <span
            class="dc-code-item__badge"
            :class="
              c.status === 1
                ? 'dc-code-item__badge--active'
                : 'dc-code-item__badge--inactive'
            "
            >{{ c.status === 1 ? $t('common.active') : $t('common.inactive') }}</span
          >
          <div class="dc-code-item__actions">
            <button
              type="button"
              class="dc-code-item__btn"
              :title="$t('common.edit')"
              @click="editDispatchCode(c)"
            >
              <feather-icon icon="EditIcon" size="13" />
            </button>
            <button
              v-if="$hasAbility('node.admin')"
              type="button"
              class="dc-code-item__btn dc-code-item__btn--danger"
              :title="$t('common.delete')"
              @click="deleteDispatchCode(c)"
            >
              <feather-icon icon="TrashIcon" size="13" />
            </button>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- Modal: condições de pulo de etapa -->
    <b-modal
      id="modal-step-skips"
      :title="
        skipModal.step
          ? $t('nodeDisciplineConfig.skipModal.titleWithStep', { step: skipModal.step.step_label })
          : $t('nodeDisciplineConfig.skipModal.title')
      "
      :ok-title="$t('common.save')"
      :cancel-title="$t('common.cancel')"
      @ok="saveSkips"
    >
      <p class="text-muted small mb-1">
        {{ $t('nodeDisciplineConfig.skipModal.hint') }}
      </p>
      <b-form-group :label="$t('nodeDisciplineConfig.skipModal.typesLabel')">
        <v-select
          v-model="skipModal.selectedTypeIds"
          :options="dispatchTypes"
          :reduce="(t) => t.id"
          label="name"
          multiple
          :placeholder="$t('nodeDisciplineConfig.skipModal.selectTypesPlaceholder')"
        />
      </b-form-group>
      <b-form-group :label="$t('nodeDisciplineConfig.skipModal.reasonsLabel')">
        <v-select
          v-model="skipModal.selectedReasonIds"
          :options="dispatchReasons"
          :reduce="(r) => r.id"
          label="name"
          multiple
          :placeholder="$t('nodeDisciplineConfig.skipModal.selectReasonsPlaceholder')"
        />
      </b-form-group>
    </b-modal>

    <!-- Modal: configurar predecessores -->
    <b-modal
      id="modal-predecessors"
      :title="
        configuring
          ? $t('nodeDisciplineConfig.predecessorsModal.titleWithCode', { code: configuring.code, name: configuring.name })
          : $t('nodeDisciplineConfig.predecessorsModal.title')
      "
      :ok-title="$t('common.save')"
      :cancel-title="$t('common.cancel')"
      size="md"
      @ok="savePredecessors"
    >
      <p class="text-muted small mb-2">
        {{ $t('nodeDisciplineConfig.predecessorsModal.hintBefore') }}
        <strong>{{ $t('nodeDisciplineConfig.predecessorsModal.before') }}</strong>
        {{ $t('nodeDisciplineConfig.predecessorsModal.hintOf') }}
        <b-badge variant="primary">{{
          configuring ? configuring.code : ""
        }}</b-badge
        >. <br />{{ $t('nodeDisciplineConfig.predecessorsModal.hintEmpty') }}
      </p>
      <div class="form-group">
        <v-select
          v-model="selectedPredecessorIds"
          :options="availablePredecessors"
          :reduce="(t) => t.id"
          label="label"
          multiple
          :placeholder="$t('nodeDisciplineConfig.predecessorsModal.selectPlaceholder')"
          class="vselect"
        />
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  BTabs,
  BTab,
  BButton,
  BModal,
  BSpinner,
  BBadge,
  BFormCheckbox,
} from "bootstrap-vue";
import vSelect from "vue-select";
import draggable from "vuedraggable";
import swal from "sweetalert";
import BusinessRulesTab from "@/components/BusinessRulesTab.vue";
import FaIconPicker from "@/components/FaIconPicker.vue";
import PinPreview from "@/components/PinPreview.vue";
import PinStyleEditor from "@/components/PinStyleEditor.vue";
import PauseTypeList from "@/components/PauseTypeList.vue";
import { ELAPSED_DEFAULTS } from "@/mixins/ElapsedTimeMixin";
import ConfirmUnlinkDeleteMixin from "@/mixins/ConfirmUnlinkDeleteMixin";

export default {
  components: {
    FaIconPicker,
    PinPreview,
    PinStyleEditor,
    BTabs,
    BTab,
    BButton,
    BModal,
    BSpinner,
    BBadge,
    BFormCheckbox,
    vSelect,
    draggable,
    BusinessRulesTab,
    PauseTypeList,
  },

  mixins: [ConfirmUnlinkDeleteMixin],

  data() {
    return {
      node: {},
      discipline: {},

      // Naturezas de envolvido habilitadas nesta disciplina (nó+disciplina)
      disciplineEntityTypes: [],
      loadingEntityTypes: false,
      savingEntityTypes: false,

      stepAlerts: [],
      loadingStepAlerts: false,
      savingStepAlerts: false,
      stepAlertsError: null,

      // Papéis (catálogo global) habilitados + abas por papel, nesta disciplina
      disciplineRoles: [],
      allPanels: [],
      loadingDisciplineRoles: false,
      savingDisciplineRoles: false,
      // Modal de papéis por natureza (engrenagem)
      showRoleModal: false,
      roleModalNature: null,

      positions: [],
      loadingPositions: false,

      editingPosition: {
        code: "",
        name: "",
        description: "",
        order: 0,
        scope: "ocorrencia",
        free_access: false,
        display_kanban: false,
        allows_dispatch: true,
        is_default_position: false,
        releases_occurrence: false,
        marks_arrival: false,
        has_patient: false,
        allows_redirect: false,
        marks_base_arrival: false,
        allows_unboarding: true,
        display_panel: true,
        show_in_occurrence: true,
        panel_color: "#2563EB",
        status: 1,
      },

      // modal predecessores
      configuring: null,
      availablePredecessors: [],
      selectedPredecessorIds: [],

      // tipos de ocorrência
      dispatchTypes: [],
      loadingTypes: false,
      editingType: {
        name: "",
        description: "",
        status: 1,
        team_types: [],
      },

      // motivos
      dispatchReasons: [],
      loadingReasons: false,
      selectedTypeIdForReasons: null,
      editingReason: {
        dispatch_type_id: null,
        classification_id: null,
        name: "",
        description: "",
        status: 1,
        interrogatory_id: null,
        interrogatory_required: false,
        team_types: [],
      },

      // linhas de cuidado
      careLines: [],
      loadingCareLines: false,
      editingCareLine: {
        name: "",
        description: "",
        status: 1,
      },

      // interrogatórios
      interrogatories: [],
      loadingInterrogatories: false,
      editingInterrogatory: {
        name: "",
        description: "",
        status: 1,
        show_on_multiple_involveds: false,
        dispatch_type_id: null,
      },
      selectedInterrogatoryId: null,
      questions: [],
      loadingQuestions: false,
      questionMode: "add", // 'add' | 'edit'
      editingQuestion: {
        interrogatory_id: null,
        question: "",
        question_type: 2,
        required: false,
        next_question_id: null,
        order: 0,
        classification_id: null,
        status: 1,
      },
      editingAlternatives: [], // [{ label, next_question_id, classification_id, team_types: [] }]
      teamTypes: [], // tipos de equipe do tenant
      disciplineTeamTypes: [], // só os que têm equipe desta disciplina (sugestão do interrogatório)

      // desfechos
      outcomes: [],
      outcomeTypes: [],
      loadingOutcomes: false,
      editingOutcome: {
        name: "",
        description: "",
        is_prank_call: false,
        types: [],
      },

      // códigos de envio
      showDispatchCodesModal: false,
      dispatchCodesEnabled: false,
      savingDispatchCodesEnabled: false,
      dispatchCodes: [],
      loadingDispatchCodes: false,
      editingDispatchCode: {
        code: "",
        status: 1,
      },

      // classificações de risco
      classifications: [],
      loadingClassifications: false,
      editingClassification: {
        color_label: "",
        hex_color: "#FF0000",
        weight: 0,
        status: 1,
      },

      // fluxo de ocorrência
      flowSteps: [],
      skipModal: {
        step: null,
        selectedTypeIds: [],
        selectedReasonIds: [],
      },

      // intercorrências
      intercurrences: [],
      loadingIntercurrences: false,
      editingIntercurrence: { name: "", description: "", is_active: true },

      // decisões técnicas
      technicalDecisions: [],
      loadingTechnicalDecisions: false,
      editingTechnicalDecision: { name: "", status: 1 },

      // avaliação inicial
      assessmentQuestions: [],
      loadingAssessmentQuestions: false,
      editingAssessmentQuestion: {
        label: "",
        type: "single_select",
        order: 0,
        is_active: true,
      },
      editingAssessmentQuestionOptions: [],
      inlineOptionInput: "",

      // problemas
      problems: [],
      loadingProblems: false,
      editingProblem: { label: "", order: 0, is_active: true },

      // ── formulários (form builder) ──────────────────────────────────────
      // Seção A: definições de formulário (sem order — tabela não possui essa coluna)
      formDefinitions: [],
      loadingFormDefinitions: false,
      editingFormDefinition: { name: "", description: "", status: true },

      // Seção B (edição de campos) foi movida para a tela dedicada do Form
      // Builder — aqui só resta o estado do formulário selecionado, usado
      // para exibir a Seção C (associações) abaixo da lista.
      selectedFormDefinition: null,

      // Seção C: associações (form_assignments)
      formAssignments: [],
      loadingFormAssignments: false,
      editingFormAssignment: {
        discipline_id: null,
        involved_role_id: null,
        user_role_id: null,
        context: "all",
        status: 1,
      },
      allDisciplines: [], // catálogo de disciplinas do nó (picker "Disciplina" das associações)
      involvedRolesAll: [], // catálogo de papéis de envolvido (picker "Papel do envolvido")
      userRolesAll: [], // catálogo de papéis de usuário (picker "Papel de usuário")
    };
  },

  computed: {
    // Papéis da natureza selecionada na engrenagem (filtra o catálogo carregado).
    rolesForModal() {
      if (!this.roleModalNature) return [];
      return this.disciplineRoles.filter((r) =>
        (r.entity_types || []).includes(this.roleModalNature.code)
      );
    },
    roleModalTitle() {
      return this.roleModalNature
        ? this.$t('nodeDisciplineConfig.roleModal.titleWithNature', { nature: this.roleModalNature.label })
        : this.$t('nodeDisciplineConfig.roleModal.title');
    },
    positionsSorted() {
      return [...this.positions].sort(
        (a, b) => a.order - b.order || a.code.localeCompare(b.code)
      );
    },
    orderedPositions: {
      get() {
        return this.positionsSorted;
      },
      set(newOrder) {
        newOrder.forEach((pos, idx) => {
          const found = this.positions.find((p) => p.id === pos.id);
          if (found) found.order = idx;
        });
      },
    },
    orderedQuestions: {
      get() {
        return [...this.questions].sort(
          (a, b) => (a.order || 0) - (b.order || 0)
        );
      },
      set(newOrder) {
        newOrder.forEach((q, idx) => {
          const found = this.questions.find((x) => x.id === q.id);
          if (found) found.order = idx;
        });
      },
    },
    orderedAssessmentQuestions: {
      get() {
        return [...this.assessmentQuestions].sort(
          (a, b) => (a.order || 0) - (b.order || 0)
        );
      },
      set(newOrder) {
        newOrder.forEach((q, idx) => {
          const found = this.assessmentQuestions.find((x) => x.id === q.id);
          if (found) found.order = idx;
        });
      },
    },
    orderedProblems: {
      get() {
        return [...this.problems].sort(
          (a, b) => (a.order || 0) - (b.order || 0)
        );
      },
      set(newOrder) {
        newOrder.forEach((p, idx) => {
          const found = this.problems.find((x) => x.id === p.id);
          if (found) found.order = idx;
        });
      },
    },
    orderedFormDefinitions: {
      get() {
        return [...this.formDefinitions].sort(
          (a, b) => (a.order || 0) - (b.order || 0)
        );
      },
      set(newOrder) {
        newOrder.forEach((item, idx) => {
          const found = this.formDefinitions.find((x) => x.id === item.id);
          if (found) found.order = idx;
        });
      },
    },
    tenantId() {
      return this.$store.state.user ? this.$store.state.user.tenant_id : null;
    },
    filteredReasons() {
      if (!this.selectedTypeIdForReasons) return this.dispatchReasons;
      return this.dispatchReasons.filter(
        (r) => r.dispatch_type_id === this.selectedTypeIdForReasons
      );
    },
  },

  mounted() {
    this.loadAll();
  },

  methods: {
    typeNameById(typeId) {
      const t = this.dispatchTypes.find((t) => t.id === typeId);
      return t ? t.name : "-";
    },

    goBack() {
      this.$router.push(`/nodes/admin/${this.$route.params.nodeId}`);
    },

    // ── drag & drop ─────────────────────────────────────────────────────────

    onDragEnd() {
      // Persiste a nova ordem de todos os itens de uma vez
      const updates = this.orderedPositions.map((pos, idx) =>
        axios.post(`${this.$store.state.api}team_position_types/${pos.id}`, {
          ...pos,
          order: idx,
          _method: "PUT",
        })
      );
      Promise.all(updates)
        .then(() => this.loadPositions())
        .catch(() =>
          this.$message(this.$t('nodeDisciplineConfig.messages.errorTitle'), this.$t('nodeDisciplineConfig.messages.saveOrderFailed'), "error")
        );
    },

    // ── carregamentos ───────────────────────────────────────────────────────

    async loadAll() {
      const { nodeId, disciplineId } = this.$route.params;

      const [nodeRes, discRes] = await Promise.all([
        axios.get(`${this.$store.state.api}nodes/${nodeId}?with[]=type`),
        axios.get(`${this.$store.state.api}discipline/${disciplineId}`),
      ]);

      this.node = nodeRes.data.data[0];
      this.discipline = discRes.data.data[0];

      await Promise.all([this.loadPositions(), this.loadTypes(), this.loadTeamTypes()]);
      this.loadAllReasons();
      this.loadCareLines();
      this.loadInterrogatories();
      this.loadOutcomes();
      this.loadOutcomeTypes();
      this.loadClassifications();
      this.loadFlowSteps();
      this.loadIntercurrences();
      this.loadTechnicalDecisions();
      this.loadAssessmentQuestions();
      this.loadProblems();
      this.loadDisciplineEntityTypes();
      this.loadDisciplineRoles();
      this.loadFormDefinitions();
      this.loadDispatchCodesEnabled();
      this.loadDispatchCodes();
      this.loadStepAlerts();
    },

    // ── naturezas de envolvido por disciplina ───────────────────────────────

    async loadDisciplineEntityTypes() {
      // Config é por (tenant, disciplina); o tenant vem do usuário autenticado no backend.
      const { disciplineId } = this.$route.params;
      this.loadingEntityTypes = true;
      try {
        const res = await axios.get(
          `${this.$store.state.api}discipline_entity_types`,
          { params: { discipline_id: Number(disciplineId) } }
        );
        this.disciplineEntityTypes = (res.data.data || []).map((t) => ({
          ...t,
          enabled: !!t.enabled,
        }));
      } catch (e) {
        this.disciplineEntityTypes = [];
      } finally {
        this.loadingEntityTypes = false;
      }
    },

    async saveDisciplineEntityTypes() {
      const { disciplineId } = this.$route.params;
      this.savingEntityTypes = true;
      try {
        await axios.post(`${this.$store.state.api}discipline_entity_types`, {
          discipline_id: Number(disciplineId),
          entity_type_ids: this.disciplineEntityTypes
            .filter((t) => t.enabled)
            .map((t) => t.id),
        });
        this.$message(this.$t('nodeDisciplineConfig.messages.successTitle'), this.$t('nodeDisciplineConfig.messages.configSaved'), "success");
      } catch (e) {
        this.$message(this.$t('nodeDisciplineConfig.messages.errorTitle'), this.$t('nodeDisciplineConfig.messages.configSaveFailed'), "error");
      } finally {
        this.savingEntityTypes = false;
      }
    },

    // ── tempos de alerta do cronômetro ──────────────────────────────────────

    async loadStepAlerts() {
      const { nodeId, disciplineId } = this.$route.params;
      this.loadingStepAlerts = true;
      this.stepAlertsError = null;
      try {
        const res = await axios.get(
          `${this.$store.state.api}node_step_alerts`,
          {
            params: {
              node_id: Number(nodeId),
              discipline_id: Number(disciplineId),
            },
          }
        );
        this.stepAlerts = res.data.data || [];
      } catch (e) {
        this.stepAlerts = [];
        this.stepAlertsError = e.response?.status
          ? this.$t('nodeDisciplineConfig.stepAlerts.loadErrorWithStatus', { status: e.response.status })
          : this.$t('nodeDisciplineConfig.stepAlerts.loadError');
      } finally {
        this.loadingStepAlerts = false;
      }
    },

    humanSeconds(seconds) {
      const n = Number(seconds);
      if (!Number.isFinite(n) || n <= 0) return "—";
      const minutes = Math.floor(n / 60);
      const rest = n % 60;
      if (!minutes) return `${rest}s`;
      if (!rest) return `${minutes}min`;
      return `${minutes}min${rest}s`;
    },

    clockSeconds(seconds) {
      const n = Number(seconds);
      if (!Number.isFinite(n) || n < 0) return "--:--:--";
      const h = Math.floor(n / 3600);
      const m = Math.floor((n % 3600) / 60);
      const s = n % 60;
      return [h, m, s].map((v) => String(v).padStart(2, "0")).join(":");
    },

    restoreDefaultStepAlert(step) {
      step.warning_seconds = ELAPSED_DEFAULTS.warning;
      step.danger_seconds = ELAPSED_DEFAULTS.danger;
    },

    async saveStepAlerts() {
      const invalid = this.stepAlerts.find(
        (e) => e.danger_seconds <= e.warning_seconds
      );
      if (invalid) {
        this.$message(
          this.$t('nodeDisciplineConfig.messages.errorTitle'),
          this.$t('nodeDisciplineConfig.messages.dangerMustBeGreater', { step: invalid.step_label }),
          "error"
        );
        return;
      }

      const { nodeId, disciplineId } = this.$route.params;
      this.savingStepAlerts = true;
      try {
        const res = await axios.put(
          `${this.$store.state.api}node_step_alerts`,
          {
            node_id: Number(nodeId),
            discipline_id: Number(disciplineId),
            steps: this.stepAlerts.map((e) => ({
              step_key: e.step_key,
              warning_seconds: e.warning_seconds,
              danger_seconds: e.danger_seconds,
            })),
          }
        );
        this.stepAlerts = res.data.data || this.stepAlerts;
        this.$message(this.$t('nodeDisciplineConfig.messages.successTitle'), this.$t('nodeDisciplineConfig.messages.timesSaved'), "success");
      } catch (e) {
        this.$message(this.$t('nodeDisciplineConfig.messages.errorTitle'), this.$t('nodeDisciplineConfig.messages.timesSaveFailed'), "error");
      } finally {
        this.savingStepAlerts = false;
      }
    },

    // ── papéis e suas abas (catálogo global, habilitado por disciplina) ──────

    openRoleModal(nature) {
      this.roleModalNature = nature;
      this.showRoleModal = true;
      if (!this.disciplineRoles.length) this.loadDisciplineRoles();
    },

    async loadDisciplineRoles() {
      const { disciplineId } = this.$route.params;
      this.loadingDisciplineRoles = true;
      try {
        const [panelsRes, rolesRes] = await Promise.all([
          axios.get(`${this.$store.state.api}involved_panels`),
          axios.get(`${this.$store.state.api}discipline_roles`, {
            params: { discipline_id: Number(disciplineId) },
          }),
        ]);
        this.allPanels = panelsRes.data.data || [];
        this.disciplineRoles = (rolesRes.data.data || []).map((r) => ({
          ...r,
          enabled: !!r.enabled,
          // chaves dos painéis efetivos (override ou default), para os checkboxes
          panelKeys: (r.panels || []).map((p) => p.key),
          // seletor de ícone do catálogo — aberto/fechado por papel, dentro do modal
          showIconSearch: false,
        }));
      } catch (e) {
        this.allPanels = [];
        this.disciplineRoles = [];
      } finally {
        this.loadingDisciplineRoles = false;
      }
    },

    async saveDisciplineRoles() {
      const { disciplineId } = this.$route.params;
      const disc = Number(disciplineId);
      this.savingDisciplineRoles = true;
      try {
        const enabled = this.disciplineRoles.filter((r) => r.enabled);

        // 1) papéis habilitados
        await axios.post(`${this.$store.state.api}discipline_roles`, {
          discipline_id: disc,
          role_ids: enabled.map((r) => r.id),
        });

        // 2) abas de cada papel habilitado (na ordem do catálogo de painéis)
        await Promise.all(
          enabled.map((r) =>
            axios.post(`${this.$store.state.api}discipline_role_panels`, {
              discipline_id: disc,
              involved_role_id: r.id,
              panel_keys: this.allPanels
                .filter((p) => r.panelKeys.includes(p.key))
                .map((p) => p.key),
            })
          )
        );

        this.$message(this.$t('nodeDisciplineConfig.messages.successTitle'), this.$t('nodeDisciplineConfig.messages.rolesSaved'), "success");
        this.loadDisciplineRoles();
      } catch (e) {
        this.$message(this.$t('nodeDisciplineConfig.messages.errorTitle'), this.$t('nodeDisciplineConfig.messages.rolesSaveFailed'), "error");
      } finally {
        this.savingDisciplineRoles = false;
      }
    },

    async uploadRoleIconOverride(event, role) {
      const file = event.target.files[0];
      const { disciplineId } = this.$route.params;
      if (!file) return;
      const fd = new FormData();
      fd.append("pin", file);
      fd.append("discipline_id", Number(disciplineId));
      fd.append("involved_role_id", role.id);
      this.$loading(true);
      try {
        const r = await axios.post(`${this.$store.state.api}discipline_role_icons/pin`, fd);
        this.$set(role, "icon", r.data.pin_url);
        this.$set(role, "icon_class", null);
        this.$message(this.$t('nodeDisciplineConfig.messages.successTitle'), this.$t('nodeDisciplineConfig.messages.pinUpdated'), "success");
      } catch (e) {
        this.$message(null, this.$t('nodeDisciplineConfig.messages.pinUploadFailed'), "error");
      } finally {
        this.$loading(false);
        event.target.value = "";
      }
    },

    async removeRoleIconOverride(role) {
      const { disciplineId } = this.$route.params;
      this.$loading(true);
      try {
        await axios.delete(`${this.$store.state.api}discipline_role_icons/pin`, {
          data: { discipline_id: Number(disciplineId), involved_role_id: role.id },
        });
        this.$set(role, "icon", role.default_icon || null);
        this.$set(role, "icon_class", role.default_icon_class || null);
        this.$message(this.$t('nodeDisciplineConfig.messages.successTitle'), this.$t('nodeDisciplineConfig.messages.pinRemoved'), "success");
      } catch (e) {
        this.$message(null, this.$t('nodeDisciplineConfig.messages.pinRemoveFailed'), "error");
      } finally {
        this.$loading(false);
      }
    },

    async selectRoleIconClass(role, iconClass) {
      const { disciplineId } = this.$route.params;
      this.$loading(true);
      try {
        const r = await axios.post(`${this.$store.state.api}discipline_role_icons/icon-class`, {
          discipline_id: Number(disciplineId),
          involved_role_id: role.id,
          icon_class: iconClass,
        });
        this.$set(role, "icon", null);
        this.$set(role, "icon_class", r.data.icon_class);
        role.showIconSearch = false;
        this.$message(this.$t('nodeDisciplineConfig.messages.successTitle'), this.$t('nodeDisciplineConfig.messages.pinUpdated'), "success");
      } catch (e) {
        const msg = (e.response && typeof e.response.data === "string")
          ? e.response.data
          : this.$t('nodeDisciplineConfig.messages.pinUploadFailed');
        this.$message(null, msg, "error");
      } finally {
        this.$loading(false);
      }
    },

    // ── tipos de ocorrência ─────────────────────────────────────────────────

    loadTypes() {
      const { nodeId, disciplineId } = this.$route.params;
      this.loadingTypes = true;
      return axios
        .get(`${this.$store.state.api}dispatch_types/for-node`, {
          params: {
            discipline_id: disciplineId,
            node_id: nodeId,
            status: 1,
          },
        })
        .then((r) => {
          this.dispatchTypes = r.data.data || [];
        })
        .finally(() => {
          this.loadingTypes = false;
        });
    },

    cancelEditType() {
      this.editingType = {
        name: "", description: "", status: 1, team_types: [],
      };
    },

    editType(t) {
      this.editingType = {
        ...t,
        team_types: (t.team_types || []).map((tt) => ({ team_type_id: tt.id })),
      };
    },

    syncTypeTeamTypes(typeId, types) {
      if (!typeId) return Promise.resolve();
      return axios
        .post(`${this.$store.state.api}dispatch_types/${typeId}/sync-team-types`, {
          team_types: types.map((tt, idx) => ({
            team_type_id: tt.team_type_id,
            order: idx,
          })),
        })
        .catch(() => Promise.resolve());
    },

    saveType() {
      if (!this.editingType.name) {
        this.$message(this.$t('nodeDisciplineConfig.messages.warningTitle'), this.$t('nodeDisciplineConfig.messages.nameRequired'), "warning");
        return;
      }
      const { nodeId, disciplineId } = this.$route.params;
      const teamTypes = (this.editingType.team_types || []).filter((tt) => tt.team_type_id);
      const payload = {
        ...this.editingType,
        discipline_id: Number(disciplineId),
        node_id: Number(nodeId),
        description: this.editingType.description || null,
      };
      delete payload.team_types;
      let api = `${this.$store.state.api}dispatch_types`;
      if (payload.id) {
        payload._method = "PUT";
        api += `/${payload.id}`;
      }
      this.$loading(true);
      axios
        .post(api, payload)
        .then((r) => {
          const typeId = payload.id || (r.data.data ? r.data.data.id : r.data.id);
          return this.syncTypeTeamTypes(typeId, teamTypes);
        })
        .then(() => {
          this.$message(this.$t('nodeDisciplineConfig.messages.successTitle'), this.$t('nodeDisciplineConfig.messages.typeSaved'), "success");
          this.cancelEditType();
          this.loadTypes();
        })
        .catch((e) => this.$message(null, e.response?.data, "error"))
        .finally(() => this.$loading(false));
    },

    // O pin é imagem enviada OU cor + ícone: gravar um limpa o outro, na tela e na lista.
    applyTypePin(pin) {
      const idx = this.dispatchTypes.findIndex((t) => t.id === this.editingType.id);
      Object.keys(pin).forEach((field) => {
        this.$set(this.editingType, field, pin[field]);
        if (idx !== -1) this.$set(this.dispatchTypes[idx], field, pin[field]);
      });
    },

    onTypePinStyleSaved(style) {
      this.applyTypePin({
        pin_icon: null,
        pin_color: style.pin_color,
        pin_icon_class: style.pin_icon_class,
        pin_icon_color: style.pin_icon_color,
        pin_size: style.pin_size,
      });
    },

    applyDisciplinePin(pin) {
      Object.keys(pin).forEach((field) => this.$set(this.discipline, field, pin[field]));
    },

    onDisciplinePinStyleSaved(style) {
      this.applyDisciplinePin({
        pin_icon: null,
        pin_color: style.pin_color,
        pin_icon_class: style.pin_icon_class,
        pin_icon_color: style.pin_icon_color,
        pin_size: style.pin_size,
      });
    },

    async uploadTypePin(event) {
      const file = event.target.files[0];
      if (!file || !this.editingType.id) return;
      const fd = new FormData();
      fd.append("pin", file);
      this.$loading(true);
      try {
        const r = await axios.post(
          `${this.$store.state.api}dispatch_types/${this.editingType.id}/pin`,
          fd
        );
        this.applyTypePin({ pin_icon: r.data.pin_url, pin_color: null, pin_icon_class: null, pin_icon_color: null, pin_size: null });
        this.$message(this.$t('nodeDisciplineConfig.messages.successTitle'), this.$t('nodeDisciplineConfig.messages.pinUpdated'), "success");
      } catch (e) {
        this.$message(null, this.$t('nodeDisciplineConfig.messages.pinUploadFailed'), "error");
      } finally {
        this.$loading(false);
        event.target.value = "";
      }
    },

    async removeTypePin() {
      if (!this.editingType.id) return;
      this.$loading(true);
      try {
        await axios.delete(
          `${this.$store.state.api}dispatch_types/${this.editingType.id}/pin`
        );
        this.applyTypePin({ pin_icon: null, pin_color: null, pin_icon_class: null, pin_icon_color: null, pin_size: null });
        this.$message(this.$t('nodeDisciplineConfig.messages.successTitle'), this.$t('nodeDisciplineConfig.messages.pinRemoved'), "success");
      } catch (e) {
        this.$message(null, this.$t('nodeDisciplineConfig.messages.pinRemoveFailed'), "error");
      } finally {
        this.$loading(false);
      }
    },

    async uploadDisciplinePin(event) {
      const file = event.target.files[0];
      if (!file || !this.discipline.id) return;
      const fd = new FormData();
      fd.append("pin", file);
      this.$loading(true);
      try {
        const r = await axios.post(
          `${this.$store.state.api}discipline/${this.discipline.id}/pin`,
          fd
        );
        this.applyDisciplinePin({ pin_icon: r.data.pin_url, pin_color: null, pin_icon_class: null, pin_icon_color: null, pin_size: null });
        this.$message(this.$t('nodeDisciplineConfig.messages.successTitle'), this.$t('nodeDisciplineConfig.messages.disciplinePinUpdated'), "success");
      } catch (e) {
        this.$message(null, this.$t('nodeDisciplineConfig.messages.pinUploadFailed'), "error");
      } finally {
        this.$loading(false);
        event.target.value = "";
      }
    },

    async removeDisciplinePin() {
      if (!this.discipline.id) return;
      this.$loading(true);
      try {
        await axios.delete(
          `${this.$store.state.api}discipline/${this.discipline.id}/pin`
        );
        this.applyDisciplinePin({ pin_icon: null, pin_color: null, pin_icon_class: null, pin_icon_color: null, pin_size: null });
        this.$message(this.$t('nodeDisciplineConfig.messages.successTitle'), this.$t('nodeDisciplineConfig.messages.disciplinePinRemoved'), "success");
      } catch (e) {
        this.$message(null, this.$t('nodeDisciplineConfig.messages.pinRemoveFailed'), "error");
      } finally {
        this.$loading(false);
      }
    },

    deleteType(t) {
      this.deleteConfirmingUnlink({
        url: `${this.$store.state.api}dispatch_types/${t.id}`,
        name: t.name,
        successMessage: this.$t('nodeDisciplineConfig.messages.typeDeleted'),
        onDeleted: () => this.loadTypes(),
      });
    },

    // ── linhas de cuidado ──────────────────────────────────────────────────

    loadCareLines() {
      const { nodeId, disciplineId } = this.$route.params;
      this.loadingCareLines = true;
      return axios
        .get(`${this.$store.state.api}care_lines/for-node`, {
          params: {
            discipline_id: disciplineId,
            node_id: nodeId,
          },
        })
        .then((r) => {
          this.careLines = r.data.data || [];
        })
        .finally(() => {
          this.loadingCareLines = false;
        });
    },

    cancelEditCareLine() {
      this.editingCareLine = { name: "", description: "", status: 1 };
    },

    editCareLine(cl) {
      this.editingCareLine = { ...cl };
    },

    saveCareLine() {
      if (!this.editingCareLine.name) {
        this.$message(this.$t('nodeDisciplineConfig.messages.warningTitle'), this.$t('nodeDisciplineConfig.messages.nameRequired'), "warning");
        return;
      }
      const { nodeId, disciplineId } = this.$route.params;
      const payload = {
        ...this.editingCareLine,
        discipline_id: Number(disciplineId),
        node_id: Number(nodeId),
        description: this.editingCareLine.description || null,
      };
      let api = `${this.$store.state.api}care_lines`;
      if (payload.id) {
        payload._method = "PUT";
        api += `/${payload.id}`;
      }
      this.sendCareLine(api, payload);
    },

    async sendCareLine(api, payload) {
      this.$loading(true);
      try {
        await axios.post(api, payload);
        this.$message(
          this.$t('nodeDisciplineConfig.messages.successTitle'),
          this.$t('nodeDisciplineConfig.messages.careLineSaved'),
          "success"
        );
        this.cancelEditCareLine();
        this.loadCareLines();
      } catch (e) {
        const data = (e.response && e.response.data) || {};
        const needsConfirm = e.response
          && e.response.status === 409
          && Array.isArray(data.establishments)
          && !payload.confirm_inactivate;

        if (!needsConfirm) {
          this.$message(null, data.message || data, "error");
          return;
        }

        this.$loading(false);
        const lista = data.establishments.map((est) => `• ${est.name}`).join("\n");
        const ok = await swal({
          title: this.$t('nodeDisciplineConfig.careLines.inactivateConfirmTitle', { name: payload.name }),
          text: this.$t('nodeDisciplineConfig.careLines.inactivateConfirmText', { list: lista }),
          icon: "warning",
          buttons: [this.$t('common.cancel'), this.$t('nodeDisciplineConfig.careLines.inactivateButton')],
          dangerMode: true,
        });
        if (ok) await this.sendCareLine(api, { ...payload, confirm_inactivate: 1 });
      } finally {
        this.$loading(false);
      }
    },

    deleteCareLine(cl) {
      this.deleteConfirmingUnlink({
        url: `${this.$store.state.api}care_lines/${cl.id}`,
        name: cl.name,
        successMessage: this.$t('nodeDisciplineConfig.messages.careLineDeleted'),
        onDeleted: () => this.loadCareLines(),
      });
    },

    // ── motivos ─────────────────────────────────────────────────────────────

    onReasonTypeChange(typeId) {
      this.cancelEditReason();
      this.editingReason.dispatch_type_id = typeId || null;
    },

    loadAllReasons() {
      // Carrega todos os motivos dos tipos desta disciplina: próprios do nó
      // e herdados de acima. Nunca os cadastrados nos nós abaixo.
      if (!this.dispatchTypes.length) return;
      const { nodeId } = this.$route.params;
      const typeIds = this.dispatchTypes.map((t) => t.id);
      this.loadingReasons = true;
      const requests = typeIds.map((id) =>
        axios.get(`${this.$store.state.api}dispatch_reasons/for-node`, {
          params: {
            dispatch_type_id: id,
            node_id: nodeId,
          },
        })
      );
      Promise.all(requests)
        .then((responses) => {
          this.dispatchReasons = responses.flatMap((r) => r.data.data || []);
        })
        .finally(() => {
          this.loadingReasons = false;
        });
    },

    loadReasons(typeId) {
      // Recarrega motivos após salvar/excluir, mantendo o mesmo conjunto completo
      this.loadAllReasons();
    },

    cancelEditReason() {
      this.editingReason = {
        dispatch_type_id: this.selectedTypeIdForReasons,
        classification_id: null,
        name: "",
        description: "",
        status: 1,
        interrogatory_id: null,
        interrogatory_required: false,
        team_types: [],
      };
    },

    editReason(r) {
      this.editingReason = {
        ...r,
        team_types: (r.team_types || []).map((tt) => ({ team_type_id: tt.id })),
      };
    },

    syncReasonTeamTypes(reasonId, types) {
      if (!reasonId) return Promise.resolve();
      return axios
        .post(`${this.$store.state.api}dispatch_reasons/${reasonId}/sync-team-types`, {
          team_types: types.map((tt, idx) => ({
            team_type_id: tt.team_type_id,
            order: idx,
          })),
        })
        .catch(() => Promise.resolve());
    },

    saveReason() {
      if (!this.editingReason.name || !this.editingReason.dispatch_type_id) {
        this.$message(this.$t('nodeDisciplineConfig.messages.warningTitle'), this.$t('nodeDisciplineConfig.messages.nameAndTypeRequired'), "warning");
        return;
      }
      if (!this.editingReason.classification_id) {
        this.$message(this.$t('nodeDisciplineConfig.messages.warningTitle'), this.$t('nodeDisciplineConfig.messages.classificationRequired'), "warning");
        return;
      }
      const { nodeId } = this.$route.params;
      const teamTypes = (this.editingReason.team_types || []).filter((tt) => tt.team_type_id);
      const payload = {
        ...this.editingReason,
        node_id: Number(nodeId),
        description: this.editingReason.description || "",
      };
      delete payload.team_types;
      let api = `${this.$store.state.api}dispatch_reasons`;
      if (payload.id) {
        payload._method = "PUT";
        api += `/${payload.id}`;
      }
      this.$loading(true);
      axios
        .post(api, payload)
        .then((r) => {
          const reasonId = payload.id || (r.data.data ? r.data.data.id : r.data.id);
          return this.syncReasonTeamTypes(reasonId, teamTypes);
        })
        .then(() => {
          this.$message(this.$t('nodeDisciplineConfig.messages.successTitle'), this.$t('nodeDisciplineConfig.messages.reasonSaved'), "success");
          this.cancelEditReason();
          this.loadReasons(this.selectedTypeIdForReasons);
        })
        .catch((e) => this.$message(null, e.response?.data, "error"))
        .finally(() => this.$loading(false));
    },

    deleteReason(r) {
      this.deleteConfirmingUnlink({
        url: `${this.$store.state.api}dispatch_reasons/${r.id}`,
        name: r.name,
        successMessage: this.$t('nodeDisciplineConfig.messages.reasonDeleted'),
        onDeleted: () => this.loadReasons(this.selectedTypeIdForReasons),
      });
    },

    // ── códigos de envio ────────────────────────────────────────────────────

    loadDispatchCodesEnabled() {
      // Config é por (tenant, disciplina), igual naturezas de envolvido.
      const { disciplineId } = this.$route.params;
      return axios
        .get(`${this.$store.state.api}discipline_dispatch_code_settings`, {
          params: { discipline_id: Number(disciplineId) },
        })
        .then((r) => {
          this.dispatchCodesEnabled = !!(r.data.data && r.data.data.enabled);
        })
        .catch(() => {
          this.dispatchCodesEnabled = false;
        });
    },

    saveDispatchCodesEnabled() {
      const { disciplineId } = this.$route.params;
      this.savingDispatchCodesEnabled = true;
      axios
        .post(`${this.$store.state.api}discipline_dispatch_code_settings`, {
          discipline_id: Number(disciplineId),
          enabled: this.dispatchCodesEnabled,
        })
        .then(() => {
          this.$message(this.$t('nodeDisciplineConfig.messages.successTitle'), this.$t('nodeDisciplineConfig.messages.configSaved'), "success");
        })
        .catch((e) => {
          this.dispatchCodesEnabled = !this.dispatchCodesEnabled;
          this.$message(null, e.response?.data, "error");
        })
        .finally(() => {
          this.savingDispatchCodesEnabled = false;
        });
    },

    loadDispatchCodes() {
      const { disciplineId } = this.$route.params;
      this.loadingDispatchCodes = true;
      return axios
        .get(`${this.$store.state.api}dispatch_codes`, {
          params: { discipline_id: Number(disciplineId) },
        })
        .then((r) => {
          this.dispatchCodes = r.data.data || [];
        })
        .finally(() => {
          this.loadingDispatchCodes = false;
        });
    },

    cancelEditDispatchCode() {
      this.editingDispatchCode = { code: "", status: 1 };
    },

    editDispatchCode(c) {
      this.editingDispatchCode = { ...c };
    },

    saveDispatchCode() {
      if (!this.editingDispatchCode.code) {
        this.$message(this.$t('nodeDisciplineConfig.messages.warningTitle'), this.$t('nodeDisciplineConfig.messages.codeRequired'), "warning");
        return;
      }
      const disciplineId = Number(this.$route.params.disciplineId);
      const payload = {
        code: this.editingDispatchCode.code,
        status: this.editingDispatchCode.status,
        discipline_id: disciplineId,
      };
      let api = `${this.$store.state.api}dispatch_codes`;
      if (this.editingDispatchCode.id) {
        payload._method = "PUT";
        api += `/${this.editingDispatchCode.id}`;
      }
      this.$loading(true);
      axios
        .post(api, payload)
        .then(() => {
          this.$message(
            this.$t('nodeDisciplineConfig.messages.successTitle'),
            this.$t('nodeDisciplineConfig.messages.dispatchCodeSaved'),
            "success"
          );
          this.cancelEditDispatchCode();
          this.loadDispatchCodes();
        })
        .catch((e) => this.$message(null, e.response?.data, "error"))
        .finally(() => this.$loading(false));
    },

    deleteDispatchCode(c) {
      swal({
        title: this.$t('nodeDisciplineConfig.messages.deleteConfirmTitle', { name: c.code }),
        text: this.$t('nodeDisciplineConfig.messages.actionCannotBeUndone'),
        icon: "warning",
        buttons: [this.$t('common.cancel'), this.$t('common.delete')],
        dangerMode: true,
      }).then((confirmed) => {
        if (!confirmed) return;
        this.$loading(true);
        axios
          .delete(`${this.$store.state.api}dispatch_codes/${c.id}`)
          .then(() => {
            this.$message(this.$t('nodeDisciplineConfig.messages.successTitle'), this.$t('nodeDisciplineConfig.messages.dispatchCodeDeleted'), "success");
            this.loadDispatchCodes();
          })
          .catch((e) => this.$message(null, e.response?.data, "error"))
          .finally(() => this.$loading(false));
      });
    },

    // ── desfechos ────────────────────────────────────────────────────────────

    loadOutcomes() {
      const { disciplineId } = this.$route.params;
      this.loadingOutcomes = true;
      return axios
        .get(
          `${this.$store.state.api}outcomes?paginated=false&discipline_id=${disciplineId}&with[]=types`
        )
        .then((r) => {
          this.outcomes = r.data.data || [];
        })
        .finally(() => {
          this.loadingOutcomes = false;
        });
    },

    loadOutcomeTypes() {
      return axios
        .get(`${this.$store.state.api}outcome_types?paginated=false`)
        .then((r) => {
          this.outcomeTypes = r.data.data || [];
        });
    },

    cancelEditOutcome() {
      this.editingOutcome = {
        name: "",
        description: "",
        is_prank_call: false,
        types: [],
      };
    },

    editOutcome(oc) {
      this.editingOutcome = {
        ...oc,
        types: (oc.types || []).map((t) => t.id),
      };
    },

    saveOutcome() {
      if (!this.editingOutcome.name) {
        this.$message(this.$t('nodeDisciplineConfig.messages.warningTitle'), this.$t('nodeDisciplineConfig.messages.nameRequired'), "warning");
        return;
      }
      const disciplineId = Number(this.$route.params.disciplineId);
      const payload = {
        name: this.editingOutcome.name,
        description: this.editingOutcome.description || null,
        is_prank_call: !!this.editingOutcome.is_prank_call,
        discipline_id: disciplineId,
        types: this.editingOutcome.types || [],
      };
      let api = `${this.$store.state.api}outcomes`;
      if (this.editingOutcome.id) {
        payload._method = "PUT";
        api += `/${this.editingOutcome.id}`;
      }
      this.$loading(true);
      axios
        .post(api, payload)
        .then(() => {
          this.$message(this.$t('nodeDisciplineConfig.messages.successTitle'), this.$t('nodeDisciplineConfig.messages.outcomeSaved'), "success");
          this.cancelEditOutcome();
          this.loadOutcomes();
        })
        .catch((e) => this.$message(null, e.response?.data, "error"))
        .finally(() => this.$loading(false));
    },

    deleteOutcome(oc) {
      swal({
        title: this.$t('nodeDisciplineConfig.messages.deleteConfirmTitle', { name: oc.name }),
        text: this.$t('nodeDisciplineConfig.messages.actionCannotBeUndone'),
        icon: "warning",
        buttons: [this.$t('common.cancel'), this.$t('common.delete')],
        dangerMode: true,
      }).then((confirmed) => {
        if (!confirmed) return;
        this.$loading(true);
        axios
          .delete(`${this.$store.state.api}outcomes/${oc.id}`)
          .then(() => {
            this.$message(this.$t('nodeDisciplineConfig.messages.successTitle'), this.$t('nodeDisciplineConfig.messages.outcomeDeleted'), "success");
            this.loadOutcomes();
          })
          .catch((e) => this.$message(null, e.response?.data, "error"))
          .finally(() => this.$loading(false));
      });
    },

    // ── classificações de risco ─────────────────────────────────────────────

    loadClassifications() {
      const { nodeId, disciplineId } = this.$route.params;
      this.loadingClassifications = true;
      return axios
        .get(
          `${this.$store.state.api}classifications?node_id=${nodeId}&discipline_id=${disciplineId}`
        )
        .then((r) => {
          this.classifications = r.data.data || [];
        })
        .finally(() => {
          this.loadingClassifications = false;
        });
    },

    cancelEditClassification() {
      this.editingClassification = {
        color_label: "",
        hex_color: "#FF0000",
        weight: 0,
        status: 1,
      };
    },

    editClassification(c) {
      this.editingClassification = { ...c };
    },

    saveClassification() {
      const c = this.editingClassification;
      if (!c.color_label || !c.hex_color) {
        this.$message(this.$t('nodeDisciplineConfig.messages.warningTitle'), this.$t('nodeDisciplineConfig.messages.labelAndColorRequired'), "warning");
        return;
      }
      if (!/^#[0-9A-Fa-f]{6}$/.test(c.hex_color)) {
        this.$message(
          this.$t('nodeDisciplineConfig.messages.warningTitle'),
          this.$t('nodeDisciplineConfig.messages.colorFormatInvalid'),
          "warning"
        );
        return;
      }
      const { nodeId, disciplineId } = this.$route.params;
      const payload = {
        ...c,
        node_id: Number(nodeId),
        discipline_id: Number(disciplineId),
      };
      let api = `${this.$store.state.api}classifications`;
      if (payload.id) {
        payload._method = "PUT";
        api += `/${payload.id}`;
      }
      this.$loading(true);
      axios
        .post(api, payload)
        .then(() => {
          this.$message(
            this.$t('nodeDisciplineConfig.messages.successTitle'),
            this.$t('nodeDisciplineConfig.messages.classificationSaved'),
            "success"
          );
          this.cancelEditClassification();
          this.loadClassifications();
        })
        .catch((e) => this.$message(null, e.response?.data, "error"))
        .finally(() => this.$loading(false));
    },

    deleteClassification(c) {
      swal({
        title: this.$t('nodeDisciplineConfig.messages.deleteConfirmTitle', { name: c.name }),
        text: this.$t('nodeDisciplineConfig.messages.actionCannotBeUndone'),
        icon: "warning",
        buttons: [this.$t('common.cancel'), this.$t('common.delete')],
        dangerMode: true,
      }).then((confirmed) => {
        if (!confirmed) return;
        this.$loading(true);
        axios
          .delete(`${this.$store.state.api}classifications/${c.id}`)
          .then(() => {
            this.$message(this.$t('nodeDisciplineConfig.messages.successTitle'), this.$t('nodeDisciplineConfig.messages.classificationDeleted'), "success");
            this.loadClassifications();
          })
          .catch((e) => this.$message(null, e.response?.data, "error"))
          .finally(() => this.$loading(false));
      });
    },

    // ── interrogatórios ─────────────────────────────────────────────────────

    loadInterrogatories() {
      const { disciplineId } = this.$route.params;
      this.loadingInterrogatories = true;
      return axios
        .get(
          `${this.$store.state.api}interrogatories?paginated=false&discipline_id=${disciplineId}`
        )
        .then((r) => {
          this.interrogatories = r.data.data || [];
        })
        .finally(() => {
          this.loadingInterrogatories = false;
        });
    },

    cancelEditInterrogatory() {
      this.editingInterrogatory = {
        name: "",
        description: "",
        status: 1,
        show_on_multiple_involveds: false,
        dispatch_type_id: null,
      };
    },

    editInterrogatory(item) {
      this.editingInterrogatory = { ...item };
      this.selectInterrogatory(item);
    },

    onShowOnMultipleInvolvedsChange(checked) {
      if (!checked) this.editingInterrogatory.dispatch_type_id = null;
    },

    saveInterrogatory() {
      if (!this.editingInterrogatory.name) {
        this.$message(this.$t('nodeDisciplineConfig.messages.warningTitle'), this.$t('nodeDisciplineConfig.messages.nameRequired'), "warning");
        return;
      }
      if (this.editingInterrogatory.show_on_multiple_involveds && !this.editingInterrogatory.dispatch_type_id) {
        this.$message(this.$t('nodeDisciplineConfig.messages.warningTitle'), this.$t('nodeDisciplineConfig.interrogatories.dispatchTypeRequired'), "warning");
        return;
      }
      const disciplineId = Number(this.$route.params.disciplineId);
      const payload = {
        ...this.editingInterrogatory,
        discipline_id: disciplineId,
        tenant_id: this.tenantId,
        description: this.editingInterrogatory.description || "",
      };
      let api = `${this.$store.state.api}interrogatories`;
      if (payload.id) {
        payload._method = "PUT";
        api += `/${payload.id}`;
      }
      this.$loading(true);
      axios
        .post(api, payload)
        .then(() => {
          this.$message(this.$t('nodeDisciplineConfig.messages.successTitle'), this.$t('nodeDisciplineConfig.messages.interrogatorySaved'), "success");
          this.cancelEditInterrogatory();
          this.loadInterrogatories();
        })
        .catch((e) => this.$message(null, e.response?.data, "error"))
        .finally(() => this.$loading(false));
    },

    deleteInterrogatory(item) {
      swal({
        title: this.$t('nodeDisciplineConfig.messages.deleteConfirmTitle', { name: item.name }),
        text: this.$t('nodeDisciplineConfig.messages.actionCannotBeUndone'),
        icon: "warning",
        buttons: [this.$t('common.cancel'), this.$t('common.delete')],
        dangerMode: true,
      }).then((confirmed) => {
        if (!confirmed) return;
        this.$loading(true);
        axios
          .delete(`${this.$store.state.api}interrogatories/${item.id}`)
          .then(() => {
            this.$message(this.$t('nodeDisciplineConfig.messages.successTitle'), this.$t('nodeDisciplineConfig.messages.interrogatoryDeleted'), "success");
            if (this.selectedInterrogatoryId === item.id) {
              this.selectedInterrogatoryId = null;
              this.questions = [];
            }
            this.loadInterrogatories();
          })
          .catch((e) => this.$message(null, e.response?.data, "error"))
          .finally(() => this.$loading(false));
      });
    },

    // ── perguntas ────────────────────────────────────────────────────────────

    selectInterrogatory(item) {
      this.selectedInterrogatoryId = item.id;
      this.cancelEditQuestion();
      this.loadQuestions(item.id);
      this.loadTeamTypes();
    },

    loadQuestions(interrogatoryId) {
      this.loadingQuestions = true;
      return axios
        .get(
          `${this.$store.state.api}interrogatory_questions?paginated=false&interrogatory_id=${interrogatoryId}&with[]=alternatives&with[]=alternatives.teamTypes&with[]=teamTypes`
        )
        .then((r) => {
          this.questions = r.data.data || [];
        })
        .finally(() => {
          this.loadingQuestions = false;
        });
    },

    cancelEditQuestion() {
      this.questionMode = "add";
      this.editingQuestion = {
        interrogatory_id: this.selectedInterrogatoryId,
        question: "",
        question_type: 2,
        required: false,
        next_question_id: null,
        order: 0,
        classification_id: null,
        status: 1,
      };
      this.editingAlternatives = [];
    },

    editQuestion(q) {
      this.questionMode = "edit";
      this.editingQuestion = { ...q };
      this.editingAlternatives = (q.alternatives || []).map((a) => ({
        id: a.id,
        label: a.label,
        next_question_id: a.next_question_id,
        classification_id: a.classification_id || null,
        team_types: (a.team_types || []).map((tt) => ({ team_type_id: tt.id })),
      }));
      this.loadTeamTypes();
    },

    addAlternative() {
      this.editingAlternatives.push({
        label: "",
        next_question_id: null,
        classification_id: null,
        team_types: [],
      });
    },

    removeAlternative(index) {
      this.editingAlternatives.splice(index, 1);
    },

    saveAlternatives(questionId) {
      const { api } = this.$store.state;
      const altsToSave = this.editingAlternatives.filter((a) => a.label.trim());
      return axios
        .get(
          `${api}interrogatory_question_alternatives?paginated=false&interrogatory_question_id=${questionId}`
        )
        .then((r) => {
          const existing = r.data.data || [];
          return Promise.all(
            existing.map((a) =>
              axios.delete(`${api}interrogatory_question_alternatives/${a.id}`)
            )
          );
        })
        .then(() =>
          Promise.all(
            altsToSave.map((a, idx) =>
              axios.post(`${api}interrogatory_question_alternatives`, {
                interrogatory_question_id: questionId,
                label: a.label.trim(),
                next_question_id: a.next_question_id || null,
                classification_id: a.classification_id || null,
                order: idx,
              })
            )
          )
        )
        .then((responses) =>
          Promise.all(
            responses.map((r, idx) => {
              const altData = altsToSave[idx];
              const altId = r.data.data ? r.data.data.id : r.data.id || null;
              const types = (altData.team_types || []).filter(
                (tt) => tt.team_type_id
              );
              return this.syncAlternativeTeamTypes(altId, types);
            })
          )
        );
    },

    syncAlternativeTeamTypes(alternativeId, types) {
      if (!alternativeId) return Promise.resolve();
      const { api } = this.$store.state;
      return axios
        .post(
          `${api}interrogatory_question_alternatives/${alternativeId}/sync-team-types`,
          {
            team_types: types.map((tt, idx) => ({
              team_type_id: tt.team_type_id,
              order: idx,
            })),
          }
        )
        .catch(() => Promise.resolve());
    },

    saveQuestion() {
      if (!this.editingQuestion.question) {
        this.$message(
          this.$t('nodeDisciplineConfig.messages.warningTitle'),
          this.$t('nodeDisciplineConfig.messages.questionTextRequired'),
          "warning"
        );
        return;
      }
      if (
        this.editingQuestion.question_type === 4 &&
        this.editingAlternatives.filter((a) => a.label.trim()).length === 0
      ) {
        this.$message(
          this.$t('nodeDisciplineConfig.messages.warningTitle'),
          this.$t('nodeDisciplineConfig.messages.addAtLeastOneAlternative'),
          "warning"
        );
        return;
      }
      const payload = {
        ...this.editingQuestion,
        interrogatory_id: this.selectedInterrogatoryId,
      };
      let apiUrl = `${this.$store.state.api}interrogatory_questions`;
      if (payload.id) {
        payload._method = "PUT";
        apiUrl += `/${payload.id}`;
      }
      this.$loading(true);
      axios
        .post(apiUrl, payload)
        .then((r) => {
          const savedId = r.data.data
            ? r.data.data.id
            : r.data.id || payload.id;
          const saves = [];
          if (this.editingQuestion.question_type === 4) {
            saves.push(this.saveAlternatives(savedId));
          }
          return Promise.all(saves);
        })
        .then(() => {
          this.$message(this.$t('nodeDisciplineConfig.messages.successTitle'), this.$t('nodeDisciplineConfig.messages.questionSaved'), "success");
          this.cancelEditQuestion();
          this.loadQuestions(this.selectedInterrogatoryId);
        })
        .catch((e) => this.$message(null, e.response?.data, "error"))
        .finally(() => this.$loading(false));
    },

    deleteQuestion(q) {
      swal({
        title: this.$t('nodeDisciplineConfig.questions.deleteConfirmTitle'),
        text: this.$t('nodeDisciplineConfig.messages.actionCannotBeUndone'),
        icon: "warning",
        buttons: [this.$t('common.cancel'), this.$t('common.delete')],
        dangerMode: true,
      }).then((confirmed) => {
        if (!confirmed) return;
        this.$loading(true);
        axios
          .delete(`${this.$store.state.api}interrogatory_questions/${q.id}`)
          .then(() => {
            this.$message(this.$t('nodeDisciplineConfig.messages.successTitle'), this.$t('nodeDisciplineConfig.messages.questionDeleted'), "success");
            this.loadQuestions(this.selectedInterrogatoryId);
          })
          .catch((e) => this.$message(null, e.response?.data, "error"))
          .finally(() => this.$loading(false));
      });
    },

    questionNameById(qId) {
      const q = this.questions.find((q) => q.id === qId);
      return q
        ? q.question.substring(0, 40) + (q.question.length > 40 ? "..." : "")
        : this.$t('nodeDisciplineConfig.questions.endOption');
    },

    loadTeamTypes() {
      // Tipos de equipe são da central: carrega os do nó sendo configurado,
      // não os do nó operacional do usuário.
      axios
        .get(`${this.$store.state.api}team_types`, {
          params: { node_id: this.$route.params.nodeId, paginated: false },
        })
        .then((r) => {
          this.teamTypes = r.data.data || [];
        })
        .catch(() => {});

      // A disciplina é da equipe, não do tipo: o interrogatório só pode sugerir tipos que têm equipe dela.
      axios
        .get(`${this.$store.state.api}team_types`, {
          params: {
            node_id: this.$route.params.nodeId,
            discipline_id: this.$route.params.disciplineId,
            paginated: false,
          },
        })
        .then((r) => {
          this.disciplineTeamTypes = r.data.data || [];
        })
        .catch(() => {});
    },

    // Opções do select de tipo de equipe da alternativa: os da disciplina, mais o tipo já escolhido nesta linha
    // (cadastro antigo pode ter um tipo de fora; some da lista de escolha, mas não some do que foi salvo).
    alternativeTeamTypeOptions(row) {
      const chosen = row && row.team_type_id;
      if (!chosen || this.disciplineTeamTypes.some((t) => t.id === chosen)) {
        return this.disciplineTeamTypes;
      }
      const current = this.teamTypes.find((t) => t.id === chosen);

      return current ? [...this.disciplineTeamTypes, current] : this.disciplineTeamTypes;
    },

    onQuestionDragEnd() {
      const items = this.orderedQuestions.map((q, idx) => ({
        id: q.id,
        order: idx,
      }));
      axios
        .post(`${this.$store.state.api}interrogatory_questions/reorder`, {
          items,
        })
        .then(() => this.loadQuestions(this.selectedInterrogatoryId))
        .catch(() =>
          this.$message(this.$t('nodeDisciplineConfig.messages.errorTitle'), this.$t('nodeDisciplineConfig.messages.saveOrderFailed'), "error")
        );
    },

    onAssessmentQuestionDragEnd() {
      const items = this.orderedAssessmentQuestions.map((q, idx) => ({
        id: q.id,
        order: idx,
      }));
      axios
        .post(`${this.$store.state.api}initial_assessment_questions/reorder`, {
          items,
        })
        .then(() => this.loadAssessmentQuestions())
        .catch(() =>
          this.$message(this.$t('nodeDisciplineConfig.messages.errorTitle'), this.$t('nodeDisciplineConfig.messages.saveOrderFailed'), "error")
        );
    },

    onProblemDragEnd() {
      const items = this.orderedProblems.map((p, idx) => ({
        id: p.id,
        order: idx,
      }));
      axios
        .post(`${this.$store.state.api}problems/reorder`, { items })
        .then(() => this.loadProblems())
        .catch(() =>
          this.$message(this.$t('nodeDisciplineConfig.messages.errorTitle'), this.$t('nodeDisciplineConfig.messages.saveOrderFailed'), "error")
        );
    },

    loadPositions() {
      this.loadingPositions = true;
      const { disciplineId, nodeId } = this.$route.params;
      // O no ve o que e seu e o que herdou de cima (ancestrais). Nunca o que
      // os nos abaixo dele cadastraram.
      return axios
        .get(
          `${this.$store.state.api}team_position_types/for-node?discipline_id=${disciplineId}&node_id=${nodeId}&shown_in_occurrence=0`
        )
        .then((r) => {
          this.positions = r.data.data || [];
        })
        .finally(() => {
          this.loadingPositions = false;
        });
    },

    // ── posições ────────────────────────────────────────────────────────────

    origemDaPosicao(pos) {
      if (pos.origin) return pos.origin;

      return Number(pos.node_id) === Number(this.$route.params.nodeId)
        ? "own"
        : "inherited";
    },

    daPropriaNo(pos) {
      return this.origemDaPosicao(pos) === "own";
    },

    textoDaOrigem(pos) {
      return (
        {
          inherited: this.$t('nodeDisciplineConfig.origin.positionInherited'),
          descendant: this.$t('nodeDisciplineConfig.origin.positionDescendant'),
        }[this.origemDaPosicao(pos)] || this.$t('nodeDisciplineConfig.origin.positionOwn')
      );
    },

    // Versão genérica de origemDaPosicao/daPropriaNo/textoDaOrigem, usada por
    // Tipos e Motivos (mesmo padrão de herança de nó que Posições já usa).
    origemDoRegistro(item) {
      if (item.origin) return item.origin;

      return Number(item.node_id) === Number(this.$route.params.nodeId)
        ? "own"
        : "inherited";
    },

    ehDoProprioNo(item) {
      return this.origemDoRegistro(item) === "own";
    },

    textoDaOrigemRegistro(item) {
      return (
        {
          inherited: this.$t('nodeDisciplineConfig.origin.genericInherited'),
          descendant: this.$t('nodeDisciplineConfig.origin.genericDescendant'),
        }[this.origemDoRegistro(item)] || this.$t('nodeDisciplineConfig.origin.genericOwn')
      );
    },

    cancelEdit() {
      this.editingPosition = {
        code: "",
        name: "",
        description: "",
        order: 0,
        scope: "ocorrencia",
        free_access: false,
        display_kanban: false,
        allows_dispatch: true,
        is_default_position: false,
        releases_occurrence: false,
        marks_arrival: false,
        has_patient: false,
        allows_redirect: false,
        marks_base_arrival: false,
        allows_unboarding: true,
        display_panel: true,
        show_in_occurrence: true,
        panel_color: "#2563EB",
        status: 1,
      };
    },

    editPosition(pos) {
      this.editingPosition = { ...pos, panel_color: pos.panel_color || "#2563EB" };
    },

    savePosition() {
      const self = this;

      if (!this.editingPosition.code || !this.editingPosition.name) {
        this.$message(this.$t('nodeDisciplineConfig.messages.warningTitle'), this.$t('nodeDisciplineConfig.messages.codeAndNameRequired'), "warning");
        return;
      }

      const { disciplineId, nodeId } = this.$route.params;

      const payload = {
        ...this.editingPosition,
        discipline_id: Number(disciplineId),
        node_id: Number(nodeId),
      };

      let api = `${this.$store.state.api}team_position_types`;
      if (payload.id) {
        payload._method = "PUT";
        api += `/${payload.id}`;
      }

      this.$loading(true);
      axios
        .post(api, payload)
        .then(() => {
          this.$message(this.$t('nodeDisciplineConfig.messages.successTitle'), this.$t('nodeDisciplineConfig.messages.positionSaved'), "success");
          this.cancelEdit();
          this.loadPositions();
          this.$loading(false);
        })
        .catch((e) => {
          this.$loading(false);
          this.$message(null, e.response?.data, "error");
        });
    },

    deletePosition(pos) {
      swal({
        title: this.$t('nodeDisciplineConfig.positions.deleteConfirmTitle', { code: pos.code }),
        text: this.$t('nodeDisciplineConfig.positions.deleteConfirmText', { code: pos.code, name: pos.name }),
        icon: "warning",
        buttons: [this.$t('common.cancel'), this.$t('common.delete')],
        dangerMode: true,
      }).then((confirmed) => {
        if (!confirmed) return;
        this.$loading(true);
        axios
          .delete(`${this.$store.state.api}team_position_types/${pos.id}`)
          .then(() => {
            this.$message(this.$t('nodeDisciplineConfig.messages.successTitle'), this.$t('nodeDisciplineConfig.messages.positionDeleted'), "success");
            this.loadPositions();
            this.$loading(false);
          })
          .catch((e) => {
            this.$loading(false);
            this.$message(null, e.response?.data, "error");
          });
      });
    },

    // Liga/desliga uma flag da posição. A chave muda de lado na hora e volta atrás se o servidor
    // recusar (ex.: já existe outra posição com a mesma flag): sem isso a tela ficaria mostrando
    // ligado algo que não foi salvo, até alguém recarregar a página.
    togglePositionFlag(pos, field) {
      const previous = pos[field];
      pos[field] = !previous;
      this.$loading(true);
      axios
        .post(`${this.$store.state.api}team_position_types/${pos.id}`, {
          ...pos,
          [field]: !previous,
          _method: "PUT",
        })
        .catch((e) => {
          pos[field] = previous;
          this.$message(null, e.response?.data, "error");
        })
        .finally(() => this.$loading(false));
    },

    toggleFreeAccess(pos) {
      this.togglePositionFlag(pos, "free_access");
    },

    toggleAllowsDispatch(pos) {
      this.togglePositionFlag(pos, "allows_dispatch");
    },

    toggleReleasesOccurrence(pos) {
      this.togglePositionFlag(pos, "releases_occurrence");
    },

    toggleMarksArrival(pos) {
      this.togglePositionFlag(pos, "marks_arrival");
    },

    toggleHasPatient(pos) {
      this.togglePositionFlag(pos, "has_patient");
    },

    toggleAllowsRedirect(pos) {
      this.togglePositionFlag(pos, "allows_redirect");
    },

    toggleAllowsUnboarding(pos) {
      this.togglePositionFlag(pos, "allows_unboarding");
    },

    toggleMarksBaseArrival(pos) {
      this.togglePositionFlag(pos, "marks_base_arrival");
    },

    toggleShowInOccurrence(pos) {
      this.togglePositionFlag(pos, "show_in_occurrence");
    },

    toggleDisplayPanel(pos) {
      this.togglePositionFlag(pos, "display_panel");
    },

    // ── predecessores ───────────────────────────────────────────────────────

    openPredecessors(pos) {
      this.configuring = pos;
      this.selectedPredecessorIds = (pos.predecessors || []).map((p) => p.id);
      this.availablePredecessors = this.positions
        .filter((p) => p.id !== pos.id)
        .map((p) => ({ ...p, label: `${p.code} — ${p.name}` }));
      this.$bvModal.show("modal-predecessors");
    },

    savePredecessors() {
      this.$loading(true);
      axios
        .post(
          `${this.$store.state.api}team_position_types/${this.configuring.id}/predecessors`,
          { predecessor_ids: this.selectedPredecessorIds }
        )
        .then(() => {
          this.$message(this.$t('nodeDisciplineConfig.messages.successTitle'), this.$t('nodeDisciplineConfig.messages.successionRulesSaved'), "success");
          this.loadPositions();
          this.$loading(false);
        })
        .catch((e) => {
          this.$loading(false);
          this.$message(null, e.response?.data, "error");
        });
    },

    // ── fluxo de ocorrência ─────────────────────────────────────────────────

    loadFlowSteps() {
      const { disciplineId } = this.$route.params;
      axios
        .get(
          `${this.$store.state.api}discipline_flow_steps?discipline_id=${disciplineId}`
        )
        .then((r) => {
          this.flowSteps = r.data.data || [];
        })
        .catch(() => {});
    },

    toggleFlowStep(step) {
      axios
        .patch(
          `${this.$store.state.api}discipline_flow_steps/${step.id}/toggle`
        )
        .then((r) => {
          this.$set(step, "status", r.data.data.status);
        })
        .catch(() =>
          this.$message(this.$t('nodeDisciplineConfig.messages.errorTitle'), this.$t('nodeDisciplineConfig.messages.statusChangeFailed'), "error")
        );
    },

    openSkipModal(step) {
      const skips = step.skip_conditions || [];
      this.skipModal.step = step;
      this.skipModal.selectedTypeIds = skips
        .filter((s) => s.dispatch_type_id)
        .map((s) => s.dispatch_type_id);
      this.skipModal.selectedReasonIds = skips
        .filter((s) => s.dispatch_reason_id)
        .map((s) => s.dispatch_reason_id);
      this.$bvModal.show("modal-step-skips");
    },

    saveSkips() {
      const { step } = this.skipModal;
      if (!step) return;
      axios
        .post(
          `${this.$store.state.api}discipline_flow_steps/${step.id}/skips`,
          {
            dispatch_type_ids: this.skipModal.selectedTypeIds,
            dispatch_reason_ids: this.skipModal.selectedReasonIds,
          }
        )
        .then((r) => {
          this.$set(step, "skip_conditions", r.data.data.skip_conditions || []);
          this.$message(this.$t('nodeDisciplineConfig.messages.successTitle'), this.$t('nodeDisciplineConfig.messages.skipConditionsSaved'), "success");
        })
        .catch(() =>
          this.$message(this.$t('nodeDisciplineConfig.messages.errorTitle'), this.$t('nodeDisciplineConfig.messages.saveFailedGeneric'), "error")
        );
    },

    // ── intercorrências ─────────────────────────────────────────────────────

    loadIntercurrences() {
      const { nodeId, disciplineId } = this.$route.params;
      this.loadingIntercurrences = true;
      return axios
        .get(
          `${this.$store.state.api}intercurrences?paginated=false&node_id=${nodeId}&discipline_id=${disciplineId}`
        )
        .then((r) => {
          this.intercurrences = r.data.data || [];
        })
        .finally(() => {
          this.loadingIntercurrences = false;
        });
    },

    cancelEditIntercurrence() {
      this.editingIntercurrence = {
        name: "",
        description: "",
        is_active: true,
      };
    },

    editIntercurrence(item) {
      this.editingIntercurrence = { ...item };
    },

    saveIntercurrence() {
      if (!this.editingIntercurrence.name) {
        this.$message(this.$t('nodeDisciplineConfig.messages.warningTitle'), this.$t('nodeDisciplineConfig.messages.nameRequired'), "warning");
        return;
      }
      const { nodeId, disciplineId } = this.$route.params;
      const payload = {
        ...this.editingIntercurrence,
        node_id: Number(nodeId),
        discipline_id: Number(disciplineId),
        description: this.editingIntercurrence.description || null,
      };
      let api = `${this.$store.state.api}intercurrences`;
      if (payload.id) {
        payload._method = "PUT";
        api += `/${payload.id}`;
      }
      this.$loading(true);
      axios
        .post(api, payload)
        .then(() => {
          this.$message(
            this.$t('nodeDisciplineConfig.messages.successTitle'),
            this.$t('nodeDisciplineConfig.messages.intercurrenceSaved'),
            "success"
          );
          this.cancelEditIntercurrence();
          this.loadIntercurrences();
        })
        .catch((e) => this.$message(null, e.response?.data, "error"))
        .finally(() => this.$loading(false));
    },

    deleteIntercurrence(item) {
      swal({
        title: this.$t('nodeDisciplineConfig.messages.deleteConfirmTitle', { name: item.name }),
        text: this.$t('nodeDisciplineConfig.messages.actionCannotBeUndone'),
        icon: "warning",
        buttons: [this.$t('common.cancel'), this.$t('common.delete')],
        dangerMode: true,
      }).then((confirmed) => {
        if (!confirmed) return;
        this.$loading(true);
        axios
          .delete(`${this.$store.state.api}intercurrences/${item.id}`)
          .then(() => {
            this.$message(this.$t('nodeDisciplineConfig.messages.successTitle'), this.$t('nodeDisciplineConfig.messages.intercurrenceDeleted'), "success");
            this.loadIntercurrences();
          })
          .catch((e) => this.$message(null, e.response?.data, "error"))
          .finally(() => this.$loading(false));
      });
    },

    // ── Decisões Técnicas ──

    loadTechnicalDecisions() {
      const { nodeId, disciplineId } = this.$route.params;
      this.loadingTechnicalDecisions = true;
      axios
        .get(
          `${this.$store.state.api}technical_decisions?paginated=false&discipline_id=${disciplineId}`
        )
        .then((r) => {
          this.technicalDecisions = r.data.data || [];
        })
        .finally(() => {
          this.loadingTechnicalDecisions = false;
        });
    },

    cancelEditTechnicalDecision() {
      this.editingTechnicalDecision = { name: "", status: 1 };
    },

    editTechnicalDecision(item) {
      this.editingTechnicalDecision = { ...item };
    },

    saveTechnicalDecision() {
      if (!this.editingTechnicalDecision.name) {
        this.$message(this.$t('nodeDisciplineConfig.messages.warningTitle'), this.$t('nodeDisciplineConfig.messages.nameRequired'), "warning");
        return;
      }
      const { disciplineId } = this.$route.params;
      const payload = {
        ...this.editingTechnicalDecision,
        discipline_id: Number(disciplineId),
      };
      let api = `${this.$store.state.api}technical_decisions`;
      if (payload.id) {
        payload._method = "PUT";
        api += `/${payload.id}`;
      }
      this.$loading(true);
      axios
        .post(api, payload)
        .then(() => {
          this.$message(
            this.$t('nodeDisciplineConfig.messages.successTitle'),
            this.$t('nodeDisciplineConfig.messages.technicalDecisionSaved'),
            "success"
          );
          this.cancelEditTechnicalDecision();
          this.loadTechnicalDecisions();
        })
        .catch((e) => this.$message(null, e.response?.data, "error"))
        .finally(() => this.$loading(false));
    },

    toggleTechnicalDecisionStatus(item) {
      const newStatus = item.status ? 0 : 1;
      this.$loading(true);
      axios
        .post(`${this.$store.state.api}technical_decisions/${item.id}`, {
          status: newStatus,
          _method: "PUT",
        })
        .then(() => {
          this.$message(this.$t('nodeDisciplineConfig.messages.successTitle'), this.$t('nodeDisciplineConfig.messages.statusUpdated'), "success");
          this.loadTechnicalDecisions();
        })
        .catch((e) => this.$message(null, e.response?.data, "error"))
        .finally(() => this.$loading(false));
    },

    deleteTechnicalDecision(item) {
      swal({
        title: this.$t('nodeDisciplineConfig.messages.deleteConfirmTitle', { name: item.name }),
        text: this.$t('nodeDisciplineConfig.messages.actionCannotBeUndone'),
        icon: "warning",
        buttons: [this.$t('common.cancel'), this.$t('common.delete')],
        dangerMode: true,
      }).then((confirmed) => {
        if (!confirmed) return;
        this.$loading(true);
        axios
          .delete(`${this.$store.state.api}technical_decisions/${item.id}`)
          .then(() => {
            this.$message(this.$t('nodeDisciplineConfig.messages.successTitle'), this.$t('nodeDisciplineConfig.messages.technicalDecisionDeleted'), "success");
            this.loadTechnicalDecisions();
          })
          .catch((e) => this.$message(null, e.response?.data, "error"))
          .finally(() => this.$loading(false));
      });
    },

    // ── Avaliação Inicial ────────────────────────────────────────────────────

    typeLabel(type) {
      return (
        {
          single_select: this.$t('nodeDisciplineConfig.assessmentQuestions.typeSingleSelect'),
          multiple_select: this.$t('nodeDisciplineConfig.assessmentQuestions.typeMultipleSelect'),
          text: this.$t('nodeDisciplineConfig.assessmentQuestions.typeFreeText'),
        }[type] || type
      );
    },

    typeVariant(type) {
      return (
        {
          single_select: "light-primary",
          multiple_select: "light-info",
          text: "light-secondary",
        }[type] || "secondary"
      );
    },

    loadAssessmentQuestions() {
      const { nodeId, disciplineId } = this.$route.params;
      this.loadingAssessmentQuestions = true;
      return axios
        .get(
          `${this.$store.state.api}initial_assessment_questions?paginated=false&node_id=${nodeId}&discipline_id=${disciplineId}`
        )
        .then((r) => {
          this.assessmentQuestions = r.data.data || [];
        })
        .finally(() => {
          this.loadingAssessmentQuestions = false;
        });
    },

    cancelEditAssessmentQuestion() {
      this.editingAssessmentQuestion = {
        label: "",
        type: "single_select",
        order: 0,
        is_active: true,
      };
      this.editingAssessmentQuestionOptions = [];
      this.inlineOptionInput = "";
    },

    beginEditAssessmentQuestion(item) {
      this.editingAssessmentQuestion = { ...item };
      this.editingAssessmentQuestionOptions = (item.options || []).map((o) => ({
        ...o,
      }));
      this.inlineOptionInput = "";
    },

    addInlineOption() {
      const label = this.inlineOptionInput.trim();
      if (!label) return;
      const q = this.editingAssessmentQuestion;
      if (q.id) {
        // Pergunta já salva: persiste imediatamente
        this.$loading(true);
        axios
          .post(
            `${this.$store.state.api}initial_assessment_questions/${q.id}/options`,
            {
              label,
              order: this.editingAssessmentQuestionOptions.length,
            }
          )
          .then((r) => {
            this.editingAssessmentQuestionOptions.push(r.data.data);
            this.inlineOptionInput = "";
          })
          .catch((e) => this.$message(null, e.response?.data, "error"))
          .finally(() => this.$loading(false));
      } else {
        // Pergunta nova: guarda localmente até salvar
        this.editingAssessmentQuestionOptions.push({ label, _new: true });
        this.inlineOptionInput = "";
      }
    },

    removeInlineOption(opt, idx) {
      if (opt.id) {
        const q = this.editingAssessmentQuestion;
        this.$loading(true);
        axios
          .delete(
            `${this.$store.state.api}initial_assessment_questions/${q.id}/options/${opt.id}`
          )
          .then(() => {
            this.editingAssessmentQuestionOptions.splice(idx, 1);
          })
          .catch((e) => this.$message(null, e.response?.data, "error"))
          .finally(() => this.$loading(false));
      } else {
        this.editingAssessmentQuestionOptions.splice(idx, 1);
      }
    },

    saveAssessmentQuestion() {
      if (!this.editingAssessmentQuestion.label) {
        this.$message(this.$t('nodeDisciplineConfig.messages.warningTitle'), this.$t('nodeDisciplineConfig.messages.labelRequired'), "warning");
        return;
      }
      if (!this.editingAssessmentQuestion.type) {
        this.$message(this.$t('nodeDisciplineConfig.messages.warningTitle'), this.$t('nodeDisciplineConfig.messages.typeRequired'), "warning");
        return;
      }
      const isSelect = ["single_select", "multiple_select"].includes(
        this.editingAssessmentQuestion.type
      );
      if (
        isSelect &&
        !this.editingAssessmentQuestion.id &&
        !this.editingAssessmentQuestionOptions.length
      ) {
        this.$message(
          this.$t('nodeDisciplineConfig.messages.warningTitle'),
          this.$t('nodeDisciplineConfig.messages.atLeastOneOptionRequired'),
          "warning"
        );
        return;
      }
      const { nodeId, disciplineId } = this.$route.params;
      const payload = {
        ...this.editingAssessmentQuestion,
        node_id: Number(nodeId),
        discipline_id: Number(disciplineId),
        order: this.editingAssessmentQuestion.order ?? 0,
      };
      let api = `${this.$store.state.api}initial_assessment_questions`;
      const isEdit = !!payload.id;
      if (isEdit) {
        payload._method = "PUT";
        api += `/${payload.id}`;
      }
      this.$loading(true);
      axios
        .post(api, payload)
        .then((r) => {
          const savedId = isEdit ? payload.id : r.data.data?.id || r.data.id;
          // Salva as opções pendentes (novas, ainda sem ID)
          const pending = this.editingAssessmentQuestionOptions.filter(
            (o) => !o.id
          );
          return Promise.all(
            pending.map((o, idx) =>
              axios.post(
                `${this.$store.state.api}initial_assessment_questions/${savedId}/options`,
                {
                  label: o.label,
                  order:
                    this.editingAssessmentQuestionOptions.filter((x) => x.id)
                      .length + idx,
                }
              )
            )
          );
        })
        .then(() => {
          this.$message(this.$t('nodeDisciplineConfig.messages.successTitle'), this.$t('nodeDisciplineConfig.messages.questionSaved'), "success");
          this.cancelEditAssessmentQuestion();
          this.loadAssessmentQuestions();
        })
        .catch((e) => this.$message(null, e.response?.data, "error"))
        .finally(() => this.$loading(false));
    },

    deleteAssessmentQuestion(item) {
      swal({
        title: this.$t('nodeDisciplineConfig.messages.deleteConfirmTitle', { name: item.label }),
        text: this.$t('nodeDisciplineConfig.messages.optionsRelatedWillBeRemoved'),
        icon: "warning",
        buttons: [this.$t('common.cancel'), this.$t('common.delete')],
        dangerMode: true,
      }).then((confirmed) => {
        if (!confirmed) return;
        this.$loading(true);
        axios
          .delete(
            `${this.$store.state.api}initial_assessment_questions/${item.id}`
          )
          .then(() => {
            this.$message(this.$t('nodeDisciplineConfig.messages.successTitle'), this.$t('nodeDisciplineConfig.messages.questionDeleted'), "success");
            this.loadAssessmentQuestions();
          })
          .catch((e) => this.$message(null, e.response?.data, "error"))
          .finally(() => this.$loading(false));
      });
    },

    // ── Problemas ─────────────────────────────────────────────────────────────

    loadProblems() {
      const { nodeId, disciplineId } = this.$route.params;
      this.loadingProblems = true;
      return axios
        .get(
          `${this.$store.state.api}problems?paginated=false&node_id=${nodeId}&discipline_id=${disciplineId}`
        )
        .then((r) => {
          this.problems = r.data.data || [];
        })
        .finally(() => {
          this.loadingProblems = false;
        });
    },

    cancelEditProblem() {
      this.editingProblem = { label: "", order: 0, is_active: true };
    },

    beginEditProblem(item) {
      this.editingProblem = { ...item };
    },

    saveProblem() {
      if (!this.editingProblem.label) {
        this.$message(this.$t('nodeDisciplineConfig.messages.warningTitle'), this.$t('nodeDisciplineConfig.messages.problemRequired'), "warning");
        return;
      }
      const { nodeId, disciplineId } = this.$route.params;
      const payload = {
        ...this.editingProblem,
        node_id: Number(nodeId),
        discipline_id: Number(disciplineId),
        order: this.editingProblem.order ?? 0,
      };
      let api = `${this.$store.state.api}problems`;
      if (payload.id) {
        payload._method = "PUT";
        api += `/${payload.id}`;
      }
      this.$loading(true);
      axios
        .post(api, payload)
        .then(() => {
          this.$message(this.$t('nodeDisciplineConfig.messages.successTitle'), this.$t('nodeDisciplineConfig.messages.problemSaved'), "success");
          this.cancelEditProblem();
          this.loadProblems();
        })
        .catch((e) => this.$message(null, e.response?.data, "error"))
        .finally(() => this.$loading(false));
    },

    deleteProblem(item) {
      swal({
        title: this.$t('nodeDisciplineConfig.messages.deleteConfirmTitle', { name: item.label }),
        text: this.$t('nodeDisciplineConfig.messages.actionCannotBeUndone'),
        icon: "warning",
        buttons: [this.$t('common.cancel'), this.$t('common.delete')],
        dangerMode: true,
      }).then((confirmed) => {
        if (!confirmed) return;
        this.$loading(true);
        axios
          .delete(`${this.$store.state.api}problems/${item.id}`)
          .then(() => {
            this.$message(this.$t('nodeDisciplineConfig.messages.successTitle'), this.$t('nodeDisciplineConfig.messages.problemDeleted'), "success");
            this.loadProblems();
          })
          .catch((e) => this.$message(null, e.response?.data, "error"))
          .finally(() => this.$loading(false));
      });
    },

    skipSummary(step) {
      const skips = step.skip_conditions || [];
      const types = skips
        .filter((s) => s.dispatch_type_id)
        .map((s) => {
          const t = this.dispatchTypes.find((x) => x.id === s.dispatch_type_id);
          return t
            ? t.name
            : this.$t('nodeDisciplineConfig.flow.typeFallback', { id: s.dispatch_type_id });
        });
      const reasons = skips
        .filter((s) => s.dispatch_reason_id)
        .map((s) => {
          const r = this.dispatchReasons.find(
            (x) => x.id === s.dispatch_reason_id
          );
          return r
            ? r.name
            : this.$t('nodeDisciplineConfig.flow.reasonFallback', { id: s.dispatch_reason_id });
        });
      return [...types, ...reasons].join(", ");
    },

    // ── Formulários — Seção A: definições ───────────────────────────────────

    loadFormDefinitions() {
      this.loadingFormDefinitions = true;
      return axios
        .get(`${this.$store.state.api}form_definitions?paginated=false`)
        .then((r) => {
          this.formDefinitions = r.data.data || [];
        })
        .finally(() => {
          this.loadingFormDefinitions = false;
        });
    },

    onFormDefinitionDragEnd() {
      const items = this.orderedFormDefinitions.map((item, idx) => ({
        id: item.id,
        order: idx,
      }));
      axios
        .post(`${this.$store.state.api}form_definitions/reorder`, { items })
        .then(() => this.loadFormDefinitions())
        .catch(() =>
          this.$message(this.$t('nodeDisciplineConfig.messages.errorTitle'), this.$t('nodeDisciplineConfig.messages.saveOrderFailed'), "error")
        );
    },

    cancelEditFormDefinition() {
      this.editingFormDefinition = { name: "", description: "", status: true };
    },

    editFormDefinition(item) {
      this.editingFormDefinition = { ...item };
    },

    saveFormDefinition() {
      if (!this.editingFormDefinition.name) {
        this.$message(this.$t('nodeDisciplineConfig.messages.warningTitle'), this.$t('nodeDisciplineConfig.messages.nameRequired'), "warning");
        return;
      }
      const payload = { ...this.editingFormDefinition };
      let api = `${this.$store.state.api}form_definitions`;
      if (payload.id) {
        payload._method = "PUT";
        api += `/${payload.id}`;
      }
      this.$loading(true);
      axios
        .post(api, payload)
        .then(() => {
          this.$message(this.$t('nodeDisciplineConfig.messages.successTitle'), this.$t('nodeDisciplineConfig.messages.formSaved'), "success");
          this.cancelEditFormDefinition();
          this.loadFormDefinitions();
        })
        .catch((e) => this.$message(null, e.response?.data, "error"))
        .finally(() => this.$loading(false));
    },

    deleteFormDefinition(item) {
      swal({
        title: this.$t('nodeDisciplineConfig.messages.deleteConfirmTitle', { name: item.name }),
        text: this.$t('nodeDisciplineConfig.messages.formFieldsWillBeRemoved'),
        icon: "warning",
        buttons: [this.$t('common.cancel'), this.$t('common.delete')],
        dangerMode: true,
      }).then((confirmed) => {
        if (!confirmed) return;
        this.$loading(true);
        axios
          .delete(`${this.$store.state.api}form_definitions/${item.id}`)
          .then(() => {
            this.$message(this.$t('nodeDisciplineConfig.messages.successTitle'), this.$t('nodeDisciplineConfig.messages.formDeleted'), "success");
            if (
              this.selectedFormDefinition &&
              this.selectedFormDefinition.id === item.id
            ) {
              this.selectedFormDefinition = null;
              this.formAssignments = [];
            }
            this.loadFormDefinitions();
          })
          .catch((e) => this.$message(null, e.response?.data, "error"))
          .finally(() => this.$loading(false));
      });
    },

    goToFormBuilder(item) {
      this.$router.push({
        name: "FormBuilder",
        params: { ...this.$route.params, formDefinitionId: item.id },
      });
    },

    // Mostra as Associações (Seção C) do formulário selecionado — a edição
    // de campos/lógica agora vive na tela dedicada do Form Builder.
    selectFormDefinition(item) {
      this.selectedFormDefinition = item;
      this.cancelEditFormAssignment();
      this.loadFormAssignments(item.id);
      // Catálogos dos pickers de associação — carregados sob demanda (apenas 1x).
      if (!this.allDisciplines.length) this.loadAllDisciplines();
      if (!this.involvedRolesAll.length) this.loadInvolvedRolesAll();
      if (!this.userRolesAll.length) this.loadUserRolesAll();
    },

    // ── Formulários — Seção C: associações ──────────────────────────────────

    loadFormAssignments(formDefinitionId) {
      this.loadingFormAssignments = true;
      return axios
        .get(
          `${this.$store.state.api}form_assignments?form_definition_id=${formDefinitionId}`
        )
        .then((r) => {
          this.formAssignments = r.data.data || [];
        })
        .finally(() => {
          this.loadingFormAssignments = false;
        });
    },

    loadAllDisciplines() {
      return axios
        .get(`${this.$store.state.api}discipline?paginated=false&status=1`)
        .then((r) => {
          this.allDisciplines = r.data.data || [];
        })
        .catch(() => {});
    },

    loadInvolvedRolesAll() {
      return axios
        .get(`${this.$store.state.api}involved_roles`)
        .then((r) => {
          this.involvedRolesAll = r.data.data || [];
        })
        .catch(() => {});
    },

    loadUserRolesAll() {
      return axios
        .get(`${this.$store.state.api}roles?paginated=false&status=1`)
        .then((r) => {
          this.userRolesAll = r.data.data || [];
        })
        .catch(() => {});
    },

    cancelEditFormAssignment() {
      this.editingFormAssignment = {
        discipline_id: null,
        involved_role_id: null,
        user_role_id: null,
        context: "all",
        status: 1,
      };
    },

    saveFormAssignment() {
      const payload = {
        ...this.editingFormAssignment,
        form_definition_id: this.selectedFormDefinition.id,
      };
      this.$loading(true);
      axios
        .post(`${this.$store.state.api}form_assignments`, payload)
        .then(() => {
          this.$message(this.$t('nodeDisciplineConfig.messages.successTitle'), this.$t('nodeDisciplineConfig.messages.assignmentCreated'), "success");
          this.cancelEditFormAssignment();
          this.loadFormAssignments(this.selectedFormDefinition.id);
        })
        .catch((e) => this.$message(null, e.response?.data, "error"))
        .finally(() => this.$loading(false));
    },

    deleteFormAssignment(item) {
      swal({
        title: this.$t('nodeDisciplineConfig.forms.deleteAssignmentConfirmTitle'),
        text: this.$t('nodeDisciplineConfig.messages.actionCannotBeUndone'),
        icon: "warning",
        buttons: [this.$t('common.cancel'), this.$t('common.delete')],
        dangerMode: true,
      }).then((confirmed) => {
        if (!confirmed) return;
        this.$loading(true);
        axios
          .delete(`${this.$store.state.api}form_assignments/${item.id}`)
          .then(() => {
            this.$message(this.$t('nodeDisciplineConfig.messages.successTitle'), this.$t('nodeDisciplineConfig.messages.assignmentDeleted'), "success");
            this.loadFormAssignments(this.selectedFormDefinition.id);
          })
          .catch((e) => this.$message(null, e.response?.data, "error"))
          .finally(() => this.$loading(false));
      });
    },

    disciplineNameById(id) {
      if (!id) return this.$t('nodeDisciplineConfig.forms.allOption');
      const d = this.allDisciplines.find((x) => x.id === id);
      return d ? d.name : `#${id}`;
    },

    involvedRoleLabelById(id) {
      if (!id) return this.$t('nodeDisciplineConfig.forms.allOption');
      const r = this.involvedRolesAll.find((x) => x.id === id);
      return r ? r.label : `#${id}`;
    },

    userRoleNameById(id) {
      if (!id) return this.$t('nodeDisciplineConfig.forms.allOption');
      const r = this.userRolesAll.find((x) => x.id === id);
      return r ? r.name : `#${id}`;
    },

    contextLabel(ctx) {
      const map = { web: "Web", app: "App", all: this.$t('nodeDisciplineConfig.forms.allOption') };
      return map[ctx] || ctx;
    },
  },
};
</script>

<style scoped>
.card-body.p-0 {
  overflow-x: auto;
}

::v-deep .dc-tabs-nav {
  flex-wrap: wrap;
  row-gap: 2px;
}
::v-deep .dc-tabs-nav .nav-link {
  padding-left: 0.7rem;
  padding-right: 0.7rem;
  white-space: nowrap;
}

.dc-other-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
  align-items: stretch;
}

/* Colunas de mesma altura: o card preenche a coluna e a ação principal fica sempre no rodapé. */
.dc-other-grid > div {
  display: flex;
  flex-direction: column;
}

.dc-other-grid > div > .card {
  flex: 1;
  margin-bottom: 0;
}

.dc-other-grid > div > .card > .card-body {
  display: flex;
  flex-direction: column;
}

.dc-other-grid .dc-card-fill {
  display: flex;
  flex: 1;
  flex-direction: column;
}

.dc-other-grid .dc-card-action {
  margin-top: auto;
  align-self: flex-start;
}

.dc-section-title {
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #5e5873;
}
.dark-layout .dc-section-title {
  color: #b4b7bd;
}

.required {
  color: red;
}
.drag-handle {
  cursor: grab;
}
.drag-handle:active {
  cursor: grabbing;
}
.drag-ghost td {
  background: #f0f4ff !important;
  opacity: 0.7;
}
.pin-empty-preview {
  width: 48px;
  height: 48px;
  border: 2px dashed #ccc;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  color: #999;
  text-align: center;
}

/* ── Fluxo de Ocorrência ── */
.flow-step-fixed {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  font-size: 0.88rem;
}
.flow-step-fixed--end {
  background: #f0faf4;
  border-color: #b8e6cc;
}
.flow-step-arrow {
  text-align: center;
  color: #adb5bd;
  font-size: 1.1rem;
  line-height: 1.6;
  user-select: none;
}
.flow-step-row {
  display: flex;
  align-items: center;
  padding: 7px 10px;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  margin-bottom: 0;
  gap: 4px;
}
.flow-step-inactive {
  opacity: 0.55;
}

/* ── Modal "Códigos de envio" ────────────────────────────────────── */
.dc-modal-body {
  padding: 20px 24px;
}

.dc-form-row {
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 12px;
}
.dc-form-row__field {
  flex: 1 1 220px;
  min-width: 180px;
}
.dc-form-row__field--status {
  flex: 0 1 140px;
  min-width: 120px;
}
.dc-form-row__label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #6e6b7b;
  margin-bottom: 4px;
}
.dc-form-row__actions {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
}

.dc-code-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 340px;
  overflow-y: auto;
  padding-right: 2px;
}

.dc-code-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  border: 1px solid #ebe9f1;
  border-radius: 8px;
  background: #fafafa;
  transition: background 0.15s, border-color 0.15s;
}
.dc-code-item:hover {
  background: #f4f3ff;
  border-color: #d8d5f5;
}
.dc-code-item--editing {
  border-color: #7367f0;
  background: #f4f3ff;
}

.dc-code-item__dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}
.dc-code-item__dot--active {
  background: #28c76f;
}
.dc-code-item__dot--inactive {
  background: #b9b9c3;
}

.dc-code-item__code {
  flex: 1;
  min-width: 0;
  font-size: 13.5px;
  font-weight: 600;
  color: #5e5873;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dc-code-item__badge {
  flex-shrink: 0;
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 0.02em;
  padding: 2px 9px;
  border-radius: 9px;
}
.dc-code-item__badge--active {
  background: #e6f9ef;
  color: #28c76f;
}
.dc-code-item__badge--inactive {
  background: #f1f2f4;
  color: #82868b;
}

.dc-code-item__actions {
  display: flex;
  gap: 4px;
  flex-shrink: 0;
}
.dc-code-item__btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: 1px solid #ebe9f1;
  border-radius: 6px;
  background: #fff;
  color: #7367f0;
  cursor: pointer;
  transition: background 0.15s;
}
.dc-code-item__btn:hover {
  background: #f4f3ff;
}
.dc-code-item__btn--danger {
  color: #ea5455;
}
.dc-code-item__btn--danger:hover {
  background: #fdeaea;
}

.dark-layout .dc-form-row__label {
  color: #9095a3;
}
.dark-layout .dc-code-item {
  background: #1c2333;
  border-color: #3b4253;
}
.dark-layout .dc-code-item:hover {
  background: #232a45;
  border-color: #454d68;
}
.dark-layout .dc-code-item--editing {
  background: #232a45;
  border-color: #7367f0;
}
.dark-layout .dc-code-item__code {
  color: #d0d2d6;
}
.dark-layout .dc-code-item__badge--inactive {
  background: #2a3042;
  color: #9095a3;
}
.dark-layout .dc-code-item__btn {
  background: #283046;
  border-color: #3b4253;
}
.dark-layout .dc-code-item__btn:hover {
  background: #2b2a4e;
}

.panel-color-picker {
  display: flex;
  align-items: center;
  gap: 10px;
}
.panel-color-swatch {
  position: relative;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
  cursor: pointer;
  flex-shrink: 0;
  margin-bottom: 0;
}
.panel-color-chip {
  display: inline-block;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  flex-shrink: 0;
  box-shadow: 0 0 0 2px #fff, 0 0 0 3px rgba(0, 0, 0, 0.12);
}
.dark-layout .panel-color-chip {
  box-shadow: 0 0 0 2px #283046, 0 0 0 3px rgba(255, 255, 255, 0.12);
}
.panel-color-swatch input[type="color"] {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}
</style>
